import Radio from "@mui/material/Radio";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { auto } from "@popperjs/core";
import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { parseGooglePlace } from "../../utils/helpers/addressHelper";
import { EditorState, convertToRaw, RichUtils } from "draft-js";
import {
  AiFillPlusCircle,
  AiOutlineCloseCircle,
  AiOutlinePlus,
} from "react-icons/ai";
import { BsChevronDown, BsX } from "react-icons/bs";
import { RiDeleteBinLine } from "react-icons/ri";
import PhoneInput from "react-phone-input-2";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { default as style, default as styled } from "styled-components";
import Addiocn from "../../assets/icons/Addicon (2).svg";
import Binclr from "../../assets/icons/Bin - Copy.svg";
import Calendericon from "../../assets/icons/Calendar with interaction.svg";
import plusIcon from "../../assets/icons/Plus.svg";
import actinfoblack from "../../assets/icons/Document-3.svg";
import searchicon from "../../assets/icons/search.svg";
import calendar from "../../assets/icons/calendar.svg";
import actinfo from "../../assets/icons/Document-321 - Copy.svg";
import actfilter from "../../assets/icons/Filter contacts.svg";
import projecticons from "../../assets/icons/Group 2949.svg";
import docicons from "../../assets/icons/Group 4419.svg";
import contacticons from "../../assets/icons/Group 3321.svg";
import Xicon from "../../assets/icons/Xicon.svg";
import XiconCircle from "../../assets/icons/x-circle.svg";
import DownArrowOption from "../../assets/icons/DownArrowOption.svg";
import Taskicon from "../../assets/icons/Group 2951.svg";
import Minusicon from "../../assets/icons/Minus icon.svg";
import Plusicon from "../../assets/icons/Plus.svg";
import actclip from "../../assets/icons/clipboard.svg";
import actfold from "../../assets/icons/folder.svg";
import image2 from "../../assets/icons/Group 3323.svg";
import image3 from "../../assets/icons/Group 3324.svg";
import foldblue from "../../assets/icons/folderblue.svg";
import taskIcon from "../../assets/icons/taskIcon.svg";
import plusCircle from "../../assets/icons/plusCircle.svg";
import deleteIcon from "../../assets/icons/DeleteIcon.svg";
import AppDatePicker from "../../components/Common/AppDatePicker";
import DeletePopUp from "../../components/Dailogs/DeletePopUp";
import TasDelete from "../../components/Dailogs/TaskDelete";
import DocumentUploaderWithProgress from "../../components/Common/Document_Uploader_With_Progress";
import Header from "../../layouts/Header";
import Pagination from "../../components/Pagination/Pagination";
import StockAssigneeModal from "./StockAssigneeModal";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";
import {
  AddComments,
  AddCompanyContact,
  AddContact,
  AddDocToUserContacts,
  AddTagsContact,
  DeleteTags,
  EmptyProductPart,
  FetchAddTagsContact,
  FetchContactById,
  FetchDocsContactById,
  FetchManagersList,
  FetchSearchClients,
  RemoveDocsClientById,
  UpdateContacts,
  deleteTask,
  fetchTaskByContactId,
  updateTaskStatus2,
  GlobalRequest,

  // company start 👇
  AddNewClient,
  UpdateClient,
  UpdateClientDetails,
  ClientAddressCheck,
  FetchClientById,
  DeleteMultipleAddress,
  FetchClientContactsByclientId,
  DeleteClientcontact,
  AddDocToClients,
  FetchDocsClientById,
  DeleteDocs,
  FetchClientTasks,
  ClientActivityTimeline,
  GetCreditTypeForDropdown,
  GetInvoiceTypeForDropdown,
  GetDiscountTypeForDropdown,
  FetchPaymentDeadline,
  ProjectDropdown,
  FetchProjectClient,
  FetchActiveUser,
  ClientNameExistOrNot,
} from "../../redux/actions/action";
import { axiosInstance as axios } from "../../redux/constants/axiosInstance";
import {
  API_URL,
  CHAT_API_URL,
  UPDATE_CONTACTS,
  ADD_NEW_CLIENT,
  UPDATE_CLIENT_DETAILS,
  FETCH_CLIENT_BY_ID,
  EXISTING_COMPANY_ADDRESS,
} from "../../redux/constants/type";
import "../../assets/styles/local/Addcontact.css";
import "../../assets/styles/local/AddCompany.css";
import { getLocalFormatedTime } from "../../utils/helpers/calculateTime";
import { AppInputBelowDropDown } from "../../utils/helpers/dropdown";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import { ROLES, isNotRole, isRole } from "../../utils/helpers/userRole";
import ContactTaskModal from "../dynamic/ContactTaskModal";
import AddTaskModal from "../../components/Dailogs/AddTaskModal";
import { ContactEmails } from "./ContactEmails";
import { OutlookContactEmails } from "./OutlookContactEmails";
import { HubConnectionBuilder } from "@microsoft/signalr";
import { europeanFormatWithSymbol } from "../../utils/European-Format/NumberFormatter";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import { EyeOutlined } from "@ant-design/icons";
import { getFilePreview } from "../../utils/filePreview/filePreview";
import FilePreviewModal from "../../utils/filePreview/FilePreviewModal";
import CurrencyInput from "react-currency-input";
import { v4 as uuidv4 } from "uuid";

const AddContacts = () => {
  const inputRef = useRef(null);
  const PaymentDeadline_Popup_Ref = useRef(null);
  const invoiceDetails_Popup_Ref = useRef(null);
  const startingDate_Popup_Ref = useRef(null);
  const complitionDate_Popup_Ref = useRef(null);
  const Project_Popup_Ref = useRef(null);
  const projectManagerRef = useRef(null);
  const [emailSource, setEmailSource] = useState("gmail");

  const roleAccess = window.localStorage.getItem("roleid");
  const packageID = window.localStorage.getItem("packageId");
  const currentCompanyId = useMemo(() =>
    window.localStorage.getItem("companyId"),
  );
  const currentUserId = window.localStorage.getItem("userid");
  const selectedGroupId = window.localStorage.getItem("selectedGroupId");

  const dispatch = useDispatch();
  const { id } = useParams();
  const params = useParams();
  console.log("param", params.id);

  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;
  const passedState = location.state;
  console.log("asc path", path);

  const addContactResponse = useSelector((state) => state.user.AddContacts);
  const [showAccountManagerDrop, setShowAccountManagerDrop] = useState(false);
  const [showRelationShipDrop, setShowRelationShipDrop] = useState(false);
  const [removeaddbtn, setRemoveaddbtn] = useState(false);
  const [changeComp, setChangeComp] = useState("");
  const [jobname, setJobname] = useState("");
  const [reRenderAPI, setReRenderAPI] = useState(false);
  const [deleteModalShow, setDeleteModalShow] = useState(false);
  const [deleteDocument, setDeleteDocument] = useState(false);
  const [deleteRowIndex, setDeleteRowIndex] = useState(null);
  const [searchingClients, setSearchingClients] = useState([]);
  const [canGoBack, setCanGoBack] = useState(false);

  const deletedocResponsedata = useSelector(
    (state) => state?.user?.DeleteDocsdata,
  );
  const updateContactResponse = useSelector(
    (state) => state.user.UpdateContactsdata,
  );
  const singleContactResponse = useSelector(
    (state) => state.user.FetchContactByIddata,
  );
  const fetchAllTags = useSelector(
    (state) => state.user.FetchAddTagsContactdata,
  );
  const getTaskStatusListRes = useSelector(
    (state) => state.user.getTaskStatusListRes,
  );

  const addTagResponse = useSelector((state) => state.user.AddTagsContact);
  const fetchAllManagers = useSelector((state) => state.user.FetchManagersList);

  const AddDocToClientsdata = useSelector(
    (state) => state.user.AddDocToClientsdata,
  );
  const searchClientResponse = useSelector(
    (state) => state.user.FetchSearchClientsdata,
  );
  const deleteTaskResponse = useSelector(
    (state) => state.user.deleteTaskResponse,
  );
  const updateTaskStatusResponse = useSelector(
    (state) => state.user.updateTaskStatusResponse,
  );
  const fetchContactTaskResponse = useSelector(
    (state) => state.user.fetchContactTaskResponse,
  );
  const docsContactListResponse = useSelector(
    (state) => state.user.FetchDocsContactByIdData,
  );
  const linkOrAddClientResponse = useSelector(
    (state) => state.user.AddCompanys,
  );

  // companys all res start 👇
  const addNewClientRes = useSelector((state) => state.user.addNewClientRes);

  const updateCompanyRes = useSelector((state) => state.user.updateCompanyRes);

  const updateClientDetailsRes = useSelector(
    (state) => state.user.updateClientDetailsRes,
  );

  const existingCompanyAddressRes = useSelector(
    (state) => state.user.existingCompanyAddressRes,
  );

  const fetchClientByIdRes = useSelector(
    (state) => state.user.fetchClientByIdRes,
  );

  const deleteMultipleAdressRes = useSelector(
    (state) => state.user.deleteMultipleAdressRes,
  );

  const fetchClientContactsByClientIdRes = useSelector(
    (state) => state.user.fetchClientContactsByClientIdRes,
  );

  const dleteClientContactRes = useSelector(
    (state) => state.user.dleteClientContactRes,
  );

  const FetchLinkClientByIdData = useSelector(
    (state) => state.user.FetchLinkClientByIdData,
  );

  const fetchAllClientTaskByClientIdRes = useSelector(
    (state) => state.user.fetchAllClientTaskByClientIdRes,
  );

  const fetchClientTasksRes = useSelector(
    (state) => state.user.fetchClientTasksRes,
  );

  const clientActivityTimelineRes = useSelector(
    (state) => state.user.clientActivityTimelineRes,
  );

  const getCreditTypeDropDownRes = useSelector(
    (state) => state.user.getCreditTypeDropDownRes,
  );

  const getInvoiceTypeDropDownRes = useSelector(
    (state) => state.user.getInvoiceTypeDropDownRes,
  );

  const getDiscountTypeDropDownRes = useSelector(
    (state) => state.user.getDiscountTypeDropDownRes,
  );

  const fetchPaymentDeadline = useSelector(
    (state) => state.user.fetchPaymentDeadline,
  );

  const fetchProjectDropdown = useSelector(
    (state) => state.user.fetchProjectDropdown,
  );

  const fetchProjectClientRes = useSelector(
    (state) => state.user.fetchProjectClientRes,
  );

  const fetchActiveUser = useSelector((state) => state.user.fetchActiveUser);
  const clientNameExistOrNotRes = useSelector(
    (state) => state.user.clientNameExistOrNotRes,
  );

  // companya all res end👆

  const firstupname = window.localStorage.getItem("firstname");
  const lastupname = window.localStorage.getItem("lastname");

  const [filePreview, setFilePreview] = useState(null);

  const [popups, setPopups] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [clientSearch, setClientSearch] = useState("");
  let hiddenFileInput = useRef(null);
  const primaryColor = useMemo(() =>
    window.localStorage.getItem("primarycolor"),
  );
  const [contactType, setContactType] = useState("Prospect");
  const [activeHeading, setActiveHeading] = useState("1");
  const [docAdded, setDocAdded] = useState(false);
  const selectDoc = useRef(null);
  const [showDropPeople, setShowDropPeople] = useState(false);
  const [filterDrop, setFilterDrop] = useState(false);
  const userid = window.localStorage.getItem("userid");
  const companyId = window.localStorage.getItem("companyId");
  const companyids = window.localStorage.getItem("companyid");
  const [singleContact, setSingleContact] = useState();
  const [tagList, setTagList] = useState([]);
  const [showTagDrop, setShowTagDrop] = useState(false);
  const [managerList, setManagerList] = useState([]);
  const [isUpdating, setIsUpdating] = useState(false);

  const [disableBtn, setDisableBtn] = useState(true);
  const [completeTags, setCompleteTags] = useState([]);
  const [docPeopleList, setDocPeopleList] = useState([]);
  const [contactDocsList, setContactDocsList] = useState([]);
  const [docAccessList, setDocAccessList] = useState([]);
  const [showTaskColumn, setShowTaskColumn] = useState(false);
  const [showMaritalStatusDrop, setShowMaritalStatusDrop] = useState(false);
  const [hours, setHours] = useState("00");
  const [minutes, setMinutes] = useState("00");
  const [searchPeople, setSearchPeople] = useState("");
  const [taggedUser, setTaggedUser] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalFunctionNoty, setModalFunctionNoty] = useState("");
  const [show, setShow] = useState([]);
  const [modalFunction, setModalFunction] = useState("");
  const [from, setFrom] = useState(moment().toDate());
  const [taskid, setTaskid] = useState("");
  const [searchText, setSearchText] = useState("");
  const TaskId = window.localStorage.getItem("taskid");
  const [comments, setComments] = useState([]);
  const [maxComments, setMaxComments] = useState([]);
  const [enablecomm, setEnableComm] = useState(false);
  const [showcmnt, setShowcmnt] = useState(true);
  const [length, setLength] = useState("");
  const [imgUrl, setImgUrl] = useState("");
  const [message, setMessage] = useState("");
  const [minComments, setMinComments] = useState([]);
  const [firstNameComm, setFirstNameComm] = useState("");
  const [lastNameComm, setLastNameComm] = useState("");
  const [currentDate, setcurrentDate] = useState("");
  ///////////////////////////////DATA VALUES STATE///////////////////////////////
  const [fullName, setFullName] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [birthDate, setBirthDate] = useState();
  const [relationship, setRelationship] = useState("Representative");
  const [clientVatNumber, setClientVatNumber] = useState("");
  const [amount, setAmount] = useState("");
  const [tagValue, setTagValue] = useState("");
  const [tags, setTags] = useState([]);
  const [notes, setNotes] = useState("");
  const [roleId, setRoleId] = useState("");
  const [selectedValue, setSelectedValue] = React.useState("");
  const [accountManagerId, setAccountManagerId] = useState(
    "00000000-0000-0000-0000-000000000000",
  );
  const storedClientName = window.localStorage.getItem("clientaddname");
  const [clientName, setClientName] = useState(
    typeof storedClientName === "string" ? storedClientName : "",
  );

  useEffect(() => {
    // when we come from companyList.
    if (location?.state?.from === "CompanyList_Screen") {
      setClientName(location?.state?.companyName);
    }
  }, []);

  const [connection, setConnection] = useState(null);
  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty(),
  );

  const [mainContactType, setMainContactType] = useState("Client");
  const storedClientId = window.localStorage.getItem("clientId2");
  const [clientId, setClientId] = useState(
    typeof storedClientId === "string" ? storedClientId : "",
  );
  const [fileName, setFileName] = useState("");
  const [taskName, setTaskName] = useState("");
  const [clientDescription, setClientDescription] = useState("");
  const [companyTasks, setCompanyTasks] = useState([]);
  const [key, setKey] = useState("home");
  const [dueDate, setDueDate] = useState(new Date());
  const [errorfull, setErrorfull] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [hideDropdown, setHideDropdown] = useState(true);
  const [openCompanyDropdown, setOpenCompanyDropdown] = useState(false);
  const [fulLenghtDocAddContact, setFulLenghtDocAddContact] = useState(false);
  const [contectDoc, setContectDoc] = useState(
    window.localStorage.getItem("Doc"),
  );
  const [marital, setMarital] = useState("Select");
  const [FetchTranslationList, setFetchTranslationList] = useState({});
  const t = (key) => FetchTranslationList?.[key] || "";
  const [dateError, setDateError] = useState(false);

  const typeoptions = [{ value: "Representative" }, { value: "Employee" }];
  // const typeoptions = [ { value: FetchTranslationList[ 24 ]?.translation }, { value: FetchTranslationList[ 23 ]?.translation } ];

  const mobileTypeoptions = [
    { value: "Professional Address" },
    { value: "Personal Address" },
  ];
  const emailTypeoptions = [
    { value: "Personal Email" },
    { value: "Professional Email" },
  ];
  const mobilePhoneTypeoptions = [
    { value: "Professional Mobile" },
    { value: "Personal Mobile" },
    { value: "Office Number" },
  ];
  const [emails, setEmails] = useState([
    {
      email: "",
      type: "Professional Email",
    },
  ]);
  const [emailErrors, setEmailErrors] = useState([]);
  const validateEmail = (email) => {
    // Regular expression for validating an Email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const handleEmailChange = (e, index) => {
    const { name, value } = e.target;
    let newEmails = [...emails];
    newEmails[index][name] = value;
    setEmails(newEmails);

    // Validate email and update error state
    let newEmailErrors = [...emailErrors];
    newEmailErrors[index] = !validateEmail(value);
    setEmailErrors(newEmailErrors);
  };

  const [mobiles, setMobiles] = useState([
    {
      phoneNumber: "",
      type: "Professional Mobile",
    },
  ]);

  const [addresses, setAddresses] = useState([
    {
      address: "",
      type: "Professional Address",
    },
  ]);

  const [activityLogs, setActivityLogs] = useState([]);
  const [showFullContent, setShowFullContent] = useState(false);
  const [showIndexContent, setShowIndexContent] = useState();

  const refActivityTimelineDD = useRef();

  useEffect(() => {
    if (fetchContactTaskResponse.status === true) {
      // setCompanyTasks(fetchContactTaskResponse?.data);
    }
  }, [fetchContactTaskResponse]);

  useEffect(() => {
    if (fetchClientTasksRes.status === true) {
      setCompanyTasks(fetchClientTasksRes?.data);
    }
  }, [fetchClientTasksRes]);

  useEffect(() => {
    if (contectDoc) {
      setActiveHeading("2");
      setTimeout(() => {
        window.localStorage.removeItem("Doc");
        setContectDoc(null);
      }, 1000);
    }
  }, [contectDoc]);

  useEffect(() => {
    if (AddDocToClientsdata?.status === true) {
      dispatch(FetchDocsClientById(id));
    } else {
      return;
    }
  }, [AddDocToClientsdata]);

  useEffect(() => {
    if (deleteTaskResponse.status === true) {
      // dispatch(fetchTaskByContactId(id)); // old task data.
      dispatch(
        FetchClientTasks(
          id,
          projectid || "00000000-0000-0000-0000-000000000000",
        ),
      ); // new task data.
    }
  }, [deleteTaskResponse]);

  useEffect(() => {
    if (updateTaskStatusResponse?.status === true) {
      // dispatch(fetchTaskByContactId(id)); // old task data.
      dispatch(
        FetchClientTasks(
          id,
          projectid || "00000000-0000-0000-0000-000000000000",
        ),
      ); // new task data.
    }
  }, [updateTaskStatusResponse]);

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
    setFilterDrop(false);
  };

  const handleClick = (event) => {
    event.preventDefault();
    hiddenFileInput.current.click();
  };

  const handleDeleteFun = () => {
    setImageUrl("");
    setDeleteModalShow(false);
  };

  const handleDeleteDocumentFun = () => {
    if (deleteRowIndex !== null) {
      dispatch(DeleteDocs(deleteRowIndex));
      let data = [...contactDocsList];
      data.splice(deleteRowIndex, 1);
      setContactDocsList(data);
    }
    setDeleteDocument(false);
    setDeleteRowIndex(null);
  };

  const handleDeleteLinkedConact = () => {
    dispatch(DeleteClientcontact(linkedContactID));
    setLinkedContactsDelShow(false);

    setTimeout(() => {
      dispatch(FetchClientContactsByclientId(id));
    }, 1000);
  };

  const profileUpload = async (file) => {
    var formData = new FormData();
    formData.append("", file);
    try {
      const response = await axios.put(
        `${API_URL}/api/Files/UploadToS3`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      setImageUrl(response.data[0]);
    } catch (error) {}
  };

  const onClickTag = () => {
    inputRef?.current?.focus();
    setShowTagDrop(true);
  };

  const onFileUploaded = (data) => {
    // if (isUpdating) {
    let reqArray = [];
    reqArray.push({
      documentname: data[0].name,
      documentextension: data[0].type,
      documentcontent: "string",
      link: data[0].link,
      documentsize: data[0].size,
    });
    dispatch(AddDocToClients(id, userid, reqArray));
    // } else {
    const modifiedContacts = contactDocsList || [];
    modifiedContacts.push({
      userid: userid,
      documentname: data[0].name,
      documentextension: data.type,
      documentcontent: "string",
      link: data.link,
      documentsize: data.size,
    });
    setContactDocsList([...modifiedContacts]);
    // }
    setContectDoc("Doc");
  };

  // riya code start for Doc Drag and Drop
  const [isDragging, setIsDragging] = useState(false);

  // Handle file drop
  const handleDrop = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const files = event.dataTransfer.files;
    if (files.length > 0) {
      for (const file of files) {
        const data = {
          name: file.name,
          type: file.type,
          size: file.size,
          link: URL.createObjectURL(file), // Generate a temporary link for the file
        };
        onFileUploaded(data);
      }
    }
  };

  // Handle drag over
  const handleDragOver = (event) => {
    event.preventDefault(); // Prevent default behavior (e.g., opening as a link)
    event.stopPropagation(); // Stop the event from propagating up the DOM tree
  };

  // Handle drag leave
  const handleDragLeave = (event) => {
    event.preventDefault();
    event.stopPropagation();
  };
  // riya code end for Doc Drag and Drop

  useEffect(() => {
    dispatch(FetchAddTagsContact(tagValue));
  }, [tagValue]);

  useEffect(() => {
    dispatch(FetchManagersList());
    checkIfTempData();
    return () => {
      window.localStorage.removeItem("active-contact");
      setCanGoBack(false);
      dispatch({ type: "RESET_ADD_UPDATE_CONTACT" });
    };
  }, []);

  useEffect(() => {
    if (fetchAllManagers != null) {
      if (fetchAllManagers.status === 200) {
        setManagerList(fetchAllManagers?.data);
      }
    }
  }, [fetchAllManagers]);

  useEffect(() => {
    if (path.includes(`/add-company/${id}`)) {
      if (FetchLinkClientByIdData?.status === 200) {
        setContactDocsList(FetchLinkClientByIdData?.data?.data);
      }
    }
  }, [path, FetchLinkClientByIdData, id]);

  const [emailErr, setEmailErr] = useState(false);

  const handleContactAdd = () => {
    if (isGeneralEmailValid) {
      return;
    }

    if (isValueExists === true) return;

    setChangeComp("");
    setRemoveaddbtn(true);
    if (companyName === "") {
      setErrorfull(true);
    } else {
      let year = dueDate.toISOString().split("-")[0];
      const date = dueDate.getDate();
      let month = dueDate.toISOString().split("-")[1];
      let datetime;
      if (hours.length === 1 && minutes.length === 1) {
        datetime = `${year}-${month}-${date}T0${hours}:0${minutes}:00.000Z`;
      } else if (hours.length === 1 && minutes.length === 2) {
        datetime = `${year}-${month}-${date}T0${hours}:${minutes}:00.000Z`;
      } else if (hours.length === 2 && minutes.length === 1) {
        datetime = `${year}-${month}-${date}T${hours}:0${minutes}:00.000Z`;
      } else {
        datetime = `${year}-${month}-${date}T${hours}:${minutes}:00.000Z`;
      }
      const fnames = fullName.split(" ");
      const firstName = fnames[0];
      fnames.shift();
      const lastName = fnames.join(" ") || "";
      const invalidEmails = [];
      const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

      emails.forEach((email) => {
        if (email.email && !emailPattern.test(email.email)) {
          invalidEmails.push(email.email);
        }
      });

      if (invalidEmails.length > 0) {
        // setErrorfull(true);
        setEmailError(true);
      } else {
        if (isUpdating) {
          // dispatch(
          //   UpdateContacts(
          //     userid,
          //     id,
          //     clientName,
          //     firstName,
          //     lastName,
          //     jobTitle,
          //     imageUrl,
          //     mainContactType,
          //     birthDate,
          //     marital,
          //     relationship,
          //     accountManagerId,
          //     notes,
          //     emails,
          //     // addresses, old address without zip code.
          //     addressWithPincode,
          //     mobiles,
          //     tags
          //   )
          // );

          dispatch(
            UpdateClientDetails(
              id,
              companyName,
              clientDescription,
              companyAddress,
              imageUrl,
              mainContactType,
              companyAddressParts.pinCode,
              companyAddressParts.city,
              companyAddressParts.country,
              active,
              basicInformation,
              generalInformation,
              financialInformation,
              companyAddressParts,
            ),
          );
          setCanGoBack(true);
        } else {
          let newtag = [];
          tags?.forEach((elements) => {
            newtag.push({
              tagname: elements?.tagname,
            });
          });
          if (companyName) {
            // dispatch(
            //   AddContact(
            //     userid,
            //     companyids,
            //     firstName,
            //     lastName,
            //     jobTitle,
            //     imageUrl,
            //     mainContactType,
            //     birthDate,
            //     marital,
            //     relationship,
            //     accountManagerId,
            //     notes,
            //     clientName ? clientName : "",
            //     mobiles,
            //     emails,
            //     // addresses, old address without zip code.
            //     addressWithPincode,
            //     newtag
            //   )
            // );

            dispatch(
              AddNewClient(
                // `${firstName} ${lastName}`,
                companyName,
                clientDescription,
                companyAddress,
                imageUrl,
                mainContactType,
                companyAddressParts.pinCode,
                companyAddressParts.city,
                companyAddressParts.country,
                active,
                basicInformation,
                generalInformation,
                financialInformation,
                companyAddressParts,
              ),
            );

            setCanGoBack(true);
          }
          // if (invalidEmails.length > 0) {
          //   setErrorfull(true);
          //   setEmailError(true);
          // } else {

          // elsesetEmailError(false);
          // }
          else {
            history.goBack();
          }
          window.localStorage.removeItem("clientaddname");
        }
      }
    }
    window.localStorage.removeItem("_tmpCon");
  };

  useEffect(() => {
    const processContactDocuments = () => {
      if (contactDocsList?.length > 0) {
        const reqArray = contactDocsList?.map((element) => ({
          documentname: element?.documentname,
          documentextension: element?.documentextension,
          documentcontent: element?.documentcontent,
          link: element?.link,
          documentsize: element?.documentsize.toString(),
        }));

        dispatch(
          AddDocToClients(
            addContactResponse?.data?.data?.contactid,
            userid,
            reqArray,
          ),
        );
      }
    };

    const sendContactMessage = async () => {
      if (!selectedGroupId) return;

      const newState = RichUtils.toggleInlineStyle(editorState, "BOLD");
      const textMessage = convertToRaw(newState.getCurrentContent());

      const messageId = uuidv4();
      const chatMessage = createChatMessage(textMessage, messageId);

      try {
        await connection.invoke(
          "SendMessage",
          `${currentCompanyId}-${selectedGroupId}`,
          chatMessage,
        );
      } catch (err) {
        console.error(err);
      }
    };

    const createChatMessage = (textMessage, messageId) => ({
      messageid: messageId,
      groupid: selectedGroupId,
      userid: currentUserId,
      messagetext: JSON.stringify(textMessage),
      attachments: "",
      type: "Group",
      senderimage: window.localStorage.getItem("userimageurl"),
      senderfirstname: window.localStorage.getItem("firstname"),
      senderlastname: window.localStorage.getItem("lastname"),
      contactid: addContactResponse?.data?.data?.contactid ?? "",
    });

    const handleRedirects = () => {
      if (passedState?.chatWidgetContact && connection) {
        sendContactMessage();
        history.push("/chat");
      } else {
        history.push("/contact-list");
        window.localStorage.removeItem("clientaddname");
        window.localStorage.removeItem("clientId2");
        window.localStorage.removeItem("_tmpCon");
        dispatch({ type: "ADD_CONTACTS", data: {} });
      }
    };

    const mainFlow = async () => {
      if (addContactResponse?.status === 200) {
        processContactDocuments();
        setTimeout(handleRedirects, 1000);
      }
    };

    mainFlow();
  }, [addContactResponse, connection]);

  useEffect(() => {
    if (connection) {
      connection.start().then(() => {
        console.log("connected");
      });
    }
  }, [connection]);

  useEffect(() => {
    const newConnection = new HubConnectionBuilder()
      .withUrl(`${CHAT_API_URL}/chat`, {
        withCredentials: true,
        accessTokenFactory: () =>
          Promise.resolve(window.localStorage.getItem("token")),
      })
      .withAutomaticReconnect()
      .build();

    setConnection(newConnection);
  }, []);

  const saveTempState = () => {
    const currentState = {
      fullName,
      jobTitle,
      imageUrl,
      mainContactType,
      emails,
      mobiles,
      addresses,
      birthDate,
      marital,
      relationship,
      accountManagerId,
      jobname,
      completeTags,
      tags,
      notes,
      clientName,
      clientId,
    };
    window.localStorage.setItem("_tmpCon", JSON.stringify(currentState));
  };

  useEffect(() => {
    if (updateContactResponse.status === 200) {
      setTimeout(() => {
        if (passedState?.chatWidgetContact) {
          history.push("/chat");
          return;
        }
        dispatch({ type: UPDATE_CONTACTS, data: {} });
        history.push("/contact-list");
        window.localStorage.removeItem("clientaddname");
        window.localStorage.removeItem("clientId2");
        window.localStorage.removeItem("_tmpCon");
      }, 1000);
    }
  }, [updateContactResponse]);

  useEffect(() => {
    if (passedState?.adminUser) {
      setFullName(
        `${passedState?.adminUser?.firstname} ${passedState?.adminUser?.lastname}`,
      );
      setEmails([
        {
          email: passedState?.adminUser?.email,
          type: "Professional Email",
        },
      ]);
    }
  }, [passedState?.adminUser]);

  useEffect(() => {
    if (deletedocResponsedata?.data?.status === true) {
      // dispatch(FetchDocsContactById(id)); // old fetch Doc list.
      dispatch(FetchDocsClientById(id)); // new fetch Doc list.
    }
  }, [deletedocResponsedata]);

  useEffect(() => {
    if (id) {
      // dispatch(FetchContactById(id)); // old fetch company API.
      // dispatch(fetchTaskByContactId(id)); //old task data.

      window.localStorage.setItem("active-contact", id);
      // checkIfTempData();

      // dispatch(FetchDocsContactById(id)); // old fetch Doc list.
      dispatch(FetchClientById(id)); // New fetch company API.
    }
  }, [id]);

  const checkIfTempData = () => {
    if (localStorage.getItem("_tmpConRemoval")) {
      const tmpData = window.localStorage.getItem("_tmpCon");
      if (tmpData) {
        const jsonData = JSON.parse(tmpData);
        setFullName(jsonData.fullName);
        setJobTitle(jsonData.jobTitle);
        setImageUrl(jsonData.imageUrl);
        setMainContactType(jsonData.mainContactType);

        setEmails(jsonData.emails);
        setMobiles(jsonData.mobiles);
        setAddresses(jsonData.addresses);
        setBirthDate(jsonData.birthDate ? new Date(jsonData.birthDate) : null);
        setMarital(jsonData.marital);
        setRelationship(jsonData.relationship);
        setAccountManagerId(jsonData.accountManagerId);
        setJobname(jsonData.jobname);
        setCompleteTags(jsonData.completeTags);
        setTags(jsonData.tags);
        setNotes(jsonData.notes);
        // window.localStorage.removeItem("_tmpCon");
      }
    }
    localStorage.removeItem("_tmpConRemoval");
  };

  useEffect(() => {
    if (path.includes(`/add-company/${id}`)) {
      if (singleContactResponse && singleContactResponse.status === 200) {
        setSingleContact(singleContactResponse?.data?.data);
        const contactObject = singleContactResponse?.data?.data[0];
        const { firstname, lastname } = contactObject || {};
        setFullName(`${firstname} ${lastname}`);
        setMarital(contactObject?.maritalStatus);

        if (
          contactObject != null &&
          contactObject?.contactaddress != null &&
          contactObject?.contactaddress.length > 0
        )
          setAddresses(contactObject?.contactaddress);

        if (
          contactObject != null &&
          contactObject?.contactphonenumber != null &&
          contactObject?.contactphonenumber.length > 0
        )
          setMobiles(contactObject?.contactphonenumber);

        setMainContactType(contactObject?.contacttype);
        // setContactType(contactObject.contacttype);
        setCompleteTags(contactObject?.contacttag);
        setBirthDate(
          contactObject?.dateofbirth
            ? new Date(contactObject?.dateofbirth)
            : "",
        );
        setJobTitle(contactObject?.jobtitle);
        setNotes(contactObject?.notes);
        setImageUrl(contactObject?.photo);
        setRelationship(contactObject?.relationship);

        if (
          contactObject != null &&
          contactObject?.contactemail != null &&
          contactObject?.contactemail?.length > 0
        )
          setEmails(contactObject?.contactemail);

        setAccountManagerId(contactObject?.accountmanager);
        setJobname(contactObject?.accountmanagername);
        setTags(contactObject?.contacttag);
        setClientName(
          window.localStorage.getItem("clientaddname") ||
            contactObject?.contactclients[0]?.clientname ||
            contactObject?.contactclients[0]?.clientname,
        );
        setClientId(
          window.localStorage.getItem("clientId2") ||
            contactObject?.contactclients[0]?.clientid ||
            contactObject?.contactclients[0]?.clientid,
        );
        setIsUpdating(true);
        checkIfTempData();
      }
    }
  }, [id, path, singleContactResponse]);

  // ASC Company fetching start👇
  useEffect(() => {
    if (path.includes(`/add-company/${id}`)) {
      setIsUpdating(true);
      if (fetchClientByIdRes.status === true) {
        setMainContactType(fetchClientByIdRes.data.mainCompanyType);
        setImageUrl(fetchClientByIdRes.data.companyImage);
        // setFullName(fetchClientByIdRes.data);
        setCompanyName(fetchClientByIdRes.data.companyName);
        // localStorage.setItem("clientCOName", fetchClientByIdRes.data.companyName);
        // localStorage.setItem("clientCONameID", fetchClientByIdRes.data.clientId);
        setCompanyID(fetchClientByIdRes.data.clientId);
        setClientDescription(fetchClientByIdRes.data.clientDescription);
        setCompanyAddress(fetchClientByIdRes.data.streetNameNumber);
        setCompanyAddressParts({
          street:
            fetchClientByIdRes.data.streetWithNumber ||
            fetchClientByIdRes.data.street ||
            "",
          city: fetchClientByIdRes.data.city || "",
          state: fetchClientByIdRes.data.state || "",
          pinCode:
            fetchClientByIdRes.data.pinCode ||
            fetchClientByIdRes.data.pincode ||
            fetchClientByIdRes.data.zipcode ||
            "",
          country: fetchClientByIdRes.data.country || "",
        });
        setActive(fetchClientByIdRes.data.isActive);

        // setMainAddress(
        //   fetchClientByIdRes.data.basicInformation.address.map((x) => ({
        //     asc1: x.address,
        //     asc2: x.addressId,
        //     asc3: x.type,
        //   }))
        // );

        setMainAddress(
          fetchClientByIdRes.data.basicInformation.address
            .filter((x) => x.type === "")
            .map((y) => y.address)[0],
        );
        const fetchedMainAddress =
          fetchClientByIdRes.data.basicInformation.address.find(
            (x) => x.type === "",
          );
        setMainAddressParts({
          street:
            fetchedMainAddress?.streetWithNumber ||
            fetchedMainAddress?.street ||
            "",
          city: fetchedMainAddress?.city || "",
          state: fetchedMainAddress?.state || "",
          pinCode:
            fetchedMainAddress?.pinCode ||
            fetchedMainAddress?.pincode ||
            fetchedMainAddress?.postalCode ||
            "",
          country: fetchedMainAddress?.country || "",
        });

        setMainAddressSendID(
          fetchClientByIdRes.data.basicInformation.address
            .filter((x) => x.type === "")
            .map((y) => y.addressId)[0],
        );

        setMainAddressMultiData(
          fetchClientByIdRes.data.basicInformation.address
            .filter((x) => x.type !== "")
            .map((y) => ({
              asc_EnterAddressName: y.address,
              asc_MainAddName: y.type,
              asc_MultiAdressID: y.addressId,
              street: y.streetWithNumber || y.street || "",
              city: y.city || "",
              state: y.state || "",
              pinCode: y.pinCode || y.pincode || y.postalCode || "",
              country: y.country || "",
            })),
        );

        setGeneralEmail(
          fetchClientByIdRes.data.basicInformation.email
            .filter((x) => x.type === "")
            .map((y) => y.address)[0],
        );

        setSingleEmailSendID(
          fetchClientByIdRes.data.basicInformation.email
            .filter((x) => x.type === "")
            .map((y) => y.addressId)[0],
        );

        setGenEmailMultiData(
          fetchClientByIdRes.data.basicInformation.email
            .filter((x) => x.type !== "")
            .map((y) => ({
              asc_EmailAddress: y.address,
              asc_EmailName: y.type,
              asc_MultiEmailID: y.addressId,
            })),
        );

        setContactTelephone(
          fetchClientByIdRes.data.basicInformation.contactTelephone,
        );
        setOfficeTelephone(
          fetchClientByIdRes.data.basicInformation.officeTelephone,
        );
        setKvkNumber(fetchClientByIdRes.data.generalInformation.kvkNumber);
        setProjectManagerID(
          fetchClientByIdRes.data.generalInformation.accountManager.userId,
        );
        setProjectManagerName(
          fetchClientByIdRes.data.generalInformation.accountManager.managerName,
        );
        setProjectManagerImage(
          fetchClientByIdRes.data.generalInformation.accountManager
            .profileImage,
        );
        setUrl(fetchClientByIdRes.data.generalInformation.url);
        setVatNumber(fetchClientByIdRes.data.financialInformation.vatNumber);
        // setPaymentDeadlineid(fetchClientByIdRes.data.financialInformation.);
        setPaymentDeadline(
          fetchClientByIdRes.data.financialInformation.paymentTerms,
        );
        setBankAccount(
          fetchClientByIdRes.data.financialInformation.bankAccount,
        );
        setBankAccountBlocked(
          fetchClientByIdRes.data.financialInformation.bankAccountBlockedForTax,
        );
        setTotalActiveProjects(
          fetchClientByIdRes.data.financialInformation.totalActiveProjects,
        );
        setCreditName(
          fetchClientByIdRes.data.financialInformation.creditTypeName,
        );
        setCreditID(fetchClientByIdRes.data.financialInformation.creditTypeId);
        setCreditLimit(
          fetchClientByIdRes.data.financialInformation.creditLimit,
        );
        setStartingDate(
          new Date(fetchClientByIdRes.data.financialInformation.startingDate),
        );
        setEndingDate(
          new Date(fetchClientByIdRes.data.financialInformation.endingDate),
        );
        setInvoiceDetailsid(
          fetchClientByIdRes.data.financialInformation.invoiceDetailsTypeId,
        );
        setInvoiceDetails(
          fetchClientByIdRes.data.financialInformation.invoiceDetailsTypeName,
        );
        setVatShifted(fetchClientByIdRes.data.financialInformation.vatShifted);
        setInsurance(fetchClientByIdRes.data.financialInformation.insurance);
        setDiscountID(
          fetchClientByIdRes.data.financialInformation.discountTypeId,
        );
        setDiscountName(
          fetchClientByIdRes.data.financialInformation.discountTypeName,
        );
        setNotes(fetchClientByIdRes.data.financialInformation.notes);
      }
    }
  }, [fetchClientByIdRes, id]);
  // ASC Company fetching end.

  useEffect(() => {
    fetchScreenTranslations("Add-Company").then((res) => {
      setFetchTranslationList(res);
    });
  }, []);

  useEffect(() => {
    if (singleContact) {
      mapActiveActivityLogs();
    }
  }, [singleContact]);

  useEffect(() => {
    mapActiveActivityLogs();
  }, [selectedValue]);

  const mapActiveActivityLogs = () => {
    const currentActivity = selectedValue;
    if (
      singleContact &&
      singleContact[0] &&
      singleContact[0].activityLogs &&
      singleContact[0].activityLogs.length > 0
    ) {
      const activityLogs = singleContact[0].activityLogs;
      const filteredActivityLogs = [];

      const accessLevel = {
        CONTACTS: false,
        FILES: false,
        TASKS: false,
        EMAIL: false,
        EVENTS: false,
        TIME: false,
      };

      switch (currentActivity) {
        case "information":
          accessLevel.CONTACTS = true;
          break;
        case "docs":
          accessLevel.FILES = true;
          break;
        case "tasks":
          accessLevel.TASKS = true;
          break;
        case "events":
          accessLevel.EVENTS = true;
          break;
        case "emails":
          accessLevel.EMAIL = true;
          break;
        case "time":
          accessLevel.TIME = true;
          break;

        default:
          accessLevel.CONTACTS = true;
          accessLevel.FILES = true;
          accessLevel.TASKS = true;
          accessLevel.EMAIL = true;
          accessLevel.EVENTS = true;
          accessLevel.TIME = true;
          break;
      }

      activityLogs.forEach((log) => {
        switch (log.type) {
          case "Create":
            if (accessLevel.CONTACTS && log.tableName === "Contacts") {
              let newLog = {
                Icon: <img src={actinfo} alt="" />,
                message: `Contact Created by ${log.userFullName}`,
                time: getLocalFormatedTime(
                  log.dateTime,
                  "DD[/]MM[/]YYYY[.] HH:mm[H]",
                ),
              };
              filteredActivityLogs.unshift(newLog);

              if (log.newValues.Relationship) {
                let newLog = {
                  Icon: <img src={actinfo} alt="" />,
                  message: `Contact relationship set to ${log.newValues.Relationship.toUpperCase()} by ${
                    log.userFullName
                  }`,
                  time: getLocalFormatedTime(
                    log.dateTime,
                    "DD[/]MM[/]YYYY[.] HH:mm[H]",
                  ),
                };
                filteredActivityLogs.unshift(newLog);
              }
            }

            if (accessLevel.FILES && log.tableName === "Documents") {
              let newLog = {
                Icon: <img src={foldblue} alt="" />,
                message: `Document ${log.newValues.Documentname} Attached by ${log.userFullName}`,
                time: getLocalFormatedTime(
                  log.dateTime,
                  "DD[/]MM[/]YYYY[.] HH:mm[H]",
                ),
              };
              filteredActivityLogs.unshift(newLog);
            }
            if (accessLevel.TASKS && log.tableName === "Tasks") {
              let newLog = {
                Icon: <img src={taskIcon} alt="" />,
                message: `New Task assigned ${log.newValues.Taskname}`,
                time: getLocalFormatedTime(
                  log.dateTime,
                  "DD[/]MM[/]YYYY[.] HH:mm[H]",
                ),
              };
              filteredActivityLogs.unshift(newLog);
            }
            break;
          case "Update":
            if (
              accessLevel.CONTACTS &&
              log.tableName === "Contacts" &&
              isValidActivityLog(log)
            ) {
              let newLog = {
                Icon: <img src={actinfo} alt="" />,
                message: `Contact Updated by ${log.userFullName}`,
                time: getLocalFormatedTime(
                  log.dateTime,
                  "DD[/]MM[/]YYYY[.] HH:mm[H]",
                ),
              };
              filteredActivityLogs.unshift(newLog);

              if (log.newValues.Relationship) {
                let newLog = {
                  Icon: <img src={actinfo} alt="" />,
                  message: `Contact relationship set to ${log.newValues.Relationship.toUpperCase()} by ${
                    log.userFullName
                  }`,
                  time: getLocalFormatedTime(
                    log.dateTime,
                    "DD[/]MM[/]YYYY[.] HH:mm[H]",
                  ),
                };
                filteredActivityLogs.unshift(newLog);
              }
            }
            if (accessLevel.TASKS && log.tableName === "Tasks") {
              if (
                log.oldValues.IsDeleted == false &&
                log.newValues.IsDeleted == true
              ) {
                let newLog = {
                  Icon: <img src={taskIcon} alt="" />,
                  message: `Task Deleted by ${log.userFullName}`,
                  time: getLocalFormatedTime(
                    log.dateTime,
                    "DD[/]MM[/]YYYY[.] HH:mm[H]",
                  ),
                };
                filteredActivityLogs.unshift(newLog);
              } else {
                let newLog = {
                  Icon: <img src={taskIcon} alt="" />,
                  message: `Task Updated by ${log.userFullName}`,
                  time: getLocalFormatedTime(
                    log.dateTime,
                    "DD[/]MM[/]YYYY[.] HH:mm[H]",
                  ),
                };
                filteredActivityLogs.unshift(newLog);
              }
            }
            if (accessLevel.CONTACTS && log.tableName === "Clients") {
              if (log.newValues.Priceagreement) {
                let newLog = {
                  Icon: <img src={actinfo} alt="" />,
                  message: `${log.newValues.Priceagreement} Rate assigned`,
                  time: getLocalFormatedTime(
                    log.dateTime,
                    "DD[/]MM[/]YYYY[.] HH:mm[H]",
                  ),
                };
                filteredActivityLogs.unshift(newLog);
              }
            }
            break;
          case "Delete":
            if (accessLevel.TASKS && log.tableName === "Tasks") {
              let newLog = {
                Icon: <img src={taskIcon} alt="" />,
                message: `Task ${log.oldValues.Taskname} Deleted by ${log.userFullName}`,
                time: getLocalFormatedTime(
                  log.dateTime,
                  "DD[/]MM[/]YYYY[.] HH:mm[H]",
                ),
              };
              filteredActivityLogs.unshift(newLog);
            }
            if (accessLevel.FILES && log.tableName === "Documents") {
              let newLog = {
                Icon: <img src={foldblue} alt="" />,
                message: `Document ${log.oldValues.Documentname} Deleted by ${log.userFullName}`,
                time: getLocalFormatedTime(
                  log.dateTime,
                  "DD[/]MM[/]YYYY[.] HH:mm[H]",
                ),
              };
              filteredActivityLogs.unshift(newLog);
            }
            break;
          default:
            break;
        }
      });
      setActivityLogs(filteredActivityLogs);
    }
  };

  const isValidActivityLog = (log) => {
    if (log.affectedColumns) {
      if (
        log.affectedColumns.length === 1 &&
        log.affectedColumns[0] === "Updatedat"
      ) {
        return false;
      }
    }
    return true;
  };

  useEffect(() => {
    if (fetchAllTags != null) {
      if (fetchAllTags.status === 200) {
        setTagList(fetchAllTags?.data?.data);
      }
    }
  }, [fetchAllTags]);

  useEffect(() => {
    if (addTagResponse.status === 200) {
      setTagValue("");
      tags.push({
        tagname: addTagResponse?.data?.data?.tagname,
        tagid: addTagResponse?.data?.data?.tagid,
      });
      dispatch(FetchAddTagsContact());
    }
  }, [addTagResponse]);

  useEffect(() => {
    if (
      fullName &&
      jobTitle &&
      emails[0]?.email.length > 0 &&
      mobiles[0]?.phoneNumber.length > 0 &&
      clientVatNumber &&
      amount &&
      accountManagerId !== "Select Manager"
    ) {
      setDisableBtn(false);
    } else {
      setDisableBtn(true);
    }
  }, [fullName, clientVatNumber, amount, emails, mobiles, accountManagerId]);

  const DeleteTag = async (tagid) => {
    await dispatch(DeleteTags(tagid));
    await dispatch(FetchAddTagsContact(tagValue));
  };

  const maritailOptions = [
    { value: "-" },
    { value: "Single" },
    { value: "Married" },
    { value: "Divorced" },
    { value: "Widow" },
  ];

  const handelCancel = () => {
    history.goBack();
    dispatch({
      type: FETCH_CLIENT_BY_ID,
      data: {},
    });
    // if (isUpdating === true) {
    //   if (changeComp !== "") {
    //     setPopups(true);
    //   } else {
    //     history.push("/contact-list");
    //     window.localStorage.removeItem("clientaddname");
    //     window.localStorage.removeItem("clientId2");
    //     window.localStorage.removeItem("_tmpCon");
    //   }
    // } else if (
    //   fullName != "" ||
    //   jobTitle != "" ||
    //   imageUrl != "" ||
    //   notes != "" ||
    //   tags != ""
    // ) {
    //   setPopups(true);
    //   window.localStorage.removeItem("clientaddname");
    // } else {
    //   if (changeComp !== "") {
    //     setPopups(true);
    //   } else {
    //     history.push("/contact-list");
    //     window.localStorage.removeItem("clientaddname");
    //     window.localStorage.removeItem("clientId2");
    //     window.localStorage.removeItem("_tmpCon");
    //     dispatch(RemoveDocsClientById());
    //   }
    // }
  };

  const refAccountManager = useRef();
  const handleAccountManagerMouseDown = (event) => {
    if (
      refAccountManager.current &&
      !refAccountManager.current.contains(event.target)
    ) {
      setShowAccountManagerDrop(false);
    }
  };
  useEffect(() => {
    if (showAccountManagerDrop) {
      window.addEventListener("mousedown", handleAccountManagerMouseDown);
    } else {
      window.removeEventListener("mousedown", handleAccountManagerMouseDown);
    }
    return () => {
      window.removeEventListener("mousedown", handleAccountManagerMouseDown);
    };
  }, [showAccountManagerDrop]);

  const refRelationshipManager = useRef();
  const handleRelationshipMouseDown = (event) => {
    if (
      refRelationshipManager.current &&
      !refRelationshipManager.current.contains(event.target)
    ) {
      setShowRelationShipDrop(false);
    }
  };
  useEffect(() => {
    if (showRelationShipDrop) {
      window.addEventListener("mousedown", handleRelationshipMouseDown);
    } else {
      window.removeEventListener("mousedown", handleRelationshipMouseDown);
    }
    return () => {
      window.removeEventListener("mousedown", handleRelationshipMouseDown);
    };
  }, [showRelationShipDrop]);

  const refMarital = useRef();
  const handleMaritalMouseDown = (event) => {
    if (refMarital.current && !refMarital.current.contains(event.target)) {
      setShowMaritalStatusDrop(false);
    }
  };
  useEffect(() => {
    if (showMaritalStatusDrop) {
      window.addEventListener("mousedown", handleMaritalMouseDown);
    } else {
      window.removeEventListener("mousedown", handleMaritalMouseDown);
    }
    return () => {
      window.removeEventListener("mousedown", handleMaritalMouseDown);
    };
  }, [showMaritalStatusDrop]);

  const companyDropDownRef = useRef();
  const handleCompanyDropDown = (event) => {
    if (
      companyDropDownRef.current &&
      !companyDropDownRef.current.contains(event.target)
    ) {
      setOpenCompanyDropdown(false);
      setClientName("");
    }
  };
  useEffect(() => {
    if (openCompanyDropdown) {
      window.addEventListener("mousedown", handleCompanyDropDown);
    } else {
      window.removeEventListener("mousedown", handleCompanyDropDown);
    }
    return () => {
      window.removeEventListener("mousedown", handleCompanyDropDown);
    };
  }, [openCompanyDropdown]);

  const BpIcon = style("span")(() => ({
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxShadow:
      "dark" === "dark"
        ? "0 0 0 1px rgb(16 22 26 / 40%)"
        : "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "dark" === "dark" ? "#FFFFFF" : "#f5f8fa",
    backgroundImage:
      "dark" === "dark"
        ? "linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))"
        : "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    ".Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2,
    },
    "input:hover ~ &": {
      backgroundColor: "dark" === "dark" ? "#FFFFFF" : "#ebf1f5",
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background:
        "dark" === "dark" ? "rgba(57,75,89,.5)" : "rgba(206,217,224,.5)",
    },
  }));

  const BpCheckedIcon = style(BpIcon)({
    backgroundColor: "#00246A",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 0,
      height: 16,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""',
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3",
    },
  });
  const fetchComments = async (taskId) => {
    await axios({
      method: "post",
      url: `${API_URL}/api/User/FetchComments`,
      headers: {
        "Content-Type": "application/json",
      },
      data: {
        relatedtoid: taskId,
        type: "task",
      },
    }).then((response) => {
      setComments(response.data);
    });
  };

  const handleAddComments = () => {
    dispatch(AddComments(userid, taskid, val, "task", imgUrl, taggedUser));
    setTimeout(() => {
      fetchComments(taskid);
    }, 1000);
    setTaggedUser([]);
    setMessage("");
    setVal("");
    setImgUrl("");
  };

  useEffect(() => {
    if (taskid) {
      fetchComments(taskid);
    }
  }, [taskid]);

  const handleFileChange22 = (e) => {
    const target = e.target.files[0];
    let formData = new FormData();
    formData.append("file", target);

    axios
      .put(`${API_URL}/api/Files/UploadToS3`, formData)
      .then(function (response) {
        if (response !== null) {
          setImgUrl(response.data[0]);
        } else {
        }
      })
      .catch(function () {});
  };

  // asc add documents start.
  const ASC_HandleFileUpload = async (e) => {
    const fileUploaded = e.target.files[0];
    const formData = new FormData();
    formData.append("file", fileUploaded);
    try {
      const response = await axios.put(
        `${API_URL}/api/Files/UploadToS3`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );

      // if (response !== null) {
      //     setAdd_image(response.data[ 0 ]);
      //     setAttachMessage(
      //         target.name + " " + "File is Attached in comment box"
      //     );
      //     setShowError(true);
      // } else {
      // }
      setUploadedDocumentData(response.data);
      setUploadedDocument(response.data[0]);
      console.log("asc56 doc", response);

      // payload api set up.
      if (response) {
        setTimeout(() => {
          dispatch(
            AddDocToClients(id, userid, [
              {
                documentname: response.name,
                documentextension: response.type,
                documentcontent: "string",
                link: response.data[0],
                documentsize: response.size.toString(),
              },
            ]),
          );
        }, 1000);
      }
    } catch (error) {
      console.error(error);
      // setIsError(error.message);
    }
  };
  // asc add documents end.

  const handleFileChange = (data) => {
    setImgUrl(data.link);
    // setAttachMessage(`${data.name} File is Attached in comment box`);
  };

  const onButtonClick = () => {
    // inputFile.current.click();
  };

  useEffect(() => {
    if (TaskId) {
      setReRenderAPI(true);
      setShowModal(true);
      setTaskid(TaskId);
      setModalFunctionNoty("Notification");
    }
    setTimeout(() => {
      window.localStorage.removeItem("taskid");
    }, 5000);

    return () => {
      window.localStorage.removeItem("taskid");
    };
  }, []);

  const initialRender5 = React.useRef(true);

  React.useEffect(() => {
    if (!initialRender5.current) {
      if (comments != null) {
        if (comments.status == true) {
          setMinComments([]);
          var date = new Date(comments.data[0]?.timestamp)
            .toString()
            .split(" ");
          setcurrentDate(date);
          setShow(comments.data);
          setLength(comments.data.length);
          setFirstNameComm(comments.data[0]?.firstname);
          setLastNameComm(comments.data[0]?.lastname);
          for (var i = 0; i < 5; i++) {
            minComments.push(comments.data[i]);
          }
          setMaxComments(minComments.filter((item) => item != undefined));
        } else {
        }
      }
    } else {
      initialRender5.current = false;
    }
  }, [comments]);

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
      fontWeight: 400,
      color: "#333333",
      fontSize: "14px",
      background: "#F1F1F1 0% 0% no-repeat padding-box",
      boxShadow: "0px 3px 6px #00000029",
      opacity: 1,
    },
  }));
  const handleDownloadContact = (event, documentid, documentname) => {
    axios({
      method: "post",
      url: `${API_URL}/api/Files/DownloadToS3?documentid=` + documentid,
      responseType: "blob",
      headers: {
        "Content-Type": "application/json",
      },
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const document = window.document || {};
      const link = document.createElement("a");
      link.href = url;
      link.download = documentname;
      document.body.appendChild(link);
      link.click();
    });
  };

  const getNameAbbrivation = useMemo(() => {
    if (fullName) {
      const arr = fullName?.split(" ").filter((x) => Boolean(x));
      arr.forEach((x) => {
        return x.trim();
      });
      if (arr.length > 0) {
        if (arr.length === 1) {
          return arr[0].slice(0, 2)?.toUpperCase();
        } else if (arr.length > 1) {
          return `${arr[0].slice(0, 1)?.toUpperCase()}${arr[1]
            .slice(0, 1)
            ?.toUpperCase()}`;
        }
      }
    }
  }, [fullName]);

  const [companyDataSendtoModal, setCompanyDataSendtoModal] = useState(null);

  const handleOpenUpdateTaskPopup = (taskid) => {
    setModalFunction("update");
    setTaskid(taskid);
    setShowModal(true);
    setReRenderAPI(true);
  };

  const [taskIdforDelete, setTaskIdforDelete] = useState("");

  const handleDelete = (e) => {
    dispatch(deleteTask(taskIdforDelete));
    setShowPopup(false);
  };
  useEffect(() => {
    if (linkOrAddClientResponse.status === 200) {
      window.localStorage.setItem(
        "clientaddname",
        linkOrAddClientResponse?.data?.data?.clientname,
      );
      window.localStorage.setItem(
        "clientId2",
        linkOrAddClientResponse?.data?.data?.clientid,
      );
      setClientId(linkOrAddClientResponse?.data?.data?.clientid);
    }
  }, [linkOrAddClientResponse]);

  const addCompanyFuc = (event) => {
    setHideDropdown(true);
    if (
      !companyDropDownRef.current ||
      !companyDropDownRef.current.contains(event.target)
    ) {
      if (clientName) {
        localStorage.setItem("_ce", true);
        saveTempState();
        window.localStorage.setItem("clientaddname", clientName);
        window.localStorage.setItem("clientId2", clientId);
        history.push({
          pathname: clientId
            ? `/contactlist/add-company/${clientId}`
            : "/contactlist/add-company",
        });
      } else {
        setOpenCompanyDropdown(true);
        dispatch(FetchSearchClients(""));
      }
    }
  };
  useEffect(() => {
    if (searchClientResponse.status === 200) {
      if (searchClientResponse != null) {
        setSearchingClients(searchClientResponse?.data?.data);
        setHideDropdown(true);
        if (searchClientResponse?.data?.data?.length === 0) {
          setHideDropdown(false);
        }
      }
    }
  }, [searchClientResponse]);

  const handleEnterKeyPress = (e) => {
    if (e.key === "Enter") {
      dispatch(
        AddCompanyContact(
          userid,
          clientName,
          "", // Empty string as the default value for street
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
        ),
      );
      setOpenCompanyDropdown(false);
    }
  };

  useEffect(() => {
    if (openCompanyDropdown) {
      // Focus on the input element when the dropdown opens
      inputRef.current.focus();
    }
  }, [openCompanyDropdown]);

  const [val, setVal] = useState("");
  const [statusList, setStatusList] = useState([]);
  const [showNewTaskSystem, setShowNewTaskSystem] = useState(false);

  useEffect(() => {
    if (companyId === "28830f30-b321-4662-a576-f23451677742")
      return setShowNewTaskSystem(false);
    if (packageID === process.env.REACT_APP_IS_PREMIUM) {
      setShowNewTaskSystem(true);
    }
  }, [packageID, companyId]);

  useEffect(() => {
    dispatch(
      GlobalRequest({
        url: `${API_URL}/api/Stage/GetTaskStatusDropdownList`,
        method: "get",
        state: "getTaskStatusListRes",
        data: {},
      }),
    );
  }, []);

  useEffect(() => {
    if (getTaskStatusListRes?.status === true) {
      setStatusList(getTaskStatusListRes?.data);
    }
  }, [getTaskStatusListRes]);

  const [isBasicMember, setIsBasicMember] = useState(false);
  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );

  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      const isBasicPlan = getAppSideNavOptions.every(
        (x) =>
          x.packageName.toUpperCase() == "BASIC" &&
          x.packageId == process.env.REACT_APP_IS_BASIC,
      );
      setIsBasicMember(isBasicPlan);

      const isBuildingBlockVal = getAppSideNavOptions.every(
        (x) => x.packageId == process.env.REACT_APP_IS_PREMIUM,
      );
      setIsBuildingBlock(isBuildingBlockVal);
    }
  }, [getAppSideNavOptions]);

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      refActivityTimelineDD.current &&
      !refActivityTimelineDD.current.contains(event.target)
    ) {
      setFilterDrop(false);
    }

    if (
      PaymentDeadline_Popup_Ref.current &&
      !PaymentDeadline_Popup_Ref.current.contains(event.target)
    ) {
      setPaymentDeadlineOptions(false);
      setArrowOptionsRotate(false);
    }

    if (
      invoiceDetails_Popup_Ref.current &&
      !invoiceDetails_Popup_Ref.current.contains(event.target)
    ) {
      setInvoiceDetailsOptions(false);
      setArrowOptionsRotate2(false);
    }

    if (
      startingDate_Popup_Ref.current &&
      !startingDate_Popup_Ref.current.contains(event.target)
    ) {
      setCalendarIsOpen(false);
    }
    if (
      complitionDate_Popup_Ref.current &&
      !complitionDate_Popup_Ref.current.contains(event.target)
    ) {
      setCalendarIsOpen2(false);
    }

    if (
      Project_Popup_Ref.current &&
      !Project_Popup_Ref.current.contains(event.target)
    ) {
      setProjectShowOptions(false);
      setArrowOptionsRotate3(false);
    }

    if (
      projectManagerRef.current &&
      !projectManagerRef.current.contains(event.target)
    ) {
      setProjectManagerShow(false);
      setArrowOptionsRotate4(false);
    }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  useEffect(() => {
    dispatch(FetchPaymentDeadline());
    dispatch(GetInvoiceTypeForDropdown());
    dispatch(GetDiscountTypeForDropdown());
    dispatch(GetCreditTypeForDropdown());
    // dispatch(ProjectDropdown());
    dispatch(FetchProjectClient(id));
    dispatch(FetchDocsClientById(id));
    // dispatch(FetchClientTasks(clientId, projectId));
    dispatch(FetchActiveUser(companyids));
  }, []);

  useEffect(() => {
    if (id) {
      // onClick={params.id ? handleUpdateTeam : handleAddTeam}
      dispatch(FetchClientContactsByclientId(id));
      dispatch(ClientActivityTimeline(id, selectedValue));
    }
  }, [id, selectedValue]);

  useEffect(() => {
    if (addNewClientRes?.status === true) {
      // history.goBack();
      dispatch(AddDocToClients(addNewClientRes?.data, userid, contactDocsList));
      dispatch({
        type: ADD_NEW_CLIENT,
        data: {},
      });
    }
  }, [addNewClientRes]);

  useEffect(() => {
    if (updateClientDetailsRes?.status === true) {
      // history.goBack();
      history.push("/company-list");
      dispatch({
        type: UPDATE_CLIENT_DETAILS,
        data: {},
      });
    }
  }, [updateClientDetailsRes]);

  useEffect(() => {
    if (fetchPaymentDeadline?.status === true) {
      setPaymentDeadlineData(fetchPaymentDeadline?.data);
    }
  }, [fetchPaymentDeadline]);

  useEffect(() => {
    if (getInvoiceTypeDropDownRes?.status === true) {
      setInvoiceDetailsData(getInvoiceTypeDropDownRes?.data);
    }
  }, [getInvoiceTypeDropDownRes]);

  useEffect(() => {
    if (getDiscountTypeDropDownRes?.status === true) {
      setDiscountData(getDiscountTypeDropDownRes?.data);
    }
  }, [getDiscountTypeDropDownRes]);

  useEffect(() => {
    if (fetchClientContactsByClientIdRes?.status === true) {
      setContactsLinkData(fetchClientContactsByClientIdRes?.data);
    }
  }, [fetchClientContactsByClientIdRes]);

  useEffect(() => {
    if (getCreditTypeDropDownRes?.status === true) {
      setCreditData(getCreditTypeDropDownRes?.data);
      setCreditName(getCreditTypeDropDownRes?.data[0].creditTypeName);
      setCreditID(getCreditTypeDropDownRes?.data[0].creditTypeId);
    }
  }, [getCreditTypeDropDownRes]);

  useEffect(() => {
    if (fetchProjectClientRes?.status === true) {
      setProjectData(fetchProjectClientRes?.data);
    }
  }, [fetchProjectClientRes]);

  useEffect(() => {
    if (fetchActiveUser.status === true) {
      setProjectManagerData(fetchActiveUser.data);
    }
  }, [fetchActiveUser]);

  useEffect(() => {
    if (deleteMultipleAdressRes.status === true) {
      dispatch(FetchClientById(id)); // New fetch company API.
    }
  }, [deleteMultipleAdressRes]);

  const [activityTimeLine, setActivityTimeLine] = useState([]);

  useEffect(() => {
    if (id && clientActivityTimelineRes.status === true) {
      setActivityTimeLine(clientActivityTimelineRes.data);
    }
  }, [clientActivityTimelineRes]);

  // for pagination start
  const [perPage, setPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  // for pagination end

  // asc company state start.
  const [companyName, setCompanyName] = useState("");
  const [companyID, setCompanyID] = useState("");

  // asc Assignee state start👇.
  const [openAssigneeModal, setOpenAssigneeModal] = useState(false);
  const [coWorkerData, setCoWorkerData] = useState([]);
  // const [openAssigneeModal, setOpenAssigneeModal] = useState(false);
  // asc Assignee state end👆.

  // asc payment state start👇.
  const [arrowOptionsRotate, setArrowOptionsRotate] = useState(false);
  const [paymentDeadlineOptions, setPaymentDeadlineOptions] = useState(false);
  const [paymentOthersOptions, setPaymentOthersOptions] = useState(false);
  const [paymentDeadlineData, setPaymentDeadlineData] = useState([]);
  const [paymentDeadlineid, setPaymentDeadlineid] = useState("");
  const [paymentDeadline, setPaymentDeadline] = useState("");
  const [dueDays, setDueDays] = useState("");
  const [paymentDescription, setPaymentDescription] = useState("");
  // asc payment state end👆.

  // asc invoice state start👇.
  const [arrowOptionsRotate2, setArrowOptionsRotate2] = useState(false);
  const [invoiceDetailsOptions, setInvoiceDetailsOptions] = useState(false);
  const [invoiceOthersOptions, setInvoiceOthersOptions] = useState(false);
  const [invoiceDetailsData, setInvoiceDetailsData] = useState([]);
  const [invoiceDetailsid, setInvoiceDetailsid] = useState("");
  const [invoiceDetails, setInvoiceDetails] = useState("");
  const [invoiceDueDays, setInvoiceDueDays] = useState("");
  const [invoiceDescription, setInvoiceDescription] = useState("");
  // asc invoice state end👆.

  // asc discount state start👇.
  const [showDiscountOption, setShowDiscountOption] = useState(false);
  const [discountData, setDiscountData] = useState([]);
  const [discountID, setDiscountID] = useState("");
  const [discountName, setDiscountName] = useState("");
  const [searchDiscountName, setSearchDiscountName] = useState("");
  // asc discount state end👆.

  // asc credit state start👇.
  const [showCreditOptions, setShowCreditOptions] = useState(false);
  const [creditName, setCreditName] = useState("");
  const [creditID, setCreditID] = useState("");
  const [creditData, setCreditData] = useState([]);
  // asc credit state end👆.

  // const [companysContact, setCompanysContact] = useState(false);
  const [active, setActive] = useState(true);
  const [mainAddress, setMainAddress] = useState("");
  const [mainAddressSendID, setMainAddressSendID] = useState();
  const [singleEmailSendID, setSingleEmailSendID] = useState();
  const [generalEmail, setGeneralEmail] = useState("");
  const [contactTelephone, setContactTelephone] = useState("");
  const [officeTelephone, setOfficeTelephone] = useState("");
  const [kvkNumber, setKvkNumber] = useState("");
  const [url, setUrl] = useState("");
  const [vatNumber, setVatNumber] = useState("");
  const [bankAccount, setBankAccount] = useState("");
  const [bankAccountBlocked, setBankAccountBlocked] = useState("");
  const [totalActiveProjects, setTotalActiveProjects] = useState("");
  const [creditLimit, setCreditLimit] = useState("");
  const [startingDate, setStartingDate] = useState(new Date());
  const [endingDate, setEndingDate] = useState(new Date());
  const [vatShifted, setVatShifted] = useState(false);
  const [insurance, setInsurance] = useState(false);

  const [linkedContactsDelShow, setLinkedContactsDelShow] = useState(false);
  const [contactsLinkData, setContactsLinkData] = useState([]);
  const [linkedContactID, setLinkedContactID] = useState("");

  const [calendarIsOpen, setCalendarIsOpen] = useState(false);
  const [calendarIsOpen2, setCalendarIsOpen2] = useState(false);
  // asc company state end.

  // companys contacts State start
  const [companysContsEmail, setCompanysContsEmail] = useState("");
  const [companysContsMobile, setCompanysContsMobile] = useState("");
  const [companysContsOfficeTelNo, setCompanysContsOfficeTelNo] = useState("");
  const [companysContsBirthDate, setCompanysContsBirthDate] = useState("");
  const [companysContsRelations, setCompanysContsRelations] = useState("");
  const [companysContsNotes, setCompanysContsNotes] = useState("");
  // companys contacts State end

  // main Address popup State start
  const [mainAddressPopupShow, setMainAddressPopupShow] = useState(false);
  const [mainAddressLabelOptions, setMainAddressLabelOptions] = useState(false);
  const [mainAddressOptionData, setMainAddressOptionData] = useState([
    {
      mainAddName: "Main address",
      mainAddID: "1",
    },
    {
      mainAddName: "Office address",
      mainAddID: "2",
    },
    {
      mainAddName: "Headquarter address",
      mainAddID: "3",
    },
    {
      mainAddName: "Warehouse address",
      mainAddID: "4",
    },
    {
      mainAddName: "Other address",
      mainAddID: "5",
    },
  ]);
  const [mainAddressMultiData, setMainAddressMultiData] = useState([]);
  const [mainAddressName, setMainAddressName] = useState("");
  const [mainAddressID, setMainAddressID] = useState("");
  const [enterMainAddress, setEnterMainAddress] = useState("");
  const [enterMainAddressParts, setEnterMainAddressParts] = useState({
    street: "",
    city: "",
    state: "",
    pinCode: "",
    country: "",
  });
  // main Address popup State end

  // General email popup State start
  const [genEmailPopupShow, setGenEmailPopupShow] = useState(false);
  const [genEmailLabelOptions, setGenEmailLabelOptions] = useState(false);
  const [genEmailOptionData, setGenEmailOptionData] = useState([
    {
      genMailName: "General email",
      genMailID: "1",
    },
    {
      genMailName: "Financial email",
      genMailID: "2",
    },
    {
      genMailName: "Operational email",
      genMailID: "3",
    },
    {
      genMailName: "Other email",
      genMailID: "4",
    },
  ]);
  const [genEmailMultiData, setGenEmailMultiData] = useState([]);
  const [genEmailName, setGenEmailName] = useState("");
  const [genEmailID, setGenEmailID] = useState("");
  const [enterGenEmail, setEnterGenEmail] = useState("");
  const [validemail, setValidemail] = useState(false);

  const isGeneralEmailValid = useMemo(() => {
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (
      generalEmail &&
      !pattern.test(generalEmail) &&
      generalEmail.trim() !== ""
    )
      return true;
    else return false;
  }, [generalEmail]);

  const checkEmailValidation = (e) => {
    // const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const emails = e.target.value;
    if (!emailPattern.test(emails) && emails.trim() !== "") {
      setValidemail(true);
    } else {
      setValidemail(false);
    }
  };
  // General email popup State end

  // according to project start
  const [projectData, setProjectData] = useState([]);
  const [projectShowOptions, setProjectShowOptions] = useState(false);
  const [arrowOptionsRotate3, setArrowOptionsRotate3] = useState(false);
  const [searchProjectName, setSearchProjectName] = useState("");
  const [projectName, setProjectName] = useState("");
  const [projectid, setProjectid] = useState("");
  // according to project end

  // account manager state start
  const [projectManagerShow, setProjectManagerShow] = useState(false);
  const [projectManagerData, setProjectManagerData] = useState([]);
  const [searchProjectManager, setSearchProjectManager] = useState("");
  const [arrowOptionsRotate4, setArrowOptionsRotate4] = useState("");
  const [projectManagerName, setProjectManagerName] = useState("");
  const [projectManagerID, setProjectManagerID] = useState("");
  const [projectManagerImage, setProjectManagerImage] = useState("");
  const [selectedManagerImg, setSelectedManagerImg] = useState("");
  const [selectedManagerFName, setSelectedManagerFName] = useState("");
  const [selectedManagerLName, setSelectedManagerLName] = useState("");
  // account manager state end

  const [basicInformationDiv, setBasicInformationDiv] = useState(true);
  const [generalInformationDiv, setGeneralInformationDiv] = useState(true);
  const [financialInformationDiv, setFinancialInformationDiv] = useState(true);

  const [arrowOptionsRotate5, setArrowOptionsRotate5] = useState(false);
  const [arrowOptionsRotate6, setArrowOptionsRotate6] = useState(false);
  const [arrowOptionsRotate7, setArrowOptionsRotate7] = useState(false);

  const [uploadedDocumentData, setUploadedDocumentData] = useState([]);
  const [uploadedDocument, setUploadedDocument] = useState([]);

  const [allProjectTasks, setAllProjectTasks] = useState(true);

  useEffect(() => {
    if (isUpdating) {
      if (allProjectTasks) {
        dispatch(FetchClientTasks(id, "00000000-0000-0000-0000-000000000000"));
      } else {
        // dispatch(FetchClientTasks(id, projectid));
      }
    }
  }, [isUpdating, allProjectTasks, id]);

  const [companyAddress, setCompanyAddress] = useState("");
  const [companyAddressParts, setCompanyAddressParts] = useState({
    street: "",
    city: "",
    state: "",
    pinCode: "",
    country: "",
  });
  const [mainAddressParts, setMainAddressParts] = useState({
    street: "",
    city: "",
    state: "",
    pinCode: "",
    country: "",
  });
  const [zipCode, setZipCode] = useState("");

  // postal Code start.
  const getAddressParts = (parsed = {}) => ({
    street: parsed.streetWithNumber || parsed.street || "",
    city: parsed.city || "",
    state: parsed.state || "",
    pinCode: parsed.pinCode || parsed.postalCode || "",
    country: parsed.country || "",
  });

  // for main Address
  const handleAddressSelectMain_old = async (address) => {
    const parsed = await parseGooglePlace(address);
    setMainAddress(parsed.formattedAddress);
    setZipCode(parsed.postalCode);
    setMainAddressParts(getAddressParts(parsed));
  };

  // for main Address👇
  // ASC address with postal code start
  const handleAddressSelectMain = async (address) => {
    try {
      const parsed = await parseGooglePlace(address);

      setMainAddress(parsed.formattedAddress); // Store full Google address.
      setZipCode(parsed.postalCode); // Store only postal code.
      setMainAddressParts(getAddressParts(parsed));
      console.log("final address", parsed.formattedAddress);
    } catch (error) {
      console.error("Error fetching address details:", error);
    } finally {
      console.log("Address API Call Completed");
    }
  };
  // ASC address with postal code end

  // for main multiple Address
  const handleMultiAddressSelectMain_old = async (address) => {
    const parsed = await parseGooglePlace(address);
    setEnterMainAddress(parsed.formattedAddress);
    setZipCode(parsed.postalCode);
    setEnterMainAddressParts(getAddressParts(parsed));
  };

  // for main multiple Address👇
  // ASC address with postal code start
  const handleMultiAddressSelectMain = async (address) => {
    try {
      const parsed = await parseGooglePlace(address);

      setEnterMainAddress(parsed.formattedAddress); // Store full Google address.
      setZipCode(parsed.postalCode); // Store only postal code.
      setEnterMainAddressParts(getAddressParts(parsed));
      console.log("final address", parsed.formattedAddress);
    } catch (error) {
      console.error("Error fetching address details:", error);
    } finally {
      console.log("Address API Call Completed");
    }
  };
  // ASC address with postal code end

  // for comapany Address
  const handleAddressSelect_old = async (address) => {
    const parsed = await parseGooglePlace(address);
    setCompanyAddress(parsed.formattedAddress);
    setZipCode(parsed.postalCode);
    setCompanyAddressParts(getAddressParts(parsed));
  };

  // for comapany Address👇
  // ASC address with postal code start
  const handleAddressSelect = async (address) => {
    try {
      const parsed = await parseGooglePlace(address);

      setCompanyAddress(parsed.formattedAddress); // Store full Google address.
      setZipCode(parsed.postalCode); // Store only postal code.
      setCompanyAddressParts(getAddressParts(parsed));
      setMainAddress(parsed.formattedAddress);
      setMainAddressParts(getAddressParts(parsed));
      dispatch(ClientAddressCheck(parsed.formattedAddress));
      console.log("final address", parsed.formattedAddress);
    } catch (error) {
      console.error("Error fetching address details:", error);
    } finally {
      console.log("Address API Call Completed");
    }
  };
  // ASC address with postal code end
  // postal Code end.

  useEffect(() => {
    if (existingCompanyAddressRes?.status === true) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: existingCompanyAddressRes?.message,
        },
        false,
      );

      dispatch({
        type: EXISTING_COMPANY_ADDRESS,
        data: {},
      });
    }
  }, [existingCompanyAddressRes]);

  const handleInputChange = (index, field, value) => {
    const newItems = [...genEmailMultiData];
    newItems[index][field] = value;
    // setPersonalTaskData(newItems);

    console.log("asc56 item,", newItems);

    let ascTaskid = newItems[index].taskID;
    let ascTaskChecked = newItems[index].checked;
    let ascTaskDueDateTime = newItems[index].taskDate;

    setGenEmailMultiData(newItems);
  };

  // for combine Address 👇
  console.log("asc56 addre", mainAddress);
  console.log("asc56 addre2", mainAddressMultiData);
  // let combineAddressArray = [mainAddress, ...mainAddressMultiData];
  // let combineAddressArray = [{ asc: mainAddress }, ...mainAddressMultiData];
  let combineAddressArray = [
    {
      asc_EnterAddressName: mainAddress,
      asc_MainAddName: "",
      asc_MultiAdressID: mainAddressSendID,
      ...mainAddressParts,
    },
    ...mainAddressMultiData,
  ];
  console.log("asc56 addre33", combineAddressArray);

  // for combine email 👇
  let combineEmailArray = [
    {
      asc_EmailAddress: generalEmail,
      asc_EmailName: "",
      asc_MultiEmailID: singleEmailSendID,
    },
    ...genEmailMultiData,
  ];
  console.log("asc56 email", combineEmailArray);

  // company AddNewClient API payload start👇.
  let basicInformation = {
    // address: [
    //   {
    //     // address: mainAddress,
    //     type: combineAddressArray.map((x) => x.asc_MainAddName),
    //     address: combineAddressArray.map((x) => x.asc_EnterAddressName),
    //   },
    // ],

    address: combineAddressArray
      .filter(
        (z) =>
          z.asc_EnterAddressName !== "" && z.asc_EnterAddressName !== undefined,
      )
      .map((x) => ({
        type: x.asc_MainAddName,
        address: x.asc_EnterAddressName,
        addressId: x.asc_MultiAdressID,
        street: x.street || "",
        city: x.city || "",
        state: x.state || "",
        pinCode: x.pinCode || "",
        country: x.country || "",
      })),

    // email: [
    //   {
    //     // address: generalEmail,
    //     type: combineEmailArray.map((x) => x.asc_EmailName),
    //     address: combineEmailArray.map((x) => x.asc_EmailAddress),
    //   },
    // ],

    email: combineEmailArray
      .filter(
        (z) => z.asc_EmailAddress !== "" && z.asc_EmailAddress !== undefined,
      )
      .map((x) => ({
        type: x.asc_EmailName,
        address: x.asc_EmailAddress,
        addressId: x.asc_MultiEmailID,
      })),

    contactTelephone: contactTelephone,
    officeTelephone: officeTelephone,
  };

  let generalInformation = {
    kvkNumber: kvkNumber,
    url: url,

    accountManager: {
      userId: projectManagerID || "00000000-0000-0000-0000-000000000000",
      profileImage: selectedManagerImg,
    },
  };

  let financialInformation = {
    vatNumber: vatNumber,
    paymentTerms: paymentDeadline,
    // paymentTerms: paymentDeadlineid,
    bankAccount: bankAccount,
    bankAccountBlockedForTax: bankAccountBlocked,
    totalActiveProjects: totalActiveProjects,
    creditTypeId: creditID || "00000000-0000-0000-0000-000000000000",
    creditLimit: creditLimit,
    startingDate: startingDate,
    endingDate: endingDate,
    invoiceDetailsTypeId:
      invoiceDetailsid || "00000000-0000-0000-0000-000000000000",
    vatShifted: vatShifted,
    insurance: insurance,
    discountTypeId: discountID || "00000000-0000-0000-0000-000000000000",
    notes: notes,
  };
  // company AddNewClient API payload end.

  const [addContactWarning, setAddContactWarning] = useState(false);

  useEffect(() => {
    if (addContactWarning) {
      handleGeneralNotification(
        {
          notificationType: "CUSTOM",
          text: "You have to add contact first.",
        },
        false,
      );
    }
  }, [addContactWarning]);

  // company name exist or not start
  const [isTypeCompanyName, setIsTypeCompanyName] = useState(false);
  useEffect(() => {
    if (isTypeCompanyName) {
      dispatch(ClientNameExistOrNot({ clientname: companyName }));
    }
  }, [dispatch, isTypeCompanyName]);

  const [isValueExists, setIsValueExists] = useState(false);

  useEffect(() => {
    if (clientNameExistOrNotRes.status === true) {
      if (
        companyName &&
        companyName === clientNameExistOrNotRes?.data[0]?.clientname &&
        companyName !== fetchClientByIdRes?.data?.companyName
      ) {
        setIsValueExists(true);
      } else {
        setIsValueExists(false);
      }
    } else {
      setIsValueExists(false);
    }
  }, [clientNameExistOrNotRes]);

  return (
    <>
      <Header
        leftComponent={
          <div className="flex-wrap gap-4 d-flex align-items-baseline">
            <div
              className="projectText"
              onClick={() => {
                history.push("/company-list");
              }}
            >
              {/* Company */}
              {t("Company")}
            </div>
            <div
              className="pt-2 d-flex pe-3 d-none"
              style={{ background: "#FFFFFF" }}
            >
              <p className="pt-1 ps-4 projectText2">
                {/* Project */}
                {/* {FetchTranslationList[55]?.translation} */}
              </p>
              {/* <p className="pt-3 projectID ps-5"> ID &nbsp;{projectIdCode} </p> */}
            </div>
          </div>
        }
      />

      {showPopup && (
        <TasDelete
          animation={true}
          handleDelete={handleDelete}
          show={showPopup}
          onHide={() => setShowPopup(false)}
        />
      )}
      <RouteLeavingGuard
        when={changeComp !== ""}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          // This case it blocks the navigation when:
          // 1. the login form is dirty, and
          // 2. the user is going to 'sign-up' scene.
          //    (Just an example, in real case you might
          //     need to block all location regarding this case)
          if (changeComp !== "") {
            if (
              ![
                "/add-contact",
                `/add-company/${id}`,
                "/NewInvoice",
                "/add-purchasing-order",
                "/chat",
              ].includes(location.pathname)
            ) {
              if (location.pathname === "/contact-list" && !canGoBack) {
                return true;
              } else if (location.pathname === "/contact-list" && canGoBack)
                return false;
              return true;
            }
          }
          return false;
        }}
      />

      {reRenderAPI && (
        <AddTaskModal
          val={val}
          setVal={setVal}
          showModal={showModal}
          defaultContactId={id}
          modalFunctionNoty={modalFunctionNoty}
          taskid={taskid}
          setTaskid={setTaskid}
          popups={popups}
          setPopups={setPopups}
          statusList={statusList}
          showNewTaskSystem={showNewTaskSystem}
          isBasicMember={isBasicMember}
          isBuildingBlock={isBuildingBlock}
          setShowModal={(show, reload) => {
            setShowModal(false);
            setActiveHeading("3");
            window.localStorage.removeItem("taskid");
            dispatch(EmptyProductPart());
            if (reload) {
              dispatch(FetchClientTasks(id, projectid));
            }
          }}
          setComments={setComments}
          modalFunction={modalFunction}
          setModalFunction={setModalFunction}
          companyDataSendtoModal={companyDataSendtoModal}
          setCompanyDataSendtoModal={setCompanyDataSendtoModal}
          setEnableComm={setEnableComm}
          setShowcmnt={setShowcmnt}
          enablecomm={enablecomm}
          showcmnt={showcmnt}
          setMessage={setMessage}
          message={message}
          onButtonClick={onButtonClick}
          handleFileChange={handleFileChange}
          handleAddComments={handleAddComments}
          setTaggedUser={setTaggedUser}
          taggedUser={taggedUser}
          maxComments={maxComments}
          show={show}
          length={length}
          setLength={setLength}
          setShow={setShow}
          imgUrl={imgUrl}
          setImgUrl={setImgUrl}
          setMaxComments={setMaxComments}
          from={from}
          searchText={searchText}
        />
      )}
      <section className="main-add-contact">
        <div className="ps-4 pe-4">
          <Row>
            <Col xl={8} lg={7} md={6} sm={12}>
              <p
                className="fw-bold mt-2 "
                style={{
                  fontSize: "20px",
                  color: "#333333",
                }}
              >
                {/* {FetchTranslationList[0]?.translation} */}
              </p>
            </Col>
            <Col
              xl={4}
              lg={5}
              md={6}
              sm={12}
              className="add-col-item upperADD_CancelBtnShoeHide"
              style={{ position: "relative" }}
            >
              <div
                className="d-flex cancel_cont_btn"
                onClick={() => {
                  handelCancel();
                }}
                style={{ borderRadius: "12px" }}
              >
                <p className="fw-bold mb-0" style={{ color: "#5b5b5b" }}>
                  {/* cancel */}
                  {t("Cancel")}
                </p>
              </div>
              {removeaddbtn ? (
                <div
                  className="d-flex add-buttons ms-4"
                  style={{
                    borderRadius: "12px",
                    pointerEvents:
                      existingCompanyAddressRes?.status === true ||
                      isValueExists
                        ? "none"
                        : "",
                  }}
                  // onClick={handleContactAdd}
                  onClick={() => {
                    if (path === "/add-company") {
                      companyName !== "" && setAddContactWarning(true);
                      setErrorfull(true);
                    } else {
                      handleContactAdd();
                    }
                  }}
                >
                  <p className="fw-bold mb-0">
                    {isUpdating
                      ? // ? "Confirm"
                        t("Confirm")
                      : t("Add")}
                  </p>
                </div>
              ) : (
                <div
                  className="d-flex add-buttons ms-4"
                  style={{
                    borderRadius: "12px",
                    pointerEvents:
                      existingCompanyAddressRes?.status === true ||
                      isValueExists
                        ? "none"
                        : "",
                  }}
                  // onClick={handleContactAdd}
                  onClick={() => {
                    if (path === "/add-company") {
                      companyName !== "" && setAddContactWarning(true);
                      setErrorfull(true);
                    } else {
                      handleContactAdd();
                    }
                  }}
                >
                  <p className="fw-bold mb-0">
                    {isUpdating
                      ? // ? "Confirm"
                        t("Confirm")
                      : t("Add")}
                  </p>
                </div>
              )}
            </Col>
          </Row>
        </div>
        <section className="add-contact-info-container ps-4 pe-4">
          <div
            className={
              roleAccess === process.env.REACT_APP_IS_VIEWER
                ? "pointerEvent column-1-info"
                : "column-1-info"
            }
            style={{ minHeight: "auto", maxHeight: "none" }}
          >
            <div className="contact-type" style={{ height: "40px" }}>
              <div className="contact-type-grid">
                <span
                  className={
                    mainContactType === "Client" ? "active-contact" : "contact"
                  }
                  style={
                    mainContactType === "Client"
                      ? {
                          backgroundColor:
                            companyId === "28830f30-b321-4662-a576-f23451677733"
                              ? "#C6BE00"
                              : companyId ===
                                  "28830f30-b321-4662-a576-f23451677744"
                                ? "#9BE6E4"
                                : companyId ===
                                    "28830f30-b321-4662-a576-f23451677755"
                                  ? "#D8BD90"
                                  : " ",
                          color: "white",
                        }
                      : {}
                  }
                  onClick={() => {
                    if (isNotRole(ROLES.VIEWER)) {
                      // setContactType("Client");
                      setMainContactType("Client");
                      setChangeComp("Client");
                    }
                  }}
                >
                  {t("Client")}
                </span>
                <span
                  style={
                    mainContactType === "Other"
                      ? {
                          backgroundColor:
                            companyId === "28830f30-b321-4662-a576-f23451677733"
                              ? "#C6BE00"
                              : companyId ===
                                  "28830f30-b321-4662-a576-f23451677744"
                                ? "#9BE6E4"
                                : companyId ===
                                    "28830f30-b321-4662-a576-f23451677755"
                                  ? "#D8BD90"
                                  : " ",
                          // backgroundColor: `${primaryColor}`,
                          color: "white",
                        }
                      : {}
                  }
                  onClick={() => {
                    if (isNotRole(ROLES.VIEWER)) {
                      // setContactType("Other");
                      setMainContactType("Other");
                      setChangeComp("other");
                    }
                  }}
                  className={
                    mainContactType === "Other" ? "active-contact" : "contact"
                  }
                >
                  {t("Other")}
                </span>
              </div>
            </div>
            <div className="d-flex flex-column align-items-center justify-content-center">
              <div
                className="profile-image-details image-styles"
                onDragOver={(e) => {
                  e.preventDefault();
                }}
                onDragLeave={(e) => {
                  e.preventDefault();
                }}
                onDrop={(e) => {
                  e.preventDefault();

                  const droppedFile = Array.from(e.dataTransfer.files);
                  if (droppedFile) {
                    profileUpload(droppedFile[0]);
                  }
                }}
              >
                <input
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  ref={hiddenFileInput}
                  onChange={(event) => {
                    const fileUploaded = event.target.files[0];
                    if (fileUploaded) {
                      const image = URL.createObjectURL(fileUploaded);
                      setChangeComp(image);
                      setImageUrl(image);
                      profileUpload(fileUploaded);
                    } else {
                      return;
                    }
                  }}
                />
                {imageUrl && isUpdating ? (
                  <div
                    id="profile-image"
                    className="profile-image"
                    style={{
                      border: `7px ${primaryColor} solid`,
                      marginTop: "5rem",
                    }}
                  >
                    <img
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "100%",
                        objectFit: "cover",
                      }}
                      src={imageUrl}
                      alt=""
                    />
                  </div>
                ) : imageUrl === "" && isUpdating ? (
                  <div
                    id="profile-image"
                    className="profile-image"
                    style={{
                      // border: "1px #00256E dashed",
                      marginTop: "6rem",
                    }}
                  >
                    <div
                      style={{
                        borderRadius: "50%",
                        backgroundColor: "#95A7C6",
                        fontSize: "48px",
                        fontWeight: 800,
                        height: "100%",
                        color: "#FFFFFF",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textTransform: "capitalize",
                      }}
                    >
                      {/* {getNameAbbrivation} */}
                      {companyName.split(" ")[0]?.[0]}{" "}
                      {companyName?.split(" ")[1]?.[0]}
                    </div>
                  </div>
                ) : imageUrl && !isUpdating ? (
                  <div
                    id="profile-image"
                    className="profile-image"
                    style={{
                      border: `7px ${primaryColor} solid`,
                      marginTop: "6rem",
                    }}
                  >
                    <img
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "100%",
                        objectFit: "cover",
                      }}
                      src={imageUrl}
                      alt=""
                    />
                  </div>
                ) : (
                  <div>
                    <div
                      id="profile-image"
                      className="profile-image"
                      style={{
                        marginTop: "4rem",
                        cursor: "pointer",
                        border: "1px #00256E dashed",
                      }}
                    >
                      <img
                        src={Addiocn}
                        alt="add"
                        style={{
                          marginTop: "40px",
                          fontSize: "clamp(13px,1.1vw,2vw)",
                        }}
                        onClick={handleClick}
                      />
                      <br />
                      <p
                        className="company"
                        id="company"
                        style={{ color: "#00246A", opacity: "1" }}
                        onClick={handleClick}
                      >
                        {/* Add or drag
                        <br />a photo */}
                        {t("Add or drag a photo").slice(0, 7)}
                        <br />
                        {t("Add or drag a photo").slice(7)}
                      </p>
                    </div>
                  </div>
                )}

                {imageUrl && (
                  <>
                    <div className="mt-3">
                      <span
                        className="change"
                        style={{
                          color: "#A5A5A5",
                          fontSize: "clamp(11px, 0.729vw, 1.2vw)",
                          cursor: "pointer",
                        }}
                        onClick={handleClick}
                      >
                        {"Change"}
                      </span>
                      <span className="mt-3">
                        <img
                          src={Binclr}
                          alt="bin"
                          className="change"
                          style={{
                            fontSize: "1rem",
                            marginLeft: "0.2rem",
                            width: "1.098vw",
                            height: "1.245vw",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            if (imageUrl) {
                              setDeleteModalShow(true);
                            }
                          }}
                        />
                      </span>
                    </div>
                  </>
                )}
                {isUpdating && !imageUrl && (
                  <>
                    <div className="mt-3">
                      <span
                        className="change"
                        style={{
                          cursor: "pointer",
                          color: "#A5A5A5",
                          fontSize: "clamp(11px, 0.729vw, 1.2vw)",
                        }}
                        onClick={handleClick}
                      >
                        {/* Add Picture */}
                        {t("Add Picture")}
                      </span>
                    </div>
                  </>
                )}
              </div>
              <div className="d-flex">
                <input
                  type="text"
                  // className="input-name-style"
                  className={
                    errorfull
                      ? "input-name-style2 mt-5"
                      : roleAccess === process.env.REACT_APP_IS_VIEWER
                        ? "pointerEvent input-name-style mt-5"
                        : "input-name-style mt-5"
                  }
                  // value={fullName}
                  value={companyName}
                  onChange={(e) => {
                    // setFullName(
                    //   e.target.value.charAt(0).toUpperCase() +
                    //     e.target.value.slice(1)
                    // );
                    setCompanyName(e.target.value);
                    setChangeComp(e.target.value);
                    setIsTypeCompanyName(e.target.value);
                    setErrorfull(false);
                  }}
                  // placeholder="Add Company Name"
                  placeholder={t("Add Company name")}
                />
                <span className="mandatory-sign d-flex align-items-end">*</span>
              </div>

              {isValueExists && (
                <div className="errmsg">
                  Client Name Already Exist
                  {/* {FetchTranslationList[66]?.translation} */}
                </div>
              )}

              {/* company Address start */}
              <div className="position-relative">
                <GooglePlacesAutocomplete
                  debounce={800}
                  renderInput={(props) => (
                    <textarea
                      rows="4"
                      className="DeliveryInput bordered-inputs px-2"
                      cols="50"
                      style={{
                        border: "none",
                        width: "100%",
                        // overflow: "hidden",
                        height: "75px",
                        textAlign: "center",
                      }}
                      {...props}
                      onChange={(e) => {
                        props.onChange?.(e);
                        setCompanyAddressParts({
                          street: "",
                          city: "",
                          state: "",
                          pinCode: "",
                          country: "",
                        });
                        setMainAddressParts({
                          street: "",
                          city: "",
                          state: "",
                          pinCode: "",
                          country: "",
                        });
                      }}
                      // placeholder={"Company Address"}
                      placeholder={t("Company Address")}
                    />
                  )}
                  onSelect={(e) => {
                    handleAddressSelect(e);
                    // setDeliveryAddressWarning(false);
                    setChangeComp("asc");
                  }}
                  initialValue={companyAddress}
                  // placeholder={"Company Address"}
                  placeholder={t("Company Address")}
                />
              </div>
              {/* company Address end */}

              {/* clientDescription field start */}
              <div
                className="asc-input-containe-r mx-2"
                id="ascInput"
                style={{
                  position: "relative",
                  marginTop: "5px",
                }}
              >
                <label
                  style={{
                    marginTop: "5px",
                  }}
                  className="asc-label-top projectNameText"
                >
                  {t("Description")}
                  {/* {FetchTranslationList[111]?.translation} */}
                </label>

                <textarea
                  style={{
                    marginTop: "5px",
                    height: "70px",
                  }}
                  id="w3review"
                  name="w3review"
                  rows="4"
                  cols="50"
                  // placeholder="clientDescription"
                  className="notesInput ps-3 bordered-inputs"
                  value={clientDescription}
                  onChange={(e) => {
                    setClientDescription(e.target.value);
                    setChangeComp(e.target.value);
                  }}
                ></textarea>
              </div>
              {/* clientDescription field end */}

              <div className="">
                <div className="actionHeadTxt pt-4 d-flex align-items-center gap-2">
                  {/* <p className="mb-1">Active?</p> */}
                  <label htmlFor="asc_purch_Switch" className="">
                    {/* Active? */}
                    {t("Active")} ?
                  </label>
                  <input
                    type="checkbox"
                    id="asc_purch_Switch"
                    className="asc_pursh_Checkbox"
                    // disabled={}
                    checked={active}
                    onChange={(e) => {
                      setActive(!active);
                    }}
                  />
                  <label
                    htmlFor="asc_purch_Switch"
                    className="asc_purch_Toggle"
                  >
                    {/* <p className=''>ASC</p> */}
                  </label>
                </div>
              </div>

              <div className="column-1-options px-3 mt-5">
                <div>
                  <span
                    className="responsive-font-14 pointer"
                    style={{
                      position: "relative",
                      fontSize: "14px",
                      fontWeight: "600",
                      // color: path === "/add-company" ? "" : "#333333",
                      // pointerEvents: path === "/add-company" && "none",
                      color:
                        (path === "/add-company" && addContactWarning) ||
                        path.startsWith("/add-company/")
                          ? "#333333"
                          : "",

                      pointerEvents:
                        (path === "/add-company" && addContactWarning) ||
                        path.startsWith("/add-company/")
                          ? ""
                          : "none",
                    }}
                    onClick={() => {
                      if (path === "/add-company") {
                        handleContactAdd();
                      }

                      setTimeout(() => {
                        history.push({
                          pathname: "/add-contact",
                          state: {
                            from: "Company_Screen",
                            historyCompanyName: companyName,
                            historyCompanyID: companyID,
                            historyCompanysContact: true,
                          },
                        });
                      }, 1000);

                      // setCompanysContact(true);
                    }}
                  >
                    <img
                      alt="img2email"
                      src={contacticons}
                      style={{
                        minWidth: "24px",
                        minHeight: "24px",
                        width: "1.2vw",
                        height: "1.2vw",
                        marginRight: "0.25rem",
                      }}
                    />
                    {/* <AiFillPlusCircle
                      style={{
                        position: "absolute",
                        top: "8px",
                        left: "12px",
                        color: `${primaryColor}`,
                        background: "white",
                        borderRadius: "50%",
                      }}
                    /> */}
                    {/* Contact */}
                    {t("Contacts")}
                  </span>
                </div>
                <div
                  className={
                    roleAccess === process.env.REACT_APP_IS_VIEWER
                      ? "d-none"
                      : path === "/add-company"
                        ? "d-flex justify-content-end"
                        : ""
                  }
                >
                  <DocumentUploaderWithProgress
                    maxSizeInMb={100}
                    onUploaded={onFileUploaded}
                    filefilter={
                      ".doc,.pdf,.xls,.xlsx,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    }
                  >
                    <span
                      style={{
                        position: "relative",
                        fontWeight: "600",
                        cursor: "pointer",
                        color: "#333333",
                      }}
                      className="responsive-font-14"
                    >
                      <img
                        alt="doc"
                        src={docicons}
                        style={{
                          width: "22px",
                          height: "20px",
                          marginRight: "0.25rem",
                        }}
                      />
                      {/* Doc */}
                      {t("Doc")}
                    </span>
                  </DocumentUploaderWithProgress>
                </div>
                <div
                  className={
                    roleAccess === process.env.REACT_APP_IS_VIEWER
                      ? "d-none"
                      : ""
                  }
                >
                  <span
                    style={{
                      position: "relative",
                      // fontSize: "14px",
                      fontWeight: "600",
                      cursor: isUpdating ? "pointer" : "not-allowed",
                      color: isUpdating ? "#333333" : "#999999",
                    }}
                    // onClick={() => {
                    //   setShowTaskColumn(!showTaskColumn);
                    // }}
                    // className="responsive-font-14"
                    className={
                      path === "/add-contact" ? "d-none" : "responsive-font-14"
                    }
                    onClick={() => {
                      if (isUpdating) {
                        setModalFunction("add");
                        setShowModal(true);
                        setReRenderAPI(true);

                        // Set the data locally instead of navigating
                        setCompanyDataSendtoModal({
                          from: "Update_Company_Screen",
                          historyCompanyName: companyName,
                          historyCompanyID: id,
                        });
                      }
                    }}
                  >
                    <img
                      src={Taskicon}
                      alt="taskicon"
                      style={{
                        width: "22px",
                        height: "24px",
                        marginRight: "0.25rem",
                      }}
                    />
                    {/* <AiFillPlusCircle
                      style={{
                        position: "absolute",
                        top: "10px",
                        left: "8px",
                        color: `${primaryColor}`,
                        background: "white",
                        borderRadius: "50%",
                      }}
                    /> */}
                    {/* Task */}
                    {t("Task")}
                  </span>
                </div>
                {packageID === process.env.REACT_APP_IS_PREMIUM && (
                  <div>
                    <span
                      style={{
                        position: "relative",
                        fontSize: "14px",
                        fontWeight: "600",
                      }}
                      className="responsive-font-14"
                    >
                      <img
                        alt="img2email"
                        src={image2}
                        style={{
                          minWidth: "24px",
                          minHeight: "24px",
                          width: "1.2vw",
                          height: "1.2vw",
                          marginRight: "0.25rem",
                        }}
                      />
                      {/* <AiFillPlusCircle
                      style={{
                        position: "absolute",
                        top: "8px",
                        left: "12px",
                        color: `${primaryColor}`,
                        background: "white",
                        borderRadius: "50%",
                      }}
                    /> */}
                      {/* Email */}
                      {t("Email")}
                    </span>
                  </div>
                )}
                {/* <div>
                  <span
                    style={{
                      position: "relative",
                      fontSize: "14px",
                      fontWeight: "600",
                    }}
                    className="responsive-font-14"
                  >
                    <img
                      src={image3}
                      style={{
                        minWidth: "24px",
                        minHeight: "24px",
                        width: "1.2vw",
                        height: "1.2vw",
                        marginRight: "0.25rem",
                      }}
                    />
                    <AiFillPlusCircle
                      style={{
                        position: "absolute",
                        top: "8px",
                        left: "12px",
                        color: `${primaryColor}`,
                        background: "white",
                        borderRadius: "50%",
                      }}
                    />
                    Event
                  </span>
                </div> */}
                <div>
                  <span
                    className="responsive-font-14 pointer"
                    style={{
                      position: "relative",
                      fontSize: "14px",
                      fontWeight: "600",
                      color: path === "/add-company" ? "" : "#333333",
                      pointerEvents: path === "/add-company" && "none",
                    }}
                    onClick={() => {
                      localStorage.setItem("clientCOName", companyName);
                      localStorage.setItem("clientCONameID", companyID);
                      history.push({
                        // pathname: "/addProject", "/project",
                        pathname: "/addProject",
                        state: {
                          from: "Add_Company_Screen_ForProject",
                          historyCompanyName: companyName,
                          historyCompanyID: companyID,
                          historyDeliveryAddress: companyAddress,
                          historyDeliveryAddressParts: companyAddressParts,
                          historyCreditLimit:
                            fetchClientByIdRes?.data?.financialInformation
                              ?.creditLimit,
                        },
                      });
                      // setCompanysContact(true);
                    }}
                  >
                    <img
                      alt="img2email"
                      src={projecticons}
                      style={{
                        minWidth: "24px",
                        minHeight: "24px",
                        width: "1.2vw",
                        height: "1.2vw",
                        marginRight: "0.25rem",
                      }}
                    />
                    {/* <AiFillPlusCircle
                      style={{
                        position: "absolute",
                        top: "8px",
                        left: "12px",
                        color: `${primaryColor}`,
                        background: "white",
                        borderRadius: "50%",
                      }}
                    /> */}
                    {/* Project */}
                    {t("Project")}
                  </span>
                </div>
              </div>
            </div>
          </div>
          {!docAdded ? (
            <>
              {!showTaskColumn ? (
                <>
                  <div className="column-2-info wrapperinformationDiv p-3">
                    <div className="information-tabs">
                      <div
                        style={
                          activeHeading === "1"
                            ? { color: `${primaryColor}` }
                            : {}
                        }
                        className={
                          activeHeading === "1"
                            ? "tab-headings active-tab-heading responsive-font-14"
                            : "tab-headings responsive-font-14"
                        }
                        onClick={() => setActiveHeading("1")}
                      >
                        {/* Information */}
                        {t("Information")}
                        {activeHeading === "1" && (
                          <div
                            className="tab-underline"
                            style={
                              activeHeading === "1"
                                ? { backgroundColor: `${primaryColor}` }
                                : {}
                            }
                          ></div>
                        )}
                      </div>

                      <div
                        style={
                          activeHeading === "contactTab"
                            ? { color: `${primaryColor}` }
                            : {}
                        }
                        className={
                          activeHeading === "contactTab"
                            ? "tab-headings active-tab-heading responsive-font-14"
                            : "tab-headings responsive-font-14"
                        }
                        onClick={() => setActiveHeading("contactTab")}
                      >
                        {/* Contacts */}
                        {t("Contacts")}
                        {activeHeading === "contactTab" && (
                          <div
                            className="tab-underline"
                            style={
                              activeHeading === "contactTab"
                                ? { backgroundColor: `${primaryColor}` }
                                : {}
                            }
                          ></div>
                        )}
                      </div>

                      <div
                        style={
                          activeHeading === "2"
                            ? { color: `${primaryColor}` }
                            : {}
                        }
                        className={
                          activeHeading === "2"
                            ? "tab-headings active-tab-heading responsive-font-14"
                            : "tab-headings responsive-font-14"
                        }
                        onClick={() => setActiveHeading("2")}
                      >
                        {t("Docs")}
                        {activeHeading === "2" && (
                          <div
                            className="tab-underline"
                            style={
                              activeHeading === "2"
                                ? { backgroundColor: `${primaryColor}` }
                                : {}
                            }
                          ></div>
                        )}
                      </div>
                      <div
                        style={
                          activeHeading === "3"
                            ? { color: `${primaryColor}` }
                            : {}
                        }
                        className={
                          activeHeading === "3"
                            ? "tab-headings active-tab-heading responsive-font-14"
                            : path === "/add-contact"
                              ? "d-none"
                              : "tab-headings responsive-font-14"
                        }
                        onClick={() => setActiveHeading("3")}
                      >
                        {t("Task")}
                        {activeHeading === "3" && (
                          <div
                            className="tab-underline"
                            style={
                              activeHeading === "3"
                                ? { backgroundColor: `${primaryColor}` }
                                : {}
                            }
                          ></div>
                        )}
                      </div>
                      {packageID === process.env.REACT_APP_IS_PREMIUM && (
                        <>
                          {roleAccess !== ROLES.VIEWER && (
                            <div
                              style={
                                activeHeading === "4"
                                  ? { color: `${primaryColor}` }
                                  : { visibility: "" }
                              }
                              className={
                                activeHeading === "4"
                                  ? "tab-headings active-tab-heading responsive-font-14"
                                  : "tab-headings responsive-font-14"
                              }
                              onClick={() => setActiveHeading("4")}
                            >
                              {/* Emails */}
                              {t("Emails")}
                              {activeHeading === "4" && (
                                <div
                                  className="tab-underline"
                                  style={
                                    activeHeading === "4"
                                      ? { backgroundColor: `${primaryColor}` }
                                      : {}
                                  }
                                ></div>
                              )}
                            </div>
                          )}
                        </>
                      )}
                      <div
                        style={
                          activeHeading === "5"
                            ? { color: `${primaryColor}` }
                            : { visibility: "hidden" }
                        }
                        className={
                          activeHeading === "5"
                            ? "tab-headings active-tab-heading responsive-font-14"
                            : "tab-headings responsive-font-14"
                        }
                        onClick={() => setActiveHeading("5")}
                      >
                        Events
                        {activeHeading === "5" && (
                          <div
                            className="tab-underline"
                            style={
                              activeHeading === "5"
                                ? { backgroundColor: `${primaryColor}` }
                                : {}
                            }
                          ></div>
                        )}
                      </div>
                    </div>
                    <div
                      className="underline-contact"
                      style={{
                        // width: "90%",
                        margin: "0.75rem auto 0 auto",
                      }}
                    ></div>

                    {activeHeading === "1" && (
                      // Default Information Tab start👇.
                      <div className="py-3">
                        {/* Basic information */}
                        <div className="basicInforationDiv">
                          <div className="p-2 basicInforation position-relative d-flex justify-content-between">
                            <p className="mb-0">
                              {/* Basic information */}
                              {t("Basic information")}
                            </p>

                            <img
                              src={DownArrowOption}
                              className={
                                arrowOptionsRotate5
                                  ? "upArrow ms-auto h-auto pointer"
                                  : "downArrow ms-auto h-auto pointer"
                              }
                              alt=""
                              onClick={() => {
                                setBasicInformationDiv(!basicInformationDiv);
                                setArrowOptionsRotate5(!arrowOptionsRotate5);
                              }}
                            />
                          </div>

                          {basicInformationDiv && (
                            <div>
                              <div
                                className="asc-input-container"
                                id="ascInput"
                              >
                                <label className="asc-label-top projectNameText">
                                  {/* Main Address */}
                                  {t("Main Address")}
                                </label>

                                <label className="asc-label-top projectNameTextBoth">
                                  {/* Add another */}
                                  {t("Add another")}
                                  <img
                                    src={plusIcon}
                                    className="ms-2 pointer"
                                    alt=""
                                    onClick={() => {
                                      setMainAddressPopupShow(
                                        !mainAddressPopupShow,
                                      );
                                    }}
                                  />
                                </label>

                                {/* <textarea
                            id="w3review"
                            name="w3review"
                            rows="4"
                            cols="50"
                            // placeholder="Notes"
                            className="PlanNotesInput ps-3 bordered-inputs"
                            style={{ width: "100%", resize: "none" }}
                            value={address}
                            onChange={(e) => {
                              setAddress(e.target.value);
                              // setTypeInScreen("asc");
                            }}
                          ></textarea> */}

                                <GooglePlacesAutocomplete
                                  debounce={800}
                                  renderInput={(props) => (
                                    <textarea
                                      className="PlanNotesInput ps-3 bordered-inputs"
                                      style={{
                                        // border: "none",
                                        width: "100%",
                                        height: "75px",
                                        // overflow: "hidden",
                                        resize: "none",
                                      }}
                                      {...props}
                                      onChange={(e) => {
                                        props.onChange?.(e);
                                        setMainAddressParts({
                                          street: "",
                                          city: "",
                                          state: "",
                                          pinCode: "",
                                          country: "",
                                        });
                                      }}
                                      rows={4}
                                      // placeholder="Type an Address"
                                      placeholder={t("Type an Address")}
                                    />
                                  )}
                                  onSelect={(e) => {
                                    handleAddressSelectMain(e);
                                    setChangeComp("asc");
                                  }}
                                  // placeholder="Type an Address"
                                  placeholder={t("Type an Address")}
                                  initialValue={mainAddress}
                                  withSessionToken={true}
                                />
                              </div>

                              {/* Main Address popup start */}
                              {mainAddressPopupShow && (
                                <div className="MainAddressPopup">
                                  <div className="text-end me-3">
                                    <img
                                      src={XiconCircle}
                                      className="xicon pointer ms-auto"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                      }}
                                      alt=""
                                      onClick={() => {
                                        setMainAddressPopupShow(false);
                                      }}
                                    />
                                  </div>
                                  <div
                                    className="asc-input-container m-4"
                                    id="ascInput"
                                  >
                                    <label className="asc-label-top projectNameText">
                                      {/* Address label */}
                                      {t("Address  label")}
                                    </label>

                                    <div
                                      className="clientInput ps-3"
                                      style={{
                                        height: "50px",
                                        border: "1px solid #333333",
                                      }}
                                    >
                                      <input
                                        type="text"
                                        placeholder={
                                          // "Select label"
                                          t("Select label")
                                        }
                                        className="clientText bordered-inputs"
                                        value={mainAddressName}
                                        // onClick={() => {
                                        //   setShowOptions((prev) => !prev);
                                        // }}

                                        // onChange={(e) => {
                                        //   setSearchName(e.target.value.toLowerCase());
                                        //   setMainAddressLabelOptions(true);
                                        // }}

                                        onFocus={() => {
                                          setMainAddressLabelOptions(true);
                                        }}
                                      />

                                      {mainAddressName ||
                                      mainAddressLabelOptions ? (
                                        <img
                                          src={Xicon}
                                          className="xicon pointer"
                                          alt=""
                                          onClick={() => {
                                            setMainAddressName("");
                                            setMainAddressID("");
                                            // setShowOptions(!showOptions);
                                            setMainAddressLabelOptions(false);
                                          }}
                                        />
                                      ) : (
                                        ""
                                      )}

                                      {mainAddressLabelOptions && (
                                        <div
                                          className="customSelect_Outer ps-1"
                                          style={{
                                            top: "45px",
                                            // height: "60px",
                                            width: "90%",
                                            zIndex: "2",
                                            boxShadow: "0px 6px 12px #3b45581a",
                                          }}
                                        >
                                          {mainAddressOptionData.map(
                                            (item, index) => {
                                              if (
                                                item.mainAddID === "1" ||
                                                mainAddressMultiData.find(
                                                  (item2) =>
                                                    item2.asc_MainAddName ===
                                                    item.mainAddName,
                                                )
                                              )
                                                return;

                                              return (
                                                <div
                                                  key={index}
                                                  className="customSelect"
                                                  onClick={() => {
                                                    setMainAddressName(
                                                      item.mainAddName,
                                                    );
                                                    setMainAddressID(
                                                      item.mainAddID,
                                                    );
                                                    setMainAddressLabelOptions(
                                                      false,
                                                    );
                                                    setChangeComp("asc");
                                                  }}
                                                >
                                                  <p className="mb-2">
                                                    {item.mainAddName}
                                                  </p>
                                                </div>
                                              );
                                            },
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  <div
                                    className="asc-input-container m-4"
                                    id="ascInput"
                                  >
                                    <label className="asc-label-top ClientNameText">
                                      {/* Address */}
                                      {t("Address")}
                                    </label>

                                    <GooglePlacesAutocomplete
                                      debounce={800}
                                      renderInput={(props) => (
                                        <textarea
                                          className="PlanNotesInput ps-3 bordered-inputs"
                                          style={{
                                            // border: "none",
                                            width: "100%",
                                            height: "75px",
                                            // overflow: "hidden",
                                            resize: "none",
                                          }}
                                          {...props}
                                          onChange={(e) => {
                                            props.onChange?.(e);
                                            setEnterMainAddressParts({
                                              street: "",
                                              city: "",
                                              state: "",
                                              pinCode: "",
                                              country: "",
                                            });
                                          }}
                                          rows={4}
                                          // placeholder="Type an Address"
                                          placeholder={t("Type an Address")}
                                        />
                                      )}
                                      onSelect={(e) => {
                                        handleMultiAddressSelectMain(e);
                                        setChangeComp("asc");
                                      }}
                                      // placeholder="Type an Address"
                                      placeholder={t("Type an Address")}
                                      initialValue={enterMainAddress}
                                      withSessionToken={true}
                                    />
                                  </div>

                                  <div>
                                    <button
                                      id="ascButtonDisabled"
                                      disabled={
                                        enterMainAddress === "" ||
                                        mainAddressName === ""
                                      }
                                      className="button_invo mt-3 pt-3 mx-auto"
                                      onClick={() => {
                                        // dispatch(
                                        //   SendInvoice(invoiceId, email, invoiceCode)
                                        // );
                                        setMainAddressPopupShow(false);

                                        let addressMultiData = [
                                          ...mainAddressMultiData,
                                        ];
                                        addressMultiData.push({
                                          asc_MainAddName: mainAddressName,
                                          asc_EnterAddressName:
                                            enterMainAddress,
                                          ...enterMainAddressParts,
                                        });

                                        setMainAddressMultiData(
                                          addressMultiData,
                                        );

                                        setEnterMainAddress("");
                                        setEnterMainAddressParts({
                                          street: "",
                                          city: "",
                                          state: "",
                                          pinCode: "",
                                          country: "",
                                        });
                                        setMainAddressName("");
                                      }}
                                    >
                                      <p>
                                        {/* Add */}
                                        {t("Add")}
                                      </p>
                                    </button>
                                  </div>
                                </div>
                              )}
                              {/* Main Address popup end */}

                              {/* Muliple Main Address Data start */}
                              {mainAddressMultiData.map((item, index) => {
                                console.log("asc56 multiAddre", item);
                                return (
                                  <div
                                    className="asc-input-container"
                                    id="ascInput"
                                  >
                                    <label className="asc-label-top projectNameText">
                                      {item.asc_MainAddName}
                                    </label>

                                    <label className="asc-label-top multiProjectNameTextBoth">
                                      <img
                                        src={Binclr}
                                        className="ms- pointer"
                                        width={15}
                                        alt=""
                                        onClick={() => {
                                          if (item.asc_MultiAdressID) {
                                            dispatch(
                                              DeleteMultipleAddress([
                                                item.asc_MultiAdressID,
                                              ]),
                                            );
                                          } else {
                                            let data = [
                                              ...mainAddressMultiData,
                                            ];
                                            data.splice(index, 1);
                                            setMainAddressMultiData(data);
                                          }
                                        }}
                                      />
                                    </label>

                                    <GooglePlacesAutocomplete
                                      debounce={800}
                                      renderInput={(props) => (
                                        <textarea
                                          readOnly-2
                                          className="PlanNotesInput ps-3 bordered-inputs"
                                          style={{
                                            // border: "none",
                                            width: "100%",
                                            height: "75px",
                                            // overflow: "hidden",
                                            resize: "none",
                                          }}
                                          {...props}
                                          onChange={(e) => {
                                            props.onChange?.(e);
                                            let data = [
                                              ...mainAddressMultiData,
                                            ];
                                            Object.assign(data[index], {
                                              street: "",
                                              city: "",
                                              state: "",
                                              pinCode: "",
                                              country: "",
                                            });
                                            setMainAddressMultiData(data);
                                          }}
                                          rows={4}
                                          // placeholder="Type an Address"
                                          placeholder={t("Type an Address")}
                                        />
                                      )}
                                      onSelect={async (e) => {
                                        const parsed =
                                          await parseGooglePlace(e);
                                        let data = [...mainAddressMultiData];
                                        data[index].asc_EnterAddressName =
                                          parsed.formattedAddress;
                                        Object.assign(
                                          data[index],
                                          getAddressParts(parsed),
                                        );
                                        setMainAddressMultiData(data);
                                        setZipCode(parsed.postalCode);
                                        setChangeComp("asc");
                                      }}
                                      // placeholder="Type an Address"
                                      placeholder={t("Type an Address")}
                                      // initialValue={mainAddress}
                                      initialValue={item.asc_EnterAddressName}
                                      withSessionToken={true}
                                    />
                                  </div>
                                );
                              })}
                              {/* Muliple Main Address Data end */}

                              <div
                                className="asc-input-container"
                                id="ascInput"
                              >
                                <label
                                  className="asc-label-top ClientNameText"
                                  style={{ background: "#fff" }}
                                >
                                  {/* General Email */}
                                  {t("General Email")}
                                </label>

                                <label className="asc-label-top projectNameTextBoth">
                                  {/* Add another */}
                                  {t("Add another")}
                                  <img
                                    src={plusIcon}
                                    className="ms-2 pointer"
                                    alt=""
                                    onClick={() => {
                                      setGenEmailPopupShow(!genEmailPopupShow);
                                    }}
                                  />
                                </label>

                                <input
                                  // disabled
                                  className="asc_NormalInput ps-4"
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "400",
                                    color: "#323232",
                                    width: "100%",
                                    background: "white",
                                  }}
                                  // placeholder="Type an Email"
                                  placeholder={t("Type an Email")}
                                  type="email"
                                  value={generalEmail ?? ""}
                                  onChange={(e) => {
                                    setGeneralEmail(e.target.value);
                                    setChangeComp("asc");
                                  }}
                                />
                                <div
                                  className={
                                    isGeneralEmailValid
                                      ? "ps-1 py-2"
                                      : "invisible py-2"
                                  }
                                  style={{ color: "red", fontSize: "14px" }}
                                >
                                  <i className="pe-1 bi bi-exclamation-circle"></i>
                                  {t("Email is invalid")}
                                </div>
                              </div>

                              {/* General Email popup start */}
                              {genEmailPopupShow && (
                                <div
                                  className="MainAddressPopup"
                                  style={{ bottom: "100px" }}
                                >
                                  <div className="text-end me-3">
                                    <img
                                      src={XiconCircle}
                                      className="xicon pointer ms-auto"
                                      style={{
                                        width: "20px",
                                        height: "20px",
                                      }}
                                      alt=""
                                      onClick={() => {
                                        setGenEmailPopupShow(false);
                                      }}
                                    />
                                  </div>
                                  <div
                                    className="asc-input-container m-4"
                                    id="ascInput"
                                  >
                                    <label className="asc-label-top projectNameText">
                                      {/* Email label */}
                                      {t("email label")}
                                    </label>

                                    <div
                                      className="clientInput ps-3"
                                      style={{
                                        height: "50px",
                                        border: "1px solid #333333",
                                      }}
                                    >
                                      <input
                                        type="text"
                                        placeholder={
                                          // "Select label"
                                          t("Select label")
                                        }
                                        className="clientText bordered-inputs"
                                        value={genEmailName}
                                        // onClick={() => {
                                        //   setShowOptions((prev) => !prev);
                                        // }}

                                        // onChange={(e) => {
                                        //   setSearchName(e.target.value.toLowerCase());
                                        //   setGenEmailLabelOptions(true);
                                        // }}

                                        onFocus={() => {
                                          setGenEmailLabelOptions(true);
                                        }}
                                      />

                                      {genEmailName || genEmailLabelOptions ? (
                                        <img
                                          src={Xicon}
                                          className="xicon pointer"
                                          alt=""
                                          onClick={() => {
                                            setGenEmailName("");
                                            setGenEmailID("");
                                            setGenEmailLabelOptions(false);
                                          }}
                                        />
                                      ) : (
                                        ""
                                      )}

                                      {genEmailLabelOptions && (
                                        <div
                                          className="customSelect_Outer ps-1"
                                          style={{
                                            top: "45px",
                                            // height: "60px",
                                            width: "90%",
                                            zIndex: 2,
                                            boxShadow: "0px 6px 12px #3b45581a",
                                          }}
                                        >
                                          {genEmailOptionData.map(
                                            (item, index) => {
                                              if (
                                                item.genMailID === "1" ||
                                                genEmailMultiData.find(
                                                  (item2) =>
                                                    item2.asc_EmailName ===
                                                    item.genMailName,
                                                )
                                              )
                                                return;

                                              return (
                                                <div
                                                  key={index}
                                                  className="customSelect"
                                                  onClick={() => {
                                                    setGenEmailName(
                                                      item.genMailName,
                                                    );
                                                    setGenEmailID(
                                                      item.genMailID,
                                                    );
                                                    setGenEmailLabelOptions(
                                                      false,
                                                    );
                                                    setChangeComp("asc");
                                                  }}
                                                >
                                                  <p className="mb-2">
                                                    {item.genMailName}
                                                  </p>
                                                </div>
                                              );
                                            },
                                          )}
                                        </div>
                                      )}
                                    </div>
                                  </div>

                                  <div
                                    className="asc-input-container m-4"
                                    id="ascInput"
                                  >
                                    <label className="asc-label-top ClientNameText">
                                      {/* Email */}
                                      {t("Email")}
                                    </label>
                                    <input
                                      type="text"
                                      className="asc_NormalInput_invo ps-4"
                                      style={{ width: "100%" }}
                                      // placeholder="Type an address"
                                      placeholder={t("Type an Address")}
                                      value={enterGenEmail}
                                      onChange={(e) => {
                                        setEnterGenEmail(e.target.value);
                                        checkEmailValidation(e);
                                      }}
                                    />
                                    <div
                                      className={
                                        validemail
                                          ? "ps-1 py-2"
                                          : "invisible py-2"
                                      }
                                      style={{ color: "red", fontSize: "14px" }}
                                    >
                                      <i className="pe-1 bi bi-exclamation-circle"></i>
                                      {/* Email is invalid */}
                                      {t("Email is invalid")}
                                    </div>
                                  </div>

                                  <div>
                                    <button
                                      id="ascButtonDisabled"
                                      disabled={
                                        validemail ||
                                        enterGenEmail === "" ||
                                        genEmailName === ""
                                      }
                                      className="button_invo mt-3 pt-3 mx-auto"
                                      onClick={() => {
                                        // dispatch(
                                        //   SendInvoice(invoiceId, email, invoiceCode)
                                        // );
                                        setGenEmailPopupShow(false);

                                        let emailMultiData = [
                                          ...genEmailMultiData,
                                        ];
                                        emailMultiData.push({
                                          asc_EmailName: genEmailName,
                                          asc_EmailAddress: enterGenEmail,
                                        });

                                        setGenEmailMultiData(emailMultiData);

                                        setEnterGenEmail("");
                                        setGenEmailName("");
                                      }}
                                    >
                                      <p>
                                        {/* Add */}
                                        {t("Add")}
                                      </p>
                                    </button>
                                  </div>
                                </div>
                              )}
                              {/* General Email popup end */}

                              {/* Muliple General Email Data start */}
                              {genEmailMultiData.map((item, index) => {
                                return (
                                  <div
                                    className="asc-input-container"
                                    id="ascInput"
                                  >
                                    <label className="asc-label-top projectNameText">
                                      {item.asc_EmailName}
                                    </label>

                                    <label className="asc-label-top multiProjectNameTextBoth">
                                      <img
                                        src={Binclr}
                                        className="ms- pointer"
                                        width={15}
                                        alt=""
                                        onClick={() => {
                                          if (item.asc_MultiEmailID) {
                                            dispatch(
                                              DeleteMultipleAddress([
                                                item.asc_MultiEmailID,
                                              ]),
                                            );
                                          } else {
                                            let data = [...genEmailMultiData];
                                            data.splice(index, 1);
                                            setGenEmailMultiData(data);
                                          }
                                        }}
                                      />
                                    </label>

                                    <input
                                      readOnly-2
                                      type="text"
                                      className="asc_NormalInput_invo ps-4"
                                      style={{ width: "100%" }}
                                      // placeholder="Type an email"
                                      placeholder={t("Type an Email")}
                                      value={item.asc_EmailAddress}
                                      onChange={(e) => {
                                        // setEnterGenEmail(e.target.value);
                                        // checkEmailValidation(e);
                                        handleInputChange(
                                          index,
                                          "asc_EmailAddress",
                                          e.target.value,
                                        );
                                      }}
                                    />
                                  </div>
                                );
                              })}
                              {/* Muliple General Email Data end */}

                              <div className="row">
                                <div
                                  className="asc-input-container col-md-6 col-12"
                                  id="ascInput"
                                >
                                  <label
                                    className="asc-label-top ClientNameText"
                                    style={{ background: "#fff" }}
                                  >
                                    {/* Contact Telephone */}
                                    {t("Contact Telephone")}
                                  </label>

                                  <PhoneInput
                                    country={"nl"}
                                    enableSearch={true}
                                    className="pt-1 contactDeliveryInput ps-4 bordered-inputs"
                                    // placeholder="Contact Telephone"
                                    placeholder={t("Contact Telephone")}
                                    value={contactTelephone}
                                    onChange={(phone) => {
                                      setContactTelephone(phone);
                                      setChangeComp(phone);
                                    }}
                                    // defaultCountry={'in'}
                                    // inputProps={{
                                    //   name: 'phone',
                                    //   required: true,
                                    //   autoFocus: true,
                                    // }}
                                  />
                                </div>

                                <div
                                  className="asc-input-container col-md-6 col-12"
                                  id="ascInput"
                                >
                                  <label
                                    className="asc-label-top ClientNameText"
                                    style={{ background: "#fff" }}
                                  >
                                    {/* Office Telephone */}
                                    {t("Office Telephone")}
                                  </label>

                                  <PhoneInput
                                    country={"nl"}
                                    enableSearch={true}
                                    className="pt-1 contactDeliveryInput ps-4 bordered-inputs"
                                    // placeholder="Contact Telephone"
                                    placeholder={t("Contact Telephone")}
                                    value={officeTelephone}
                                    onChange={(phone) => {
                                      setOfficeTelephone(phone);
                                      setChangeComp(phone);
                                    }}
                                    // defaultCountry={'in'}
                                    // inputProps={{
                                    //   name: 'phone',
                                    //   required: true,
                                    //   autoFocus: true,
                                    // }}
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>

                        {/* General information */}
                        <div className="basicInforationDiv pt-4">
                          <div className="p-2 basicInforation d-flex justify-content-between">
                            <p className="mb-0">
                              {/* General information */}
                              {t("General information")}
                            </p>

                            <img
                              src={DownArrowOption}
                              className={
                                arrowOptionsRotate6
                                  ? "upArrow ms-auto h-auto pointer"
                                  : "downArrow ms-auto h-auto pointer"
                              }
                              alt=""
                              onClick={() => {
                                setGeneralInformationDiv(
                                  !generalInformationDiv,
                                );
                                setArrowOptionsRotate6(!arrowOptionsRotate6);
                              }}
                            />
                          </div>

                          {generalInformationDiv && (
                            <div>
                              <div className="row">
                                <div
                                  className="asc-input-container col-md-6 col-12"
                                  id="ascInput"
                                >
                                  <label
                                    className="asc-label-top ClientNameText"
                                    style={{ background: "#fff" }}
                                  >
                                    {/* KvK Number */}
                                    {t("KvK Number")}
                                  </label>

                                  <input
                                    type="text"
                                    // disabled
                                    className="asc_NormalInput ps-4"
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "400",
                                      color: "#323232",
                                      width: "100%",
                                      background: "white",
                                    }}
                                    // placeholder="KvK Number"
                                    placeholder={t("KvK Number")}
                                    value={kvkNumber}
                                    onChange={(e) => {
                                      setKvkNumber(e.target.value);
                                      setChangeComp("asc");
                                    }}
                                  />
                                </div>

                                <div
                                  className="asc-input-container col-md-6 col-12 d-none"
                                  id="ascInput"
                                >
                                  <label
                                    className="asc-label-top ClientNameText"
                                    style={{ background: "#fff" }}
                                  >
                                    {/* Account Manager */}
                                    {t("Account Manager")}
                                  </label>

                                  <div
                                    className="asc_NormalInput ps-2"
                                    ref={projectManagerRef}
                                    style={{
                                      width: "auto",
                                      background: "unset",
                                      paddingTop: "10px",
                                    }}
                                  >
                                    <img
                                      src={plusCircle}
                                      className="pointer"
                                      alt=""
                                      onClick={() => {
                                        setOpenAssigneeModal(
                                          !openAssigneeModal,
                                        );
                                        // setSearchAssigneePeople("");
                                      }}
                                    />
                                    <div
                                      className="position-relative row"
                                      style={{ right: "245px", width: "475px" }}
                                    >
                                      {openAssigneeModal && (
                                        <StockAssigneeModal
                                          sendingData={coWorkerData} // only sending Data.👆
                                          // addUsersData={addUsersData}
                                          // removeUsersData={removeUsersData}
                                          closeAssigneeModal={
                                            setOpenAssigneeModal
                                          }
                                          // headerMaxAmount={headerMaxAmount}
                                          // setHeaderMaxAmount={setHeaderMaxAmount}
                                          showWorkersTab={true}
                                          showTeamsTab={false}
                                        />
                                      )}
                                    </div>
                                  </div>
                                </div>

                                {/* Account manager single start */}
                                <div
                                  className="asc-input-container col-md-6 col-12"
                                  id="ascInput"
                                >
                                  <label className="asc-label-top ClientNameText">
                                    {/* Account Manager */}
                                    {t("Account Manager")}
                                  </label>

                                  <div
                                    className="asc_Client_Input_Div_For_LongDiv22 p-2"
                                    ref={projectManagerRef}
                                    style={{ width: "auto" }}
                                  >
                                    <div
                                      className="d-flex gap-2"
                                      onClick={() => {
                                        setProjectManagerShow(
                                          !projectManagerShow,
                                        );
                                        setArrowOptionsRotate4(
                                          !arrowOptionsRotate4,
                                        );
                                      }}
                                    >
                                      {selectedManagerImg ||
                                      projectManagerImage ? (
                                        <img
                                          src={
                                            selectedManagerImg ||
                                            projectManagerImage
                                          }
                                          alt=""
                                          className="plusCircle mt-1"
                                        />
                                      ) : selectedManagerFName ? (
                                        <div className="plusCircleAssignee mt-1">
                                          {selectedManagerLName
                                            ? selectedManagerFName[0] +
                                              "" +
                                              selectedManagerLName[0]
                                            : selectedManagerFName?.slice(0, 2)}
                                        </div>
                                      ) : (
                                        <img
                                          src={plusCircle}
                                          alt=""
                                          className="plusCircle pointer mt-1 "
                                        />
                                      )}

                                      <p
                                        className="mb-1 pt-2"
                                        // title={
                                        //   projectManagerName?.length > 10 &&
                                        //   projectManagerName
                                        // }
                                        style={{
                                          color: "#333333",
                                          fontWeight: "700",
                                          // for 3 dots 👇
                                          // whiteSpace: "pre-wrap",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          textOverflow: "ellipsis",
                                          // maxWidth: "10px",
                                        }}
                                      >
                                        {projectManagerName
                                          ? projectManagerName
                                          : "Select a Manager"}
                                      </p>

                                      {projectManagerName ? (
                                        <img
                                          src={Xicon}
                                          className="xicon pointer ms-auto h-auto"
                                          alt=""
                                          onClick={() => {
                                            setSearchProjectManager("");
                                            setProjectManagerName("");
                                            setProjectManagerID("");
                                            setSelectedManagerImg("");
                                            setSelectedManagerFName("");
                                            setSelectedManagerLName("");
                                            setChangeComp("asc");
                                          }}
                                        />
                                      ) : (
                                        <img
                                          src={DownArrowOption}
                                          className={
                                            arrowOptionsRotate4
                                              ? "upArrow ms-auto h-auto"
                                              : "downArrow ms-auto h-auto"
                                          }
                                          alt=""
                                          onClick={() => {
                                            setProjectManagerShow(
                                              !projectManagerShow,
                                            );
                                            setArrowOptionsRotate4(
                                              !arrowOptionsRotate4,
                                            );
                                          }}
                                        />
                                      )}
                                    </div>

                                    {projectManagerShow && (
                                      <div
                                        className="asc_Custom_Select_Outer22"
                                        style={{
                                          transform: projectManagerShow
                                            ? "scale(1)"
                                            : "scale(0)",
                                          transitionDuration: "300ms",
                                          top: "50px",
                                        }}
                                      >
                                        <p className="asc_Search_Client_Text pt-2 ps-2">
                                          <input
                                            type="text"
                                            className="asc_Client_Input_For_Long ps-2"
                                            placeholder="Search Manager..."
                                            value={searchProjectManager}
                                            onChange={(e) => {
                                              setSearchProjectManager(
                                                e.target.value,
                                              );
                                              setProjectManagerShow(true);
                                            }}
                                          />
                                        </p>

                                        <section
                                          className="asc_Search_List pt-3 ps-0"
                                          id="ascSelectBox"
                                        >
                                          {projectManagerData
                                            .filter((x) =>
                                              x.firstname
                                                ?.toLowerCase()
                                                .includes(searchProjectManager),
                                            )
                                            .map((item, index) => {
                                              return (
                                                <div
                                                  key={index}
                                                  className="ulterDrop pt-2"
                                                  onClick={() => {
                                                    setSearchProjectManager("");
                                                    setProjectManagerName(
                                                      `${item.firstname}
                                                     ${item.lastname}`,
                                                    );
                                                    setProjectManagerID(
                                                      item.userid,
                                                    );
                                                    setProjectManagerShow(
                                                      false,
                                                    );

                                                    setSelectedManagerImg(
                                                      item.imageurl,
                                                    );
                                                    setSelectedManagerFName(
                                                      item.firstname,
                                                    );
                                                    setSelectedManagerLName(
                                                      item.lastname,
                                                    );
                                                    setChangeComp("asc");
                                                  }}
                                                >
                                                  <div className="d-flex gap-2 align-items-center">
                                                    {item.imageurl ? (
                                                      <img
                                                        src={item.imageurl}
                                                        alt=""
                                                        className="assigneeIMG"
                                                      />
                                                    ) : (
                                                      <div
                                                        className="assigneeAbbr"
                                                        style={{
                                                          fontSize: "12px",
                                                        }}
                                                      >
                                                        {item.lastname
                                                          ? item?.firstname[0] +
                                                            "" +
                                                            item?.lastname[0]
                                                          : item?.firstname?.slice(
                                                              0,
                                                              2,
                                                            )}
                                                      </div>
                                                    )}
                                                    <p className="mb-0">
                                                      {`${item.firstname}
                                                ${item.lastname}`}
                                                    </p>
                                                  </div>
                                                </div>
                                              );
                                            })}
                                          {projectManagerData.length === 0 && (
                                            <span className="noDataDisplay">
                                              {/* No data to display! */}
                                              {t("No data to display!")}
                                            </span>
                                          )}
                                        </section>
                                      </div>
                                    )}
                                  </div>
                                </div>
                                {/* Account manager single end */}
                              </div>

                              <div
                                className="asc-input-container"
                                id="ascInput"
                              >
                                <label
                                  className="asc-label-top ClientNameText"
                                  style={{ background: "#fff" }}
                                >
                                  {/* URL */}
                                  {t("URL")}
                                </label>

                                <input
                                  type="text"
                                  // disabled
                                  className="asc_NormalInput ps-4"
                                  style={{
                                    fontSize: "14px",
                                    fontWeight: "400",
                                    color: "#323232",
                                    width: "100%",
                                    background: "white",
                                  }}
                                  // placeholder="www.example.com"
                                  placeholder={t("www.example.com")}
                                  value={url}
                                  onChange={(e) => {
                                    setUrl(e.target.value);
                                    setChangeComp("asc");
                                  }}
                                />
                              </div>
                            </div>
                          )}
                        </div>

                        {/* Financial information */}
                        <div className="basicInforationDiv pt-4">
                          <div className="p-2 basicInforation d-flex justify-content-between">
                            <p className="mb-0">
                              {/* Financial information */}
                              {t("Financial information")}
                            </p>

                            <img
                              src={DownArrowOption}
                              className={
                                arrowOptionsRotate7
                                  ? "upArrow ms-auto h-auto pointer"
                                  : "downArrow ms-auto h-auto pointer"
                              }
                              alt=""
                              onClick={() => {
                                setFinancialInformationDiv(
                                  !financialInformationDiv,
                                );
                                setArrowOptionsRotate7(!arrowOptionsRotate7);
                              }}
                            />
                          </div>

                          {financialInformationDiv && (
                            <div>
                              <div className="row">
                                <div
                                  className="asc-input-container col-md-6 col-12"
                                  id="ascInput"
                                >
                                  <label
                                    className="asc-label-top ClientNameText"
                                    style={{ background: "#fff" }}
                                  >
                                    {/* Vat Number */}
                                    {t("Vat Number")}
                                  </label>

                                  <input
                                    type="text"
                                    // disabled
                                    className="asc_NormalInput ps-4"
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "400",
                                      color: "#323232",
                                      width: "100%",
                                      background: "white",
                                    }}
                                    // placeholder="Vat Number"
                                    placeholder={t("Vat Number")}
                                    value={vatNumber}
                                    onChange={(e) => {
                                      setVatNumber(e.target.value);
                                      setChangeComp("asc");
                                    }}
                                  />
                                </div>

                                {/* Payment Terms start */}
                                <div
                                  className="asc-input-container col-md-6 col-12"
                                  id="ascInput"
                                >
                                  <label className="asc-label-top ClientNameText">
                                    {/* Payment Deadline */}
                                    {t("Payment Deadline")}
                                  </label>
                                  <div
                                    className="asc_Client_Input_Div_For_LongDiv22"
                                    ref={PaymentDeadline_Popup_Ref}
                                    style={{ width: "auto" }}
                                  >
                                    <input
                                      type="text"
                                      className="asc_Client_Input_For_Long ps-4"
                                      // placeholder="Immediately (0 Days)"
                                      placeholder={t("Immediately (0 Days)")}
                                      value={paymentDeadline}
                                      onChange={(e) => {
                                        setPaymentDeadline(e.target.value);
                                        setPaymentDeadlineOptions(true);
                                      }}
                                      onFocus={() => {
                                        setPaymentDeadlineOptions(true);
                                        setArrowOptionsRotate(true);
                                      }}
                                    />

                                    {paymentDeadline ? (
                                      <img
                                        src={Xicon}
                                        className="xicon pointer"
                                        alt=""
                                        onClick={() => {
                                          setPaymentDeadline("");
                                          setPaymentDeadlineid("");
                                          setChangeComp("asc");
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src={DownArrowOption}
                                        className={
                                          arrowOptionsRotate
                                            ? "upArrow"
                                            : "downArrow"
                                        }
                                        alt=""
                                        onClick={() => {
                                          setPaymentDeadlineOptions(true);
                                          setArrowOptionsRotate(true);
                                        }}
                                      />
                                    )}

                                    {paymentDeadlineOptions && (
                                      <div
                                        className="asc_Custom_Select_Outer22"
                                        style={{
                                          transform: paymentDeadlineOptions
                                            ? "scale(1)"
                                            : "scale(0)",
                                          transitionDuration: "300ms",
                                        }}
                                      >
                                        <p className="asc_Search_Client_Text pt-2 ps-2">
                                          {/* Select Payment Deadline */}
                                          {t("Select Payment Deadline")}
                                        </p>

                                        <section
                                          className="asc_Search_List pt-2 ps-0"
                                          id="ascSelectBox"
                                        >
                                          {paymentDeadlineData.map(
                                            (item, index) => {
                                              return (
                                                <div
                                                  key={index}
                                                  className="ulterDrop"
                                                  onClick={() => {
                                                    setPaymentDeadline(
                                                      item.paymentDeadline,
                                                    );
                                                    setPaymentDeadlineid(
                                                      item.paymentDeadlineid,
                                                    );
                                                    setPaymentDeadlineOptions(
                                                      false,
                                                    );
                                                    setChangeComp("asc");
                                                    if (
                                                      item.paymentDeadline ===
                                                      "others"
                                                    ) {
                                                      setPaymentOthersOptions(
                                                        true,
                                                      );
                                                    }
                                                  }}
                                                >
                                                  {item.paymentDeadline}
                                                </div>
                                              );
                                            },
                                          )}
                                          {paymentDeadlineData.length === 0 && (
                                            <span className="noDataDisplay">
                                              {/* No data to display! */}
                                              {t("No data to display!")}
                                            </span>
                                          )}
                                        </section>
                                      </div>
                                    )}

                                    <paymentOtherOption>
                                      {paymentOthersOptions && (
                                        <div
                                          className="otherPayment p-3 w-"
                                          style={{ left: "0px" }}
                                        >
                                          <div>
                                            <h6
                                              className="xCiecle ms-auto me-1 pointer"
                                              onClick={() => {
                                                setPaymentOthersOptions(false);
                                              }}
                                            >
                                              x
                                            </h6>
                                          </div>
                                          <div
                                            className="asc-input-container mt-2"
                                            id="ascInput"
                                          >
                                            <label className="asc-label-top ClientNameText">
                                              {/* Due Days */}
                                              {t("Due Days")}
                                            </label>
                                            <input
                                              type="number"
                                              className="asc_NormalInput w-100 ps-4"
                                              placeholder="0"
                                              value={dueDays}
                                              onChange={(e) => {
                                                setDueDays(e.target.value);
                                                setChangeComp("asc");
                                              }}
                                            />
                                          </div>

                                          <div
                                            className="asc-input-container mt-3"
                                            id="ascInput"
                                          >
                                            <label className="asc-label-top ClientNameText">
                                              {/* Description */}
                                              {t("Description")}
                                            </label>
                                            <input
                                              type="text"
                                              className="asc_NormalInput w-100 ps-4"
                                              // placeholder="0 Days"
                                              placeholder={t("0 Days")}
                                              value={paymentDescription}
                                              onChange={(e) => {
                                                setPaymentDescription(
                                                  e.target.value,
                                                );
                                                setChangeComp("asc");
                                              }}
                                            />
                                          </div>

                                          <button
                                            className="makeInvoBtn ms-1 mt-3"
                                            onClick={() => {
                                              // setPaymentDeadline(dueDays + "" + "Days");
                                              setPaymentDeadline(
                                                `${dueDays} Days`,
                                              );
                                              setPaymentOthersOptions(false);
                                            }}
                                          >
                                            {/* Add */}
                                            {t("Add")}
                                          </button>
                                        </div>
                                      )}
                                    </paymentOtherOption>
                                  </div>
                                </div>
                                {/* Payment Terms end */}
                              </div>

                              <div className="row">
                                <div
                                  className="asc-input-container col-md-6 col-12"
                                  id="ascInput"
                                >
                                  <label
                                    className="asc-label-top ClientNameText"
                                    style={{ background: "#fff" }}
                                  >
                                    {/* Bank Account */}
                                    {t("Bank Account")}
                                  </label>

                                  <input
                                    type="text"
                                    // disabled
                                    className="asc_NormalInput ps-4"
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "400",
                                      color: "#323232",
                                      width: "100%",
                                      background: "white",
                                    }}
                                    // placeholder="Bank Account"
                                    placeholder={t("Bank Account")}
                                    value={bankAccount}
                                    onChange={(e) => {
                                      setBankAccount(e.target.value);
                                      setChangeComp("asc");
                                    }}
                                  />
                                </div>

                                <div
                                  className="asc-input-container col-md-6 col-12"
                                  id="ascInput"
                                >
                                  <label
                                    className="asc-label-top ClientNameText"
                                    style={{ background: "#fff" }}
                                  >
                                    {/* Bank Account Blocked for tax */}
                                    {t("Bank Acc Blocked for tax")}
                                  </label>

                                  <input
                                    type="text"
                                    // disabled
                                    className="asc_NormalInput ps-4"
                                    style={{
                                      fontSize: "14px",
                                      fontWeight: "400",
                                      color: "#323232",
                                      width: "100%",
                                      background: "white",
                                    }}
                                    placeholder="Bank Acc Blocked for tax"
                                    value={bankAccountBlocked}
                                    onChange={(e) => {
                                      setBankAccountBlocked(e.target.value);
                                      setChangeComp("asc");
                                    }}
                                  />
                                </div>
                              </div>

                              <div
                                className="asc-input-container"
                                id="ascInput"
                              >
                                <label
                                  className="asc-label-top ClientNameText"
                                  style={{ background: "#fff" }}
                                >
                                  {/* Total Active Projects (EUR) */}
                                  {t("Total Active Projects (EUR)")}
                                </label>

                                <CurrencyInput
                                  className="asc_NormalInput ps-4 fw-normal"
                                  style={{
                                    width: "100%",
                                    color: "#333333",
                                  }}
                                  placeholder="0"
                                  name="creditBalance"
                                  value={totalActiveProjects}
                                  onChangeEvent={(
                                    event,
                                    maskedValue,
                                    floatValue,
                                  ) => {
                                    setTotalActiveProjects(floatValue);
                                  }}
                                  decimalSeparator=","
                                  thousandSeparator="."
                                  precision="2"
                                  // for normal input👇
                                  // decimalSeparator=""
                                  // thousandSeparator=""
                                  // precision=""
                                  // for normal input👆
                                  allowEmpty={true}
                                  prefix="€ "
                                />
                              </div>

                              {/* Credit start */}
                              <div
                                className="asc-input-container"
                                id="ascInput"
                              >
                                <label className="asc-label-top projectNameText">
                                  {/* Credit */}
                                  {t("Credit")}
                                  {/* <span className="mandatory-sign">*</span> */}
                                </label>

                                <div
                                  className="clientInput ps-3"
                                  style={{
                                    height: "auto",
                                    minHeight: "120px",
                                    // border: clientNameWarning
                                    //   ? "0.5px solid red"
                                    //   : "1px solid #70707080",
                                  }}
                                >
                                  <input
                                    type="text"
                                    placeholder={
                                      // "Select Credit"
                                      t("Select Credit")
                                    }
                                    className="clientText bordered-inputs"
                                    value={creditName}
                                    // onClick={() => {
                                    //   setShowOptions((prev) => !prev);
                                    // }}

                                    // onChange={(e) => {
                                    //   setSearchName(e.target.value.toLowerCase());
                                    //   setShowOptions(true);
                                    // }}

                                    onFocus={() => {
                                      setShowCreditOptions(true);
                                    }}
                                    // onMouseEnter={() => {
                                    //     setShowOptions(true);
                                    // }}
                                  />

                                  {creditName || showCreditOptions ? (
                                    <img
                                      src={Xicon}
                                      className="xicon pointer"
                                      alt=""
                                      onClick={() => {
                                        setCreditName("");
                                        setCreditID("");
                                        // setShowOptions(!showOptions);
                                        setShowCreditOptions(false);
                                      }}
                                    />
                                  ) : (
                                    ""
                                  )}

                                  {showCreditOptions && (
                                    <div
                                      className="customSelect_Outer ps-1"
                                      style={{
                                        top: "45px",
                                        height: "60px",
                                        width: "90%",
                                      }}
                                    >
                                      {creditData.map((item, index) => {
                                        return (
                                          <div
                                            key={index}
                                            className="customSelect"
                                            onClick={() => {
                                              setCreditName(
                                                item.creditTypeName,
                                              );
                                              setCreditID(item.creditTypeId);
                                              setShowCreditOptions(false);
                                              setChangeComp("asc");
                                            }}
                                          >
                                            {item.creditTypeName}
                                          </div>
                                        );
                                      })}
                                    </div>
                                  )}

                                  <div
                                    className="creditLimit mt-3 pt-2"
                                    style={{
                                      flexWrap: "wrap",
                                      justifyContent: "unset",
                                    }}
                                  >
                                    <div className="">
                                      <p className="mb-0">
                                        {/* Credit Limit */}
                                        {t("Credit Limit")}
                                      </p>

                                      <CurrencyInput
                                        className="ps-2 fw-normal"
                                        style={{
                                          border: "none",
                                          width: "100px",
                                          color: "#A5A5A5",
                                        }}
                                        placeholder="0"
                                        name="creditBalance"
                                        value={creditLimit}
                                        onChangeEvent={(
                                          event,
                                          maskedValue,
                                          floatValue,
                                        ) => {
                                          setCreditLimit(floatValue);
                                        }}
                                        decimalSeparator=","
                                        thousandSeparator="."
                                        precision="2"
                                        // for normal input👇
                                        // decimalSeparator=""
                                        // thousandSeparator=""
                                        // precision=""
                                        // for normal input👆
                                        allowEmpty={true}
                                        prefix="€ "
                                      />
                                    </div>

                                    <div>
                                      <p className="mb-0">
                                        {/* Starting Date */}
                                        {t("Starting Date")}
                                      </p>
                                      <div
                                        className="flexContainer gap-1 ps-0 ps-md-5"
                                        // style={{ }}
                                        id="projectCalendarCssTT22"
                                        ref={startingDate_Popup_Ref}
                                      >
                                        <img
                                          className="calendarIcon"
                                          onClick={() =>
                                            setCalendarIsOpen((p) => !p)
                                          }
                                          src={calendar}
                                          alt=""
                                        />
                                        <AppDatePicker
                                          open={calendarIsOpen}
                                          onOpenChange={(open) =>
                                            setCalendarIsOpen(open)
                                          }
                                          selected={startingDate}
                                          onChange={(val) => {
                                            setStartingDate(val);
                                            setCalendarIsOpen(false);
                                          }}
                                          onSelect={(d, event) => {
                                            setDateError(false);
                                            event.preventDefault();
                                          }}
                                          isError={dateError}
                                          error={setDateError}
                                          dateFormat="dd/MM/yyyy"
                                        />
                                      </div>
                                      {dateError && (
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "5px",
                                            marginTop: "5px",
                                          }}
                                        >
                                          <div class="warning-icon">!</div>
                                          <div class="warning-message">
                                            Please select a valid date.
                                          </div>
                                        </div>
                                      )}
                                    </div>

                                    <div>
                                      <p className="mb-0">
                                        {/* Ending Date */}
                                        {t("Ending Date")}
                                      </p>
                                      <div
                                        className="flexContainer gap-1 ps-0 ps-md-5"
                                        // style={{ }}
                                        id="projectCalendarCssTT22"
                                        ref={complitionDate_Popup_Ref}
                                      >
                                        <img
                                          className="calendarIcon"
                                          onClick={() =>
                                            setCalendarIsOpen2((p) => !p)
                                          }
                                          src={calendar}
                                          alt=""
                                        />
                                        <AppDatePicker
                                          open={calendarIsOpen2}
                                          onOpenChange={(open) =>
                                            setCalendarIsOpen2(open)
                                          }
                                          selected={endingDate}
                                          onChange={(val) => {
                                            setEndingDate(val);
                                            setCalendarIsOpen2(false);
                                          }}
                                          onSelect={(d, event) => {
                                            setDateError(false);
                                            event.preventDefault();
                                          }}
                                          isError={dateError}
                                          error={setDateError}
                                          dateFormat="dd/MM/yyyy"
                                        />
                                      </div>
                                      {dateError && (
                                        <div
                                          style={{
                                            display: "flex",
                                            gap: "5px",
                                            marginTop: "5px",
                                          }}
                                        >
                                          <div class="warning-icon">!</div>
                                          <div class="warning-message">
                                            Please select a valid date.
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              {/* Credit end */}

                              <div className="row">
                                {/* Invoice Details start */}
                                <div
                                  className="asc-input-container col-md-6 col-12"
                                  id="ascInput"
                                >
                                  <label className="asc-label-top ClientNameText">
                                    {/* Invoice Details */}
                                    {t("Invoice Details")}
                                  </label>
                                  <div
                                    className="asc_Client_Input_Div_For_LongDiv22"
                                    ref={invoiceDetails_Popup_Ref}
                                    style={{ width: "auto" }}
                                  >
                                    <input
                                      type="text"
                                      className="asc_Client_Input_For_Long ps-4"
                                      // placeholder="Select"
                                      placeholder={t("Select ")}
                                      value={invoiceDetails}
                                      onChange={(e) => {
                                        setInvoiceDetails(e.target.value);
                                        setInvoiceDetailsOptions(true);
                                      }}
                                      onFocus={() => {
                                        setInvoiceDetailsOptions(true);
                                        setArrowOptionsRotate2(true);
                                      }}
                                    />

                                    {invoiceDetails ? (
                                      <img
                                        src={Xicon}
                                        className="xicon pointer"
                                        alt=""
                                        onClick={() => {
                                          setInvoiceDetails("");
                                          setInvoiceDetailsid("");
                                          setChangeComp("asc");
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src={DownArrowOption}
                                        className={
                                          arrowOptionsRotate2
                                            ? "upArrow"
                                            : "downArrow"
                                        }
                                        alt=""
                                        onClick={() => {
                                          setInvoiceDetailsOptions(true);
                                          setArrowOptionsRotate2(true);
                                        }}
                                      />
                                    )}

                                    {invoiceDetailsOptions && (
                                      <div
                                        className="asc_Custom_Select_Outer22"
                                        style={{
                                          transform: invoiceDetailsOptions
                                            ? "scale(1)"
                                            : "scale(0)",
                                          transitionDuration: "300ms",
                                        }}
                                      >
                                        <p className="asc_Search_Client_Text pt-2 ps-2">
                                          {/* Select Invoice Details */}
                                          {t("Select Invoice Details")}
                                        </p>

                                        <section
                                          className="asc_Search_List pt-2 ps-0"
                                          id="ascSelectBox"
                                        >
                                          {invoiceDetailsData.map(
                                            (item, index) => {
                                              return (
                                                <div
                                                  key={index}
                                                  className="ulterDrop"
                                                  onClick={() => {
                                                    setInvoiceDetails(
                                                      item.invoiceTypeName,
                                                    );
                                                    setInvoiceDetailsid(
                                                      item.invoiceTypeId,
                                                    );
                                                    setInvoiceDetailsOptions(
                                                      false,
                                                    );
                                                    setChangeComp("asc");
                                                    if (
                                                      item.invoiceTypeName ===
                                                      "Other..."
                                                    ) {
                                                      setInvoiceOthersOptions(
                                                        true,
                                                      );
                                                    }
                                                  }}
                                                >
                                                  {item.invoiceTypeName}
                                                </div>
                                              );
                                            },
                                          )}
                                          {invoiceDetailsData.length === 0 && (
                                            <span className="noDataDisplay">
                                              {/* No data to display! */}
                                              {t("No data to display!")}
                                            </span>
                                          )}
                                        </section>
                                      </div>
                                    )}

                                    <invoiceOtherOption>
                                      {invoiceOthersOptions && (
                                        <div
                                          className="otherPayment p-3 w-"
                                          style={{ left: "0px" }}
                                        >
                                          <div>
                                            <h6
                                              className="xCiecle ms-auto me-1 pointer"
                                              onClick={() => {
                                                setInvoiceOthersOptions(false);
                                              }}
                                            >
                                              x
                                            </h6>
                                          </div>
                                          <div
                                            className="asc-input-container mt-2"
                                            id="ascInput"
                                          >
                                            <label className="asc-label-top ClientNameText">
                                              {/* Due Days */}
                                              {t("Due Days")}
                                            </label>
                                            <input
                                              type="number"
                                              className="asc_NormalInput w-100 ps-4"
                                              placeholder="0"
                                              value={invoiceDueDays}
                                              onChange={(e) => {
                                                setInvoiceDueDays(
                                                  e.target.value,
                                                );
                                                setChangeComp("asc");
                                              }}
                                            />
                                          </div>

                                          <div
                                            className="asc-input-container mt-3"
                                            id="ascInput"
                                          >
                                            <label className="asc-label-top ClientNameText">
                                              {/* Description */}
                                              {t("Description")}
                                            </label>
                                            <input
                                              type="text"
                                              className="asc_NormalInput w-100 ps-4"
                                              // placeholder="0 Days"
                                              placeholder={t("0 Days")}
                                              value={invoiceDescription}
                                              onChange={(e) => {
                                                setInvoiceDescription(
                                                  e.target.value,
                                                );
                                                setChangeComp("asc");
                                              }}
                                            />
                                          </div>

                                          <button
                                            className="makeInvoBtn ms-1 mt-3"
                                            onClick={() => {
                                              // setInvoiceDetails(dueDays + "" + "Days");
                                              setInvoiceDetails(
                                                `${invoiceDueDays} Days`,
                                              );
                                              setInvoiceOthersOptions(false);
                                            }}
                                          >
                                            {/* Add */}
                                            {t("Add")}
                                          </button>
                                        </div>
                                      )}
                                    </invoiceOtherOption>
                                  </div>
                                </div>
                                {/* Invoice Details end */}

                                <div className="col-md-6 col-12 pt-4">
                                  <div className="row ps-lg-0 ps-5">
                                    <div className="col-md-6 col-6">
                                      <p className="mb-0 vatShifted">
                                        {/* VAT Shifted */}
                                        {t("VAT Shifted")}
                                      </p>
                                      <div className="d-flex gap-2">
                                        <div className="d-flex align-items-center gap-1 assignment_radio">
                                          <input
                                            type="radio"
                                            checked={vatShifted === true}
                                            style={{
                                              fontSize: "12px",
                                              width: "14px",
                                              height: "14px",
                                            }}
                                            // value={vatShifted}
                                            onChange={(e) => {
                                              // setVatShifted(e.target.checked);
                                              setVatShifted(true);
                                              setChangeComp(e.target.value);
                                            }}
                                          />
                                          <p className="mb-0 yesNo">
                                            {/* Yes */}
                                            {t("Yes")}
                                          </p>
                                        </div>

                                        <div className="d-flex align-items-center gap-1 assignment_radio">
                                          <input
                                            type="radio"
                                            checked={vatShifted === false}
                                            style={{
                                              fontSize: "12px",
                                              width: "14px",
                                              height: "14px",
                                            }}
                                            // value={vatShifted}
                                            onChange={(e) => {
                                              // setVatShifted(e.target.checked);
                                              setVatShifted(false);
                                              setChangeComp(e.target.value);
                                            }}
                                          />
                                          <p className="mb-0 yesNo">
                                            {/* No */}
                                            {t("No")}
                                          </p>
                                        </div>
                                      </div>
                                    </div>

                                    <div className="col-md-6 col-6">
                                      <p className="mb-0 vatShifted">
                                        {/* Insurance */}
                                        {t("Insurance")}
                                      </p>
                                      <div className="d-flex gap-2">
                                        <div className="d-flex align-items-center gap-1 assignment_radio">
                                          <input
                                            type="radio"
                                            checked={insurance === true}
                                            style={{
                                              fontSize: "12px",
                                              width: "14px",
                                              height: "14px",
                                            }}
                                            // value={insurance}
                                            onChange={(e) => {
                                              // setInsurance(e.target.checked);
                                              setInsurance(true);
                                              setChangeComp(e.target.value);
                                            }}
                                          />
                                          <p className="mb-0 yesNo">
                                            {/* Yes */}
                                            {t("Yes")}
                                          </p>
                                        </div>

                                        <div className="d-flex align-items-center gap-1 assignment_radio">
                                          <input
                                            type="radio"
                                            checked={insurance === false}
                                            style={{
                                              fontSize: "12px",
                                              width: "14px",
                                              height: "14px",
                                            }}
                                            // value={insurance}
                                            onChange={(e) => {
                                              // setInsurance(e.target.checked);
                                              setInsurance(false);
                                              setChangeComp(e.target.value);
                                            }}
                                          />
                                          <p className="mb-0 yesNo">
                                            {/* No */}
                                            {t("No")}
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {/* Discount start */}
                              <div
                                className="asc-input-container"
                                id="ascInput"
                              >
                                <label className="asc-label-top projectNameText">
                                  {/* Discount */}
                                  {t("Discount")}
                                </label>

                                <div
                                  className="clientInput ps-3"
                                  style={{ height: "50px" }}
                                >
                                  <input
                                    type="text"
                                    // placeholder="Select Discount"
                                    placeholder={t("Select Discount")}
                                    className="clientText bordered-inputs"
                                    readOnly
                                    // value={searchDiscountName}
                                    value={discountName}
                                    onClick={(e) => {
                                      setShowDiscountOption(true);
                                    }}
                                    onChange={(e) => {
                                      setSearchDiscountName(
                                        e.target.value.toLowerCase(),
                                      );
                                      setShowDiscountOption(true);
                                    }}
                                    onFocus={() => {
                                      if (discountName === "") {
                                        setShowDiscountOption(true);
                                      }
                                    }}
                                    // onMouseEnter={() => {
                                    //     setShowOptions(true);
                                    // }}
                                  />

                                  {discountName || showDiscountOption ? (
                                    <img
                                      src={Xicon}
                                      className="xicon pointer"
                                      alt=""
                                      onClick={() => {
                                        setSearchDiscountName("");
                                        setDiscountName("");
                                        setDiscountID("");
                                        setShowDiscountOption(false);
                                      }}
                                    />
                                  ) : (
                                    ""
                                  )}

                                  {/* <p className="pt-3 mb-1 billingAddress">
                                  {discountName}
                                </p> */}

                                  {showDiscountOption && (
                                    <div className="billingSelect_Outer h-auto w-100">
                                      <div className="billingTerms gap-4">
                                        <p className="mb-0 fw-bold">
                                          {/* Rent */}
                                          {t("Rent")}
                                        </p>
                                        <p className="mb-0 fw-bold ps-1">
                                          {/* Labor */}
                                          {t("Labor")}
                                        </p>
                                        <p className="mb-0 fw-bold ps-3">
                                          {/* Description */}
                                          {t("Description")}
                                        </p>
                                        <img
                                          src={XiconCircle}
                                          className="xicon pointer ms-auto"
                                          style={{
                                            width: "20px",
                                            height: "20px",
                                          }}
                                          alt=""
                                          onClick={() => {
                                            setShowDiscountOption(false);
                                          }}
                                        />
                                      </div>

                                      {discountData
                                        .filter((item) =>
                                          item.description
                                            ?.toLowerCase()
                                            .includes(searchDiscountName),
                                        )
                                        .map((item, index) => {
                                          return (
                                            <div
                                              key={index}
                                              className="billingRow"
                                              onClick={() => {
                                                setSearchDiscountName("");
                                                setDiscountName(
                                                  item.description,
                                                );
                                                setDiscountID(
                                                  item.discountTypeId,
                                                );
                                                setShowDiscountOption(false);
                                                setChangeComp("asc");
                                              }}
                                            >
                                              <div
                                                className={
                                                  discountID ===
                                                  item.discountTypeId
                                                    ? "mb-0 py-2 px-3 d-flex gap-5 billingSelected"
                                                    : "mb-0 py-2 px-3 d-flex gap-5"
                                                }
                                              >
                                                <p className="mb-0">
                                                  {item.rent}
                                                </p>
                                                <p className="mb-0">
                                                  {item.labour}
                                                </p>

                                                <p className="mb-0">
                                                  {item.description}
                                                  &nbsp;
                                                  {discountID ===
                                                    item.discountTypeId && (
                                                    <span>✔</span>
                                                  )}
                                                </p>
                                              </div>
                                            </div>
                                          );
                                        })}

                                      {discountData.filter((item) =>
                                        item.description
                                          ?.toLowerCase()
                                          .includes(searchDiscountName),
                                      ).length === 0 && (
                                        <span className="noDataDisplay">
                                          {/* No data to display! */}
                                          {t("No data to display!")}
                                        </span>
                                      )}
                                    </div>
                                  )}
                                </div>
                              </div>
                              {/* Discount end */}

                              <div
                                className="asc-input-container"
                                id="ascInput"
                              >
                                <label
                                  style={{
                                    marginTop: "6px",
                                  }}
                                  className="asc-label-top projectNameText"
                                >
                                  {/* Notes */}
                                  {t("Notes")}
                                </label>

                                <textarea
                                  style={{
                                    marginTop: "6px",
                                    height: "60px",
                                  }}
                                  id="w3review"
                                  name="w3review"
                                  rows="4"
                                  cols="50"
                                  // placeholder="Notes"
                                  className="notesInput ps-3 bordered-inputs"
                                  value={notes}
                                  onChange={(e) => {
                                    setNotes(e.target.value);
                                    setChangeComp(e.target.value);
                                  }}
                                ></textarea>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {activeHeading === "contactTab" && (
                      <div className="pt-2">
                        <div className="ascTableWrapper p-2">
                          <p className="contsLinked">
                            {/* Contacts linked */}
                            {t("Contacts linked")}
                          </p>

                          {path !== "/add-company" && (
                            <table className="table">
                              <thead>
                                <tr
                                  className="tableHeading"
                                  style={{
                                    color: "#333333",
                                    fontSize: "14px",
                                    fontWeight: "700",
                                    border: "none",
                                  }}
                                >
                                  <th style={{ width: "5%" }}></th>
                                  <th style={{ width: "30%" }}></th>
                                  <th style={{ width: "30%" }}></th>
                                  <th style={{ width: "5%" }}></th>
                                  {/* <th></th> */}
                                </tr>
                              </thead>

                              <tbody
                                className="tabLine"
                                style={{
                                  color: "#333333",
                                  fontSize: "14px",
                                  fontWeight: "400",
                                  border: "none",
                                }}
                              >
                                {contactsLinkData
                                  .slice(
                                    currentPage * perPage,
                                    (currentPage + 1) * perPage,
                                  )
                                  .map((item, index) => {
                                    console.log("asc43", item);
                                    return (
                                      <tr
                                        className="asc_Table_Hove-r"
                                        // title={item.clientname.length > 10 && item.clientname}
                                      >
                                        <td
                                          className="pointer"
                                          style={{ verticalAlign: "middle" }}
                                          onClick={() => {
                                            history.push(
                                              `/contactlist/edit-contact/${item?.contactId}`,
                                            );
                                          }}
                                        >
                                          {item.profileImage ? (
                                            <img
                                              className="linkedContactImage"
                                              src={item.profileImage}
                                              alt=""
                                            />
                                          ) : (
                                            <div className="linkedContactAbbr">
                                              {item.lastName
                                                ? item.fullName[0] +
                                                  "" +
                                                  item.lastName[0]
                                                : item.fullName?.slice(0, 2)}
                                            </div>
                                          )}
                                        </td>

                                        <td
                                          className="pointer"
                                          title={
                                            item?.fullName?.length > 10 &&
                                            item?.fullName
                                          }
                                          style={{
                                            // for 3 dots 👇
                                            // whiteSpace: "pre-wrap",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            maxWidth: "10px",
                                          }}
                                          onClick={() => {
                                            history.push(
                                              `/contactlist/edit-contact/${item?.contactId}`,
                                            );
                                          }}
                                        >
                                          <p
                                            className="mb-0"
                                            style={{
                                              // for 3 dots 👇
                                              // whiteSpace: "pre-wrap",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              maxWidth: "155px",
                                            }}
                                          >
                                            {item.fullName}
                                          </p>

                                          <p
                                            className="mb-0"
                                            style={{
                                              // for 3 dots 👇
                                              // whiteSpace: "pre-wrap",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              maxWidth: "155px",
                                            }}
                                          >
                                            {item.title || "—"}
                                          </p>
                                        </td>

                                        <td
                                          title={
                                            item?.email?.length > 10 &&
                                            item?.email
                                          }
                                          style={{
                                            // for 3 dots 👇
                                            // whiteSpace: "pre-wrap",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            maxWidth: "10px",
                                          }}
                                        >
                                          <p
                                            className="mb-0"
                                            style={{
                                              // for 3 dots 👇
                                              // whiteSpace: "pre-wrap",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              maxWidth: "155px",
                                            }}
                                          >
                                            {item.email}
                                          </p>

                                          <p
                                            className="mb-0"
                                            style={{
                                              // for 3 dots 👇
                                              // whiteSpace: "pre-wrap",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              maxWidth: "155px",
                                            }}
                                          >
                                            {item.phoneNo}
                                          </p>
                                        </td>

                                        <td className="text-end">
                                          <img
                                            className="pointer"
                                            style={{ verticalAlign: "middle" }}
                                            src={deleteIcon}
                                            alt=""
                                            onClick={() => {
                                              setLinkedContactsDelShow(true);
                                              setLinkedContactID(
                                                item.contactId,
                                              );
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    );
                                  })}
                                {contactsLinkData?.length === 0 && (
                                  <span className="noDataDisplay">
                                    {/* No data to display! */}
                                    {t("No data to display!")}
                                  </span>
                                )}
                              </tbody>
                            </table>
                          )}
                        </div>
                      </div>
                    )}

                    {activeHeading === "2" && (
                      <div // riya code start for Doc Drag and Drop
                        className={`doc-block drop-zone ${
                          isDragging ? "drop-zone-active" : ""
                        }`}
                        style={{ marginBottom: "1rem" }}
                        onDragOver={(e) => e.preventDefault()} // Prevent default to allow drop doc
                        onDrop={(e) => {
                          handleDrop(e);
                          setIsDragging(false); // Reset dragging state after doc drop
                        }}
                        onDragLeave={(e) => {
                          e.preventDefault();
                          setIsDragging(false); // Update state to remove doc drop zone visual feedback
                        }}
                        onDragEnter={() => setIsDragging(true)} // riya code end for Doc Drag and Drop
                      >
                        <div
                          className="doc-table-headings"
                          style={{ marginBottom: "1rem" }}
                        >
                          <p
                            className="doc-table-heading"
                            style={{
                              color: "#A5A5A5",
                              fontWeight: "500",
                              width: "60px",
                            }}
                          >
                            {/* Actions */}
                            {t("Actions")}
                          </p>
                          <p
                            className="doc-table-heading"
                            style={{ color: "#A5A5A5", fontWeight: "500" }}
                          >
                            {/* File title */}
                            {t("File title")}
                          </p>
                          <p
                            className="doc-table-heading ascHideForMobile HideForTablet"
                            style={{ color: "#A5A5A5", fontWeight: "500" }}
                          >
                            {/* Uploaded by */}
                            {t("Uploaded by")}
                          </p>
                          <p
                            className="doc-table-heading"
                            style={{ color: "#A5A5A5", fontWeight: "500" }}
                          >
                            {/* Date */}
                            {t("Date")}
                          </p>
                        </div>

                        {contactDocsList?.map((doc, index) => {
                          return (
                            <div // riya code start for Doc Drag and Drop
                              key={index}
                              className={`doc-table-headings cursor-pointer ${
                                isDragging ? "drop-zone-active" : ""
                              }`}
                              style={{ marginBottom: "8px" }} // riya code end for Doc Drag and Drop
                            >
                              <div
                                className="task-grid-lines"
                                style={{ opacity: "60%", width: "60px" }}
                              >
                                <RiDeleteBinLine
                                  style={{
                                    color: "black",
                                    fontSize: "1.3rem",
                                    curosor: "pointer",
                                  }}
                                  onClick={() => {
                                    setDeleteRowIndex(doc.documentid);
                                    setDeleteDocument(true);
                                  }}
                                />
                              </div>
                              <LightTooltip
                                // title={doc?.filename || doc?.documentname}

                                title={
                                  doc?.filename?.length > 30 ||
                                  doc?.documentname?.length > 30
                                    ? doc?.filename || doc?.documentname
                                    : ""
                                }
                                placement="top-start"
                              >
                                <div
                                  onMouseOver={() => {
                                    if (
                                      doc?.filename?.length > 30 ||
                                      doc?.documentname?.length > 30
                                    ) {
                                      setFulLenghtDocAddContact(true);
                                    }
                                  }}
                                  onMouseOut={() => {
                                    setFulLenghtDocAddContact(false);
                                  }}
                                  style={{ width: "14vw", cursor: "pointer" }}
                                  className="truncated-text1"
                                  onClick={(e) => {
                                    if (isUpdating) {
                                      handleDownloadContact(
                                        e,
                                        doc?.documentid,
                                        doc.filename,
                                      );
                                    }
                                  }}
                                >
                                  {" "}
                                  {doc?.filename || doc?.documentname}
                                </div>
                              </LightTooltip>

                              <p className="doc-table-heading table-content ascHideForMobile HideForTablet">
                                {doc?.uploadedby ||
                                  firstupname + " " + lastupname}
                              </p>
                              <p className="doc-table-heading table-content">
                                {moment(doc?.date).format("DD.MMM.YYYY")}

                                <EyeOutlined
                                  className="ms-3"
                                  onClick={() => {
                                    setFilePreview(
                                      getFilePreview({
                                        // file: file, // local upload file
                                        url: doc.link,
                                        type: doc.link.split(".").pop(),
                                        name: doc.documentname,
                                      }),
                                    );
                                  }}
                                />
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    )}

                    <FilePreviewModal
                      open={filePreview}
                      file={filePreview}
                      onClose={() => setFilePreview(null)}
                    />

                    {activeHeading === "3" && (
                      <div className="task-block">
                        {/* According to project start */}

                        <div className="projectAllTasks gap-2">
                          {/* <p className="mb-1">Active?</p> */}
                          <label htmlFor="asc_purch_Switch_2" className="">
                            {/* All */}
                            {t("All")}
                          </label>
                          <input
                            type="checkbox"
                            id="asc_purch_Switch_2"
                            className="asc_pursh_Checkbox"
                            // disabled={}
                            checked={allProjectTasks}
                            onChange={(e) => {
                              setAllProjectTasks(!allProjectTasks);
                              // if (isUpdating) {
                              //   if (allProjectTasks) {
                              //     dispatch(FetchClientTasks("", ""));
                              //   } else {
                              //     dispatch(FetchClientTasks(id, ""));
                              //   }
                              // }
                            }}
                          />
                          <label
                            htmlFor="asc_purch_Switch_2"
                            className="asc_purch_Toggle"
                          >
                            {/* <p className=''>ASC</p> */}
                          </label>
                        </div>

                        <div
                          className="asc-input-container"
                          id="ascInput"
                          style={{ bottom: "40px" }}
                        >
                          <label className="asc-label-top projectNameText">
                            {/* Projects */}
                            {t("Projetcs")}
                            {/* <span className="mandatory-sign">*</span> */}
                          </label>

                          <div
                            className="clientInput ps-3"
                            style={{
                              height: "50px",
                              // border: clientNameWarning
                              //   ? "0.5px solid red"
                              //   : "1px solid #70707080",
                            }}
                          >
                            <div
                              className="asc_Search_Box d-flex p-0"
                              style={{
                                border: "none",
                                width: "100%",
                                boxShadow: "none",
                              }}
                              ref={Project_Popup_Ref}
                            >
                              <p
                                className="asc_Client_Input_For_Long"
                                onClick={() => {
                                  setProjectShowOptions(!projectShowOptions);
                                  setArrowOptionsRotate3(!arrowOptionsRotate3);
                                }}
                              >
                                {projectName
                                  ? projectName
                                  : // "Select a Project"
                                    t("Select a Project")}

                                <br />
                                {/* <p className="clintAddress pt-2">
                                  {clientAddress}
                                </p> */}

                                {/* <p className="clintAddress">{clientCountry}</p> */}
                              </p>

                              {projectName ? (
                                <img
                                  src={Xicon}
                                  className="xicon pointer mt-2"
                                  alt=""
                                  onClick={() => {
                                    setSearchProjectName("");
                                    setProjectName("");
                                    setProjectid("");

                                    // setTypeInScreen("asc");
                                    setArrowOptionsRotate3(false);
                                    setAllProjectTasks(true);
                                    // setClientShowOptions(false);
                                    // setShowOptions(!showOptions);
                                  }}
                                />
                              ) : (
                                <img
                                  src={DownArrowOption}
                                  className={
                                    arrowOptionsRotate3
                                      ? "upArrow mt-1"
                                      : "downArrow mt-1"
                                  }
                                  alt=""
                                  onClick={() => {
                                    setProjectShowOptions(!projectShowOptions);
                                    setArrowOptionsRotate3(
                                      !arrowOptionsRotate3,
                                    );
                                  }}
                                />
                              )}

                              {projectShowOptions && (
                                <div
                                  className="asc_Custom_Select_Outer"
                                  style={{
                                    border: "none",
                                    left: "-17px",
                                    width: "104%",
                                  }}
                                >
                                  <section className="asc_Search_Icon_Search mx-2">
                                    <img
                                      src={searchicon}
                                      className="asc_searchicon"
                                      alt="Search Icon"
                                    />
                                    <input
                                      id="asc_input"
                                      className="asc_Search_Input"
                                      // placeholder="Search..."
                                      placeholder={t("Search")}
                                      value={searchProjectName}
                                      onChange={(e) =>
                                        setSearchProjectName(e.target.value)
                                      }
                                    />
                                  </section>

                                  <section
                                    className="asc_Search_List pt-0 p-3"
                                    id="ascSelectBox"
                                  >
                                    {projectData
                                      .filter(
                                        (item) =>
                                          item.projectname
                                            ?.toLowerCase()
                                            .includes(
                                              searchProjectName.toLowerCase(),
                                            ) ||
                                          item.projectcode
                                            ?.toLowerCase()
                                            .includes(
                                              searchProjectName.toLowerCase(),
                                            ),
                                      )
                                      .map((item, index) => {
                                        return (
                                          <div
                                            key={index}
                                            className=""
                                            onClick={() => {
                                              setSearchProjectName("");
                                              setProjectName(item.projectname);
                                              setProjectid(item.projectid);
                                              setArrowOptionsRotate3(false);
                                              setProjectShowOptions(false);
                                              setAllProjectTasks(false);
                                              // setTypeInScreen("asc");

                                              if (isUpdating) {
                                                dispatch(
                                                  FetchClientTasks(
                                                    id,
                                                    item.projectid,
                                                  ),
                                                );
                                              }
                                            }}
                                          >
                                            <p
                                              className={
                                                projectid === item.projectid
                                                  ? "asc_Selected_Item ps-3"
                                                  : "ps-3"
                                              }
                                            >
                                              {item?.projectcode}&nbsp;┃&nbsp;
                                              {/* {item.projectname} */}
                                              {item.projectname.length > 25
                                                ? item.projectname.slice(
                                                    0,
                                                    25,
                                                  ) + "..."
                                                : item.projectname}
                                            </p>
                                          </div>
                                        );
                                      })}
                                    {/* Display a message when no projects are found */}
                                    {projectData.length > 0 &&
                                      projectData.filter((item) =>
                                        item.projectname
                                          ?.toLowerCase()
                                          .includes(
                                            searchProjectName.toLowerCase(),
                                          ),
                                      ).length === 0 && (
                                        <span>No projects found!</span>
                                      )}

                                    {/* Display a message when no data to display */}
                                    {projectData.length === 0 && (
                                      <span className="noDataDisplay">
                                        {/* No data to display! */}
                                        {t("No data to display!")}
                                      </span>
                                    )}
                                  </section>
                                  {/* for button start*/}
                                  <button
                                    className="makeInvoBtn w-50 my-4 d-none"
                                    style={{ marginLeft: "25%" }}
                                    onClick={() => {
                                      history.push("/addProject", "/project");
                                    }}
                                  >
                                    Create a Project
                                  </button>
                                  {/* for button end*/}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* According to project end */}
                        <div
                          className="task-table-grid3"
                          style={{
                            gridTemplateColumns: "15% 30% 33% 18%",
                          }}
                        >
                          <div className="task-grid-lines-heading">
                            {t("Actions")}
                          </div>
                          <div className="task-grid-lines-heading">
                            {t("Task Name")}
                          </div>
                          <div className="task-grid-lines-heading">
                            {t("Deadline")}
                          </div>

                          <div className="task-grid-lines-heading ascHideForMobile HideForTablet">
                            {t("Complete?")}
                          </div>
                        </div>

                        {companyTasks?.map((task) => {
                          return (
                            <div className="task-table-grid3" key={task.taskid}>
                              <div
                                // className="task-grid-lines"
                                className={
                                  roleAccess === process.env.REACT_APP_IS_VIEWER
                                    ? "pointerEvent task-grid-lines"
                                    : "task-grid-lines pointer"
                                }
                                style={{ opacity: "60%" }}
                              >
                                <RiDeleteBinLine
                                  style={{
                                    color: "black",
                                    fontSize: "1.3rem",
                                    curosor: "pointer",
                                  }}
                                  onClick={() => {
                                    // dispatch(deleteTask(task.taskId));
                                    setShowPopup(true);
                                    setTaskIdforDelete(task.taskId);
                                  }}
                                />
                              </div>
                              <div
                                className="task-grid-lines task-main-line pointer"
                                onClick={() =>
                                  handleOpenUpdateTaskPopup(task.taskId)
                                }
                              >
                                {task.taskname || task.taskName}
                              </div>
                              <div
                                className="task-grid-lines task-main-line pointer"
                                onClick={() =>
                                  handleOpenUpdateTaskPopup(task.taskId)
                                }
                              >
                                {moment(task.deadline).format("DD.MM.YYYY")}
                              </div>
                              <div
                                className="task-grid-lines task-main-line pointer"
                                onClick={() =>
                                  handleOpenUpdateTaskPopup(task.taskId)
                                }
                              >
                                {`${
                                  task?.deadline?.split("T")[1].split(":")[0]
                                }:${
                                  task?.deadline?.split("T")[1].split(":")[1]
                                }`}
                              </div>
                              <div
                                className="task-grid-lines ascHideForMobile HideForTablet"
                                style={{ opacity: "1" }}
                              >
                                <input
                                  type="checkbox"
                                  id={`switchToggle${task.taskId}`}
                                  className="checkbox"
                                  checked={
                                    task?.taskStatus === "Complete" ||
                                    task?.taskStatus === "Completed"
                                      ? true
                                      : false
                                  }
                                  // checked={task.isCompleted}
                                  onChange={() =>
                                    dispatch(
                                      updateTaskStatus2(
                                        companyids,
                                        task.taskId,
                                      ),
                                    )
                                  }
                                />
                                <label
                                  htmlFor={`switchToggle${task.taskId}`}
                                  className="toggle"
                                >
                                  {/* <p className='text-center mt-2 textClrSign'></p> */}
                                </label>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {activeHeading === "4" && (
                      // emails?[0].email || ""
                      <div>
                        <div>
                          {emailSource === "gmail" ? (
                            <ContactEmails
                              fromEmail={
                                Boolean(emails) &&
                                Array.isArray(emails) &&
                                emails.length > 0
                                  ? emails[0].email
                                  : ""
                              }
                              emailSource={emailSource}
                              setEmailSource={setEmailSource}
                            />
                          ) : (
                            <OutlookContactEmails
                              fromEmail={
                                Boolean(emails) &&
                                Array.isArray(emails) &&
                                emails.length > 0
                                  ? emails[0].email
                                  : ""
                              }
                              emailSource={emailSource}
                              setEmailSource={setEmailSource}
                            />
                          )}
                        </div>
                      </div>
                    )}

                    {activeHeading === "5" && (
                      <div className="task-table-grid2">
                        <div className="task-grid-lines"></div>
                        <div className="task-grid-lines">{t("Subject")}</div>
                        <div className="task-grid-lines">{t("Date")}</div>
                        <div className="task-grid-lines"></div>
                      </div>
                    )}

                    {/* {activeHeading === "4" && <div>Emails</div>} */}
                    {/* {activeHeading === "5" && <div>Events</div>} */}

                    <div className="d-none">
                      <Pagination
                        perPage={perPage}
                        setPerPage={setPerPage}
                        currentPage={currentPage}
                        setCurrentPage={setCurrentPage}
                        totalPages={totalPages}
                      />
                    </div>
                  </div>
                </>
              ) : (
                // <ContactTaskBlock
                //   Image3={Image3}
                //   primaryColor={primaryColor}
                //   AiOutlineCloseCircle={AiOutlineCloseCircle}
                //   setShowPriorityDrop={setShowPriorityDrop}
                //   setPriorityName={setPriorityName}
                //   setPriorityId={setPriorityId}
                //   priorityName={priorityName}
                //   priorityData={priorityData}
                //   showPriorityDrop={showPriorityDrop}
                //   setStatusName={setStatusName}
                //   setStatusId={setStatusId}
                //   BsChevronDown={BsChevronDown}
                //   statusData={statusData}
                //   showStatusDrop={showStatusDrop}
                //   setShowStatusDrop={setShowStatusDrop}
                //   setShowNotiDropDown={setShowNotiDropDown}
                //   setNotiTime={setNotiTime}
                //   notificationTimes={notificationTimes}
                //   showNotiDropDown={showNotiDropDown}
                //   setNMinutes={setNMinutes}
                //   nminutes={nminutes}
                //   NotiBell={NotiBell}
                //   Clock={Clock}
                //   setMinutes={setMinutes}
                //   minutes={minutes}
                //   setHours={setHours}
                //   hours={hours}
                //   TaskCardCalendar={TaskCardCalendar}
                //   dueDate={dueDate}
                //   setDueDate={setDueDate}
                //   DatePicker={DatePicker}
                //   Wrapper={Wrapper}
                //   AssigneeIcon={AssigneeIcon}
                //   setShowDropPeople={setShowDropPeople}
                //   setAssigneeIdMain={setAssigneeIdMain}
                //   setAssignee={setAssignee}
                //   docPeopleList={docPeopleList}
                //   setSearchPeople={setSearchPeople}
                //   searchPeople={searchPeople}
                //   FiSearch={FiSearch}
                //   showDropPeople={showDropPeople}
                //   assignee={assignee}
                //   setDescription={setDescription}
                //   description={description}
                //   setTaskName={setTaskName}
                //   taskName={taskName}
                //   setDocAdded={setDocAdded}
                //   setShowTaskColumn={setShowTaskColumn}
                //   notiTime={notiTime}
                //   statusName={statusName}
                // />
                <div></div>
              )}
            </>
          ) : (
            <div className="column-2-info">
              <div
                className="doc-heading"
                style={{ margin: "2rem auto 0 auto" }}
              >
                <div>
                  <img
                    style={{
                      width: "20px",
                      height: "20px",
                      marginRight: "0.25rem",
                    }}
                  />
                  <span
                    className="doc-heading-bold"
                    style={{ color: `${primaryColor}` }}
                  >
                    new DOc
                  </span>
                </div>
                <div>
                  <AiOutlineCloseCircle
                    style={{
                      fontSize: "1.4rem",
                      color: "#707070",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      setDocAdded(false);
                      setShowTaskColumn(false);
                    }}
                  />
                </div>
              </div>
              <div className="upload-new-doc">
                <AiFillPlusCircle
                  style={{
                    color: `${primaryColor}`,
                    cursor: "pointer",
                    fontSize: "var(--responsive-font-18)",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    selectDoc.current.click();
                  }}
                />
                <input
                  type="file"
                  accept=".doc,.pdf,.xls,.xlsx,.docx,.xml,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  name="doc"
                  id="doc"
                  style={{ display: "none" }}
                  ref={selectDoc}
                />
                <span
                  className="text-heading-styles"
                  style={{ fontSize: "14px" }}
                >
                  Upload a new Doc
                </span>
                <div className="underline-contact"></div>
                <p style={{ margin: "1rem 0 0 0" }}>{fileName}</p>
                <div className="lock-round"></div>
                <span className="manage-text">Manage Access</span>
              </div>
              <div className="general-access">
                <p className="view-edit" style={{ marginBottom: "2rem" }}>
                  General Access to view & edit
                </p>
                <div
                  className="roles-options roles-options-contact"
                  style={{
                    width: "100%",
                    display: "grid",
                    gridTemplateColumns: "repeat(4,1fr)",
                  }}
                >
                  <p
                    style={
                      roleId === "08da3f0d-0371-4dd3-8c86-e51222d56198"
                        ? {
                            backgroundColor: `${primaryColor}`,
                            fontSize: "18px",
                          }
                        : { backgroundColor: `#FFFFFF`, fontSize: "16px" }
                    }
                    className={
                      roleId === "08da3f0d-0371-4dd3-8c86-e51222d56198"
                        ? "role-single authorisation-roles active-role active-main"
                        : "role-single authorisation-roles "
                    }
                  >
                    owner
                  </p>
                  <p
                    style={
                      roleId === "08da3f0d-0371-4dd3-8c86-e51222d56199"
                        ? {
                            backgroundColor: `${primaryColor}`,
                            fontSize: "18px",
                          }
                        : { backgroundColor: ``, fontSize: "16px" }
                    }
                    className={
                      roleId === "08da3f0d-0371-4dd3-8c86-e51222d56199"
                        ? "role-single authorisation-roles active-role active-main"
                        : "role-single authorisation-roles "
                    }
                  >
                    manager
                  </p>
                  <p
                    style={
                      roleId === "08da3f0d-0371-4dd3-8c86-e51222d56200"
                        ? {
                            backgroundColor: `${primaryColor}`,
                            fontSize: "18px",
                          }
                        : { backgroundColor: ``, fontSize: "16px" }
                    }
                    className={
                      roleId === "08da3f0d-0371-4dd3-8c86-e51222d56200"
                        ? "role-single authorisation-roles active-role active-main"
                        : "role-single authorisation-roles "
                    }
                  >
                    user
                  </p>
                  <p
                    style={
                      roleId === "08da3f0d-0371-4dd3-8c86-e51222d56201"
                        ? {
                            backgroundColor: `${primaryColor}`,
                            fontSize: "18px",
                          }
                        : { backgroundColor: ``, fontSize: "16px" }
                    }
                    className={
                      roleId === "08da3f0d-0371-4dd3-8c86-e51222d56201"
                        ? "role-single authorisation-roles active-role active-main"
                        : "role-single authorisation-roles "
                    }
                  >
                    freelancer
                  </p>
                </div>
              </div>
              <div className="people-access general-access">
                <p className="view-edit">People with access</p>
                {docAccessList?.map((access, index) => {
                  return (
                    <div className="people-owner-flex" key={index}>
                      <div className="image-name-flex">
                        <img
                          src={access?.photo}
                          style={{ width: "35px", height: "35px" }}
                        />
                        <span className="name-flex">
                          <span>{access?.username}</span>
                          <span className="text-heading-styles">
                            {companyId ===
                              "28830f30-b321-4662-a576-f23451677733" &&
                              "Corporat Booking Desk"}
                            {companyId ===
                              "28830f30-b321-4662-a576-f23451677744" &&
                              "ZUID BEHEER"}
                            {companyId ===
                              "28830f30-b321-4662-a576-f23451677755" &&
                              "Residence 32"}
                          </span>
                        </span>
                      </div>
                      <div>
                        <select
                          key={index}
                          style={{ fontsize: "14px", width: "8rem" }}
                          className="input-style add-contact-input-style"
                          name="accesslevelid"
                          id="accesslevelid"
                          value={access.accesslevelid}
                          required
                        >
                          <option
                            value="08da33e9-5a64-4f8c-8d88-49e4982df321"
                            name="08da33e9-5a64-4f8c-8d88-49e4982df321"
                          >
                            View
                          </option>
                          <option
                            value="08da33e9-5a64-4f8c-8d88-49e4982df320"
                            name="08da33e9-5a64-4f8c-8d88-49e4982df320"
                          >
                            Edit
                          </option>
                          <option
                            value="08da33e9-5a64-4f8c-8d88-49e4982df323"
                            name="08da33e9-5a64-4f8c-8d88-49e4982df323"
                          >
                            Owner
                          </option>
                          <option
                            value="08da33e9-5a64-4f8c-8d88-49e4982df322"
                            name="08da33e9-5a64-4f8c-8d88-49e4982df322"
                          >
                            NA
                          </option>
                        </select>
                      </div>
                    </div>
                  );
                })}
                <div className="plus-icon-function">
                  <div className="plus-icon">
                    <AiOutlinePlus
                      onClick={() => setShowDropPeople(!showDropPeople)}
                      style={{
                        fontSize: "1.5rem",
                        marginTop: "4px",
                        color: "#A7A7A7",
                        cursor: "pointer",
                      }}
                    />
                  </div>
                  {showDropPeople && (
                    <div className="drop-down-plus" id="drop-down-plus">
                      <div className="search-div-people">
                        <input
                          type="text"
                          style={
                            searchPeople
                              ? { opacity: "100%" }
                              : { opacity: "50%" }
                          }
                          className="search-people-input"
                          // placeholder="Search"
                          placeholder={t("Search")}
                          value={searchPeople}
                          onChange={(e) => {
                            setSearchPeople(e.target.value);
                          }}
                        />
                      </div>
                      {docPeopleList?.map((people, index) => {
                        const singlePeople = people.userdetails[0];
                        return (
                          <div key={index} className="peoples-flex">
                            <img
                              src={singlePeople.imageurl}
                              style={{ width: "30px", height: "30px" }}
                            />
                            <p style={{ marginBottom: "0" }}>
                              {singlePeople.firstname} {singlePeople.lastname}
                            </p>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
          <div
            className={
              isUpdating
                ? "column-3-info ascHideForMobile"
                : "column-3-information ascHideForMobile"
            }
          >
            <div className="timeline-main-div" ref={refActivityTimelineDD}>
              <div className="heading-filter">
                <p className="activity-text" style={{ color: "#333333" }}>
                  {t("Activity Timeline")}
                </p>
                <img
                  src={actfilter}
                  alt="filter"
                  width="18px"
                  height="16px"
                  onClick={() => setFilterDrop(true)}
                  style={{
                    cursor: "pointer",
                  }}
                  className="responsive-check"
                />
                {/* <BiSliderAlt
                  onClick={() => setFilterDrop(true)}
                  style={{
                    // fontSize: "1.6rem",
                    color: `${primaryColor}`,
                    cursor: "pointer",
                  }}
                  className="responsive-check"
                /> */}
                {filterDrop && (
                  <div className="filter-drop">
                    <div
                      style={{
                        textAlign: "end",
                        marginRight: "0.9rem",
                        marginTop: "1rem",
                      }}
                    >
                      <AiOutlineCloseCircle
                        onClick={() => setFilterDrop(false)}
                        style={{
                          // fontSize: "1.25rem",
                          // color: "#707070",
                          cursor: "pointer",
                          fontSize: "23px",
                          color: "#a5a5a5",
                        }}
                      />
                    </div>
                    <div className="drop-option-grid">
                      {/* <SVGInformation className="responsive-check" /> */}
                      <img
                        src={actinfoblack}
                        className="responsive-check"
                        alt="mail"
                      />
                      <span>{t("Information")}</span>

                      <Radio
                        checked={selectedValue === "information"}
                        onChange={handleChange}
                        value="information"
                        name="radio-buttons"
                        inputProps={{ "aria-label": "A" }}
                        checkedIcon={<BpCheckedIcon />}
                        icon={<BpIcon />}
                        size="small"
                        disableRipple={true}
                        disableFocusRipple={true}
                        sx={{
                          ":hover": {
                            backgroundColor: "transparent",
                          },
                        }}
                      />
                      {/* <SVGDocuments className="responsive-check" /> */}
                      <img
                        src={actfold}
                        className="responsive-check"
                        alt="mail"
                        height="19px"
                        width="21px"
                      />
                      <span>{t("Documents")}</span>
                      <Radio
                        checked={selectedValue === "docs"}
                        onChange={handleChange}
                        value="docs"
                        name="radio-buttons"
                        inputProps={{ "aria-label": "A" }}
                        checkedIcon={<BpCheckedIcon />}
                        icon={<BpIcon />}
                        size="small"
                        disableRipple={true}
                        disableFocusRipple={true}
                        sx={{
                          ":hover": {
                            backgroundColor: "transparent",
                          },
                        }}
                        // {...props}
                      />
                      {/* <SVGTasks className="responsive-check" /> */}
                      <img
                        src={actclip}
                        className="responsive-check"
                        alt="mail"
                        height="22px"
                        width="18px"
                      />
                      <span>{t("Tasks")}</span>
                      <Radio
                        checked={selectedValue === "tasks"}
                        onChange={handleChange}
                        value="tasks"
                        name="radio-buttons"
                        inputProps={{ "aria-label": "A" }}
                        size="small"
                        disableRipple={true}
                        checkedIcon={<BpCheckedIcon />}
                        icon={<BpIcon />}
                        disableFocusRipple={true}
                        sx={{
                          ":hover": {
                            backgroundColor: "transparent",
                          },
                        }}
                      />
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        className="reset-btn"
                        onClick={() => handleChange({ target: { value: "" } })}
                      >
                        {t("Reset default")}
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="timeline-div" id="ascSelectBox">
                {/* {activityLogs.length === 0 && (
                  <div
                    key={"no-data"}
                    className="d-flex  timeline-container"
                    style={{
                      "--themeColor": primaryColor,
                      overflow: auto,
                      minHeight: "600px",
                      maxHeight: "1000px",
                    }}
                  >
                    <div className="activity-icon"></div>
                    <div className="message-container">
                      <div className="d-flex flex-column message-box empty">
                        <div className="activity-message"></div>
                        <div className="activity-time"></div>
                      </div>
                    </div>
                  </div>
                )} */}

                {/* {activityLogs.map((Log, index) => {
                  return (
                    <div
                      key={index}
                      className="d-flex align-items-center timeline-container"
                      style={{ "--themeColor": primaryColor }}
                    >
                      <div className="activity-icon">{Log.Icon}</div>
                      <div className="message-container">
                        <div className="d-flex flex-column message-box">
                          {showFullContent && showIndexContent === index ? (
                            <div
                              className="activity-message"
                              onClick={() => {
                                setShowFullContent(!showFullContent);
                              }}
                            >
                              {Log.message}
                            </div>
                          ) : (
                            <div
                              className="activity-message"
                              onClick={() => {
                                setShowIndexContent(index);
                                setShowFullContent(!showFullContent);
                              }}
                            >
                              {" "}
                              {Log.message.slice(0, 80)}
                              {Log.message.length > 80 && "..."}
                            </div>
                          )}
                          <div className="activity-time">{Log.time}</div>
                        </div>
                      </div>
                    </div>
                  );
                })} */}

                {/* New TimeLine */}
                {activityTimeLine.map((Log, index) => {
                  return (
                    <div
                      key={index}
                      className="d-flex align-items-center timeline-container"
                      style={{ "--themeColor": primaryColor }}
                    >
                      {/* <div className="activity-icon">{Log.Icon}</div> */}
                      <div className="activity-icon">
                        <img src={actinfo} alt="" />
                      </div>
                      <div className="message-container">
                        <div className="d-flex flex-column message-box">
                          {showFullContent && showIndexContent === index ? (
                            <div
                              className="activity-message"
                              onClick={() => {
                                setShowFullContent(!showFullContent);
                              }}
                            >
                              {Log.activityDescription}
                            </div>
                          ) : (
                            <div
                              className="activity-message"
                              onClick={() => {
                                setShowIndexContent(index);
                                setShowFullContent(!showFullContent);
                              }}
                            >
                              {" "}
                              {Log.activityDescription.slice(0, 80)}
                              {Log.activityDescription.length > 80 && "..."}
                            </div>
                          )}
                          {/* <div className="activity-time">{Log.createDate}</div> */}
                          <div className="activity-time">
                            {moment(Log.createDate).format("DD-MM-YYYY")}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          {/* add button for mobile view start */}
          <Row style={{ position: "static", bottom: "12px" }}>
            <Col
              xs={6}
              xl={6}
              lg={6}
              md={6}
              sm={6}
              className="add-col-item d-none upperADD_CancelBtnShoeHide_Mobile"
              style={{ position: "relative" }}
            >
              <div
                className="d-flex cancel_cont_btn ms-4"
                onClick={() => {
                  handelCancel();
                }}
                style={{ borderRadius: "12px" }}
              >
                <p className="fw-bold mb-0" style={{ color: "#5b5b5b" }}>
                  {/* cancel */}
                  {t("Cancel")}
                </p>
              </div>
            </Col>
            <Col
              xs={6}
              xl={6}
              lg={6}
              md={6}
              sm={6}
              className="d-none upperADD_CancelBtnShoeHide_Mobile"
            >
              {removeaddbtn ? (
                <div
                  className="d-flex add-buttons ms-4"
                  style={{
                    borderRadius: "12px",
                    pointerEvents:
                      existingCompanyAddressRes?.status === true ||
                      isValueExists
                        ? "none"
                        : "",
                  }}
                  // onClick={handleContactAdd}
                  onClick={() => {
                    if (path === "/add-company") {
                      companyName !== "" && setAddContactWarning(true);
                    } else {
                      handleContactAdd();
                    }
                  }}
                >
                  <p className="fw-bold mb-0">
                    {isUpdating
                      ? // ? "Confirm"
                        t("Confirm")
                      : t("Add ")}
                  </p>
                </div>
              ) : (
                <div
                  className="d-flex add-buttons ms-4"
                  style={{
                    borderRadius: "12px",
                    pointerEvents:
                      existingCompanyAddressRes?.status === true ||
                      isValueExists
                        ? "none"
                        : "",
                  }}
                  // onClick={handleContactAdd}
                  onClick={() => {
                    if (path === "/add-company") {
                      companyName !== "" && setAddContactWarning(true);
                    } else {
                      handleContactAdd();
                    }
                  }}
                >
                  <p className="fw-bold mb-0">
                    {isUpdating
                      ? // ? "Confirm"
                        t("Confirm")
                      : t("Add ")}
                  </p>
                </div>
              )}
            </Col>
          </Row>
          {/* add button for mobile view end */}
        </section>
      </section>
      {/* {popups && (
        <Modal
          show={popups}
          // onHide={handleClose}
          // setpop={setPopups}
          className="modelwidth1"
          style={{
            backgroundColor: "transparent",
            opacity: 0.9,
            // display: "block"
          }}
        >
          <Modal.Body>
            <div className="flex_class my-5">
              <div className="text-danger">
                {FetchTranslationList[57]?.translation}
              </div>

              <div className=" mt-3">
                {" "}
                {FetchTranslationList[58]?.translation}
              </div>

              <div className="mt-5 ">
                <button
                  className="me-2 w-25 btn-no"
                  onClick={() => {
                    setPopups(false);
                    // window.location.reload();
                  }}
                >
                  {FetchTranslationList[59]?.translation}
                </button>
                <button
                  className="ms-2 w-25 btn-yes"
                  onClick={() => {
                    // setPopups(false);
                    history.push("/contact-list");
                    window.localStorage.removeItem("clientaddname");
                    window.localStorage.removeItem("clientId2");
                    window.localStorage.removeItem("_tmpCon");
                  }}
                >
                  {FetchTranslationList[60]?.translation}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )} */}

      {deleteModalShow && (
        <DeletePopUp
          animation={true}
          handleDelete={handleDeleteFun}
          show={deleteModalShow}
          onHide={() => setDeleteModalShow(false)}
          title1={"This data will be removed from the system"}
          title2={"and cannot be undone."}
          title3={"Do you want to proceed?"}
          no={t("No")}
          yes={t("Yes")}
        />
      )}

      {deleteDocument && (
        <DeletePopUp
          animation={true}
          handleDelete={handleDeleteDocumentFun}
          show={deleteDocument}
          onHide={() => setDeleteDocument(false)}
          title1={"This data will be removed from the system"}
          title2={"and cannot be undone."}
          title3={"Do you want to proceed?"}
          no={t("No")}
          yes={t("Yes")}
        />
      )}

      {linkedContactsDelShow && (
        <DeletePopUp
          animation={true}
          handleDelete={handleDeleteLinkedConact}
          show={linkedContactsDelShow}
          onHide={() => setLinkedContactsDelShow(false)}
          title1={"This data will be removed from the system"}
          title2={"and cannot be undone."}
          title3={"Do you want to proceed?"}
          no={t("No")}
          yes={t("Yes")}
        />
      )}

      {/* </ThemeProvider> */}
    </>
  );
};

export default AddContacts;
